/* eslint-disable */
// Code generated by graphql-codegen. DO NOT EDIT.
import * as scalars from "~/lib/graphql/scalars"
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** 宿泊施設の 一休.com ID */
  AccommodationId: { input: scalars.AccommodationId; output: scalars.AccommodationId; }
  AffiliateSiteId: { input: scalars.AffiliateSiteId; output: scalars.AffiliateSiteId; }
  CancelPolicyId: { input: scalars.CancelPolicyId; output: scalars.CancelPolicyId; }
  ChildMenuId: { input: scalars.ChildMenuId; output: scalars.ChildMenuId; }
  CityId: { input: scalars.CityId; output: scalars.CityId; }
  CourseId: { input: scalars.CourseId; output: scalars.CourseId; }
  Date: { input: scalars.DateText; output: scalars.DateText; }
  DateTime: { input: scalars.DateTime; output: scalars.DateTime; }
  DiscountCouponCode: { input: scalars.DiscountCouponCode; output: scalars.DiscountCouponCode; }
  GenreCode: { input: scalars.GenreCode; output: scalars.GenreCode; }
  HourMinute: { input: scalars.HourMinute; output: scalars.HourMinute; }
  HtmlFragment: { input: scalars.HtmlFragment; output: scalars.HtmlFragment; }
  KiwaminoArticleId: { input: scalars.KiwaminoArticleId; output: scalars.KiwaminoArticleId; }
  LargeAreaCode: { input: scalars.LargeAreaCode; output: scalars.LargeAreaCode; }
  MediumAreaCode: { input: scalars.MediumAreaCode; output: scalars.MediumAreaCode; }
  MinimumAreaCode: { input: scalars.MinimumAreaCode; output: scalars.MinimumAreaCode; }
  OptionMenuId: { input: scalars.OptionMenuId; output: scalars.OptionMenuId; }
  PaymentCardId: { input: scalars.PaymentCardId; output: scalars.PaymentCardId; }
  PlanId: { input: scalars.PlanId; output: scalars.PlanId; }
  PointRewardProgramId: { input: scalars.PointRewardProgramId; output: scalars.PointRewardProgramId; }
  PointRewardSettingId: { input: scalars.PointRewardSettingId; output: scalars.PointRewardSettingId; }
  ReservationId: { input: scalars.ReservationId; output: scalars.ReservationId; }
  RestaurantId: { input: scalars.RestaurantId; output: scalars.RestaurantId; }
  RestaurantTagId: { input: scalars.RestaurantTagId; output: scalars.RestaurantTagId; }
  SeatId: { input: scalars.SeatId; output: scalars.SeatId; }
  SmallAreaCode: { input: scalars.SmallAreaCode; output: scalars.SmallAreaCode; }
  SpecialFeatureId: { input: scalars.SpecialFeatureId; output: scalars.SpecialFeatureId; }
  SpecialId: { input: scalars.SpecialId; output: scalars.SpecialId; }
  SpotId: { input: scalars.SpotId; output: scalars.SpotId; }
  TimesaleId: { input: scalars.TimesaleId; output: scalars.TimesaleId; }
  TownId: { input: scalars.TownId; output: scalars.TownId; }
};

/** 宿泊施設 */
export type Accommodation = {
  /** 宿泊施設の 一休.com ID */
  accommodationId: Scalars['AccommodationId']['output'];
  /** 宿泊施設名 */
  name: Scalars['String']['output'];
};

export type AcquireDiscountCouponError =
  /** クーポンが獲得済み */
  | 'ALREADY_ACQUIRED'
  | 'LOGIN_REQUIRED'
  /** クーポンが利用できない */
  | 'NOT_AVAILABLE'
  /** クーポンが見つからない */
  | 'NOT_FOUND';

export type AffiliateSite = {
  affiliateSiteId: Scalars['AffiliateSiteId']['output'];
  logo: Scalars['Boolean']['output'];
};

export type AffiliateSiteForm = {
  notes: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** 利用可否 */
export type Availability =
  /** 利用可 */
  | 'AVAILABLE'
  /** 利用不可 */
  | 'UNAVAILABLE'
  /** 不明 */
  | 'UNKNOWN';

export type CalendarDate = {
  date: Scalars['Date']['output'];
  /** 曜日 */
  dayOfWeek: DayOfWeek;
  holiday: Scalars['Boolean']['output'];
};

export type CancelPolicy = {
  cancelPolicyId: Scalars['CancelPolicyId']['output'];
  note: Scalars['String']['output'];
  policies: Array<CancelPolicyItem>;
  version: Scalars['Int']['output'];
};

export type CancelPolicyCharge = CancelPolicyChargeFee | CancelPolicyChargeRate;

export type CancelPolicyChargeFee = {
  fee: Scalars['Int']['output'];
};

export type CancelPolicyChargeRate = {
  rate: Scalars['Int']['output'];
};

export type CancelPolicyItem = {
  appliesToVisitorDecrement: Scalars['Boolean']['output'];
  charge: CancelPolicyCharge;
};

export type CancelPolicyItemDaysBefore = CancelPolicyItem & {
  appliesToVisitorDecrement: Scalars['Boolean']['output'];
  charge: CancelPolicyCharge;
  days: Scalars['Int']['output'];
  time: Maybe<Scalars['HourMinute']['output']>;
};

export type CancelPolicyItemNoShow = CancelPolicyItem & {
  appliesToVisitorDecrement: Scalars['Boolean']['output'];
  charge: CancelPolicyCharge;
};

export type CancelPolicyItemOnTheDay = CancelPolicyItem & {
  appliesToVisitorDecrement: Scalars['Boolean']['output'];
  charge: CancelPolicyCharge;
};

export type CancelPolicyStructured = {
  cancelPolicyId: Scalars['CancelPolicyId']['output'];
  note: Scalars['String']['output'];
  policies: Array<CancelPolicyItem>;
  version: Scalars['Int']['output'];
};

export type CancelPolicyText = {
  text: Scalars['String']['output'];
};

export type CardPayment = {
  availability: Availability;
  note: Scalars['String']['output'];
};

export type ChildAvailability = ChildAvailable | ChildUnavailable;

export type ChildAvailable = {
  ageLimit: LimitType;
  chairAvailability: Availability;
  menuAvailability: Availability;
  note: Scalars['String']['output'];
  /** 個室のみ子供席可 といった場合に「制限あり」となる */
  seatLimit: LimitType;
  timeAvailability: ChildTimeAvailability;
};

export type ChildMenu = {
  childMenuId: Scalars['ChildMenuId']['output'];
  /** 来店日の2日前まで予約可能な場合、2 を返す */
  closeDays: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  image: Maybe<Image>;
  maxOrderPerReservation: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  visitingPeriodFrom: Maybe<Scalars['Date']['output']>;
  visitingPeriodTo: Maybe<Scalars['Date']['output']>;
};

/** 子供利用可能時間帯 */
export type ChildTimeAvailability =
  /** 全時間帯可 */
  | 'ALL_TIME'
  /** ディナーのみ可 */
  | 'DINNER_ONLY'
  /** ランチのみ可 */
  | 'LUNCH_ONLY'
  /** 不明 */
  | 'UNKNOWN';

export type ChildUnavailable = {
  note: Scalars['String']['output'];
};

/** 子供利用区分 */
export type ChildUse =
  /** 小学生利用可 */
  | 'GRADE_SCHOOLERS'
  /** 中学生以上利用可 */
  | 'OVER_MIDDLE_SCHOOLERS'
  /** 未就学児利用可 */
  | 'PRE_SCHOOLERS';

export type Course = Node & {
  courseId: Scalars['CourseId']['output'];
  id: Scalars['ID']['output'];
  images: Array<Image>;
  menuText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: Maybe<Plan>;
  restaurant: Restaurant;
  searchPlans: PlanSearchResultConnection;
  type: CourseType;
};


export type CoursePlanArgs = {
  planId: Scalars['PlanId']['input'];
};


export type CourseSearchPlansArgs = {
  input: SearchInput;
};

export type CourseConnection = {
  /** A list of edges. */
  edges: Array<CourseEdge>;
  /** A list of nodes. */
  nodes: Array<Course>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CourseEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Course;
};

export type CourseType = CourseTypeIkyu | CourseTypeOfficial;

export type CourseTypeIkyu = {
  dummy: Scalars['Boolean']['output'];
};

export type CourseTypeOfficial = {
  price: Scalars['Int']['output'];
};

export type DateTimePeriod = {
  from: Scalars['DateTime']['output'];
  /** 開区間か閉区間かはフィールドによるので注意 */
  to: Scalars['DateTime']['output'];
};

/** 曜日 */
export type DayOfWeek =
  /** 金曜日 */
  | 'FRI'
  /** 月曜日 */
  | 'MON'
  /** 土曜日 */
  | 'SAT'
  /** 日曜日 */
  | 'SUN'
  /** 木曜日 */
  | 'THU'
  /** 火曜日 */
  | 'TUE'
  /** 水曜日 */
  | 'WED';

export type DeletePaymentCardError = DeletePaymentCardErrorLoginRequired | DeletePaymentCardErrorUndeletable;

export type DeletePaymentCardErrorLoginRequired = {
  dummy: Scalars['Int']['output'];
};

export type DeletePaymentCardErrorUndeletable = {
  /** カードが削除可能になる日 */
  deletableDateFrom: Scalars['Date']['output'];
};

export type Device =
  | 'PC'
  | 'SD';

export type DiscountCoupon = {
  code: Scalars['DiscountCouponCode']['output'];
  discountAmount: Scalars['Int']['output'];
  minimumReservationAmount: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  reservablePeriod: DateTimePeriod;
  /** クーポンを利用可能な会員数の上限 */
  usableMemberCount: Maybe<Scalars['Int']['output']>;
  viewerAcquired: Scalars['Boolean']['output'];
  visitablePeriod: OptionalDatePeriod;
};

export type DiscountCouponValidationError = {
  message: Scalars['HtmlFragment']['output'];
};

export type DiscountCouponValidationInput = {
  code: Scalars['DiscountCouponCode']['input'];
  hash: Scalars['String']['input'];
  planId: Scalars['PlanId']['input'];
  planPrice: Scalars['Int']['input'];
  restaurantId: Scalars['RestaurantId']['input'];
  totalAmount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
};

export type DiscountCouponValidationResult = DiscountCoupon | DiscountCouponValidationError;

export type ExtendedSearchInterpretation = ExtendedSearchInterpretationKeyword | ExtendedSearchInterpretationLocation | ExtendedSearchInterpretationSpot;

export type ExtendedSearchInterpretationKeyword = {
  dummy: Scalars['Boolean']['output'];
};

export type ExtendedSearchInterpretationLocation = {
  /** ロケーション名 */
  name: Scalars['String']['output'];
  /** 検索した距離[km] */
  radius: Scalars['Float']['output'];
};

export type ExtendedSearchInterpretationSpot = {
  /** スポット名 */
  name: Scalars['String']['output'];
  /** 検索した距離[km] */
  radius: Scalars['Float']['output'];
};

export type Facet = {
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type FavoritePlanError =
  | 'FAVORITES_LIMIT_EXCEEDED'
  | 'INVALID_PLAN'
  | 'LOGIN_REQUIRED';

export type FavoriteRestaurantError =
  | 'FAVORITES_LIMIT_EXCEEDED'
  | 'INVALID_RESTAURANT'
  | 'LOGIN_REQUIRED';

export type FindReviewsInput = {
  first?: Scalars['Int']['input'];
  mealPeriod?: InputMaybe<MealPeriod>;
  offset?: Scalars['Int']['input'];
};

export type Guest = {
  dummy: Scalars['Boolean']['output'];
};

export type HitCounts = {
  facets: Array<Facet>;
  total: Scalars['Int']['output'];
};

export type HitCountsTagsInput = {
  drink?: Array<Scalars['RestaurantTagId']['input']>;
  food?: Array<Scalars['RestaurantTagId']['input']>;
  genre?: Array<Scalars['RestaurantTagId']['input']>;
  scene?: Array<Scalars['RestaurantTagId']['input']>;
};

export type Image = {
  category: ImageCategory;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ImageCategory =
  /** 子供メニュー画像 */
  | 'CHILD_MENU'
  /** コース画像 */
  | 'COURSE'
  /** 外観画像 */
  | 'EXTERIOR'
  /** ガイド広告バナー */
  | 'GUIDE_AD_BANNER'
  /** ガイドギャラリー */
  | 'GUIDE_GALLERY'
  /** ガイドPR本文 */
  | 'GUIDE_PR_BODY'
  /** Deprecated */
  | 'GUIDE_PR_TITLE'
  /** 店内・席画像 */
  | 'INTERIOR'
  /** ガイド・メニュー画面用画像 */
  | 'MENU'
  /** オプション画像 */
  | 'OPTION'
  /** その他画像 */
  | 'OTHER'
  /** プラン画像 */
  | 'PLAN'
  /** 店舗画像 */
  | 'RESTAURANT'
  /** 店舗画像 */
  | 'RESTAURANT_LIST'
  /** 席画像 */
  | 'SEAT';

export type KiwaminoArticle = {
  articleId: Scalars['KiwaminoArticleId']['output'];
  content: Scalars['HtmlFragment']['output'];
  postedAt: Scalars['DateTime']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LargeArea = {
  code: Scalars['LargeAreaCode']['output'];
  name: Scalars['String']['output'];
};

/** 制限有無 */
export type LimitType =
  /** 制限あり */
  | 'LIMITED'
  /** 制限なし */
  | 'NO_LIMIT'
  /** 不明 */
  | 'UNKNOWN';

export type LyReview = {
  handleName: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  restaurantComment: Maybe<Scalars['String']['output']>;
  userComment: Scalars['String']['output'];
  userPostDate: Scalars['Date']['output'];
};

export type MailMagazineSubscription = {
  point: Scalars['Boolean']['output'];
  present: Scalars['Boolean']['output'];
  restaurant: Scalars['Boolean']['output'];
};

export type MajorGenre = {
  code: Scalars['GenreCode']['output'];
  name: Scalars['String']['output'];
};

export type MealPeriod =
  /** すべて */
  | 'ALL'
  /** 朝食 */
  | 'BREAKFAST'
  /** ブランチ */
  | 'BRUNCH'
  /** ディナー */
  | 'DINNER'
  /** ランチ */
  | 'LUNCH'
  /** 夜食 */
  | 'MIDNIGHT'
  /** ティー */
  | 'TEATIME';

export type MediumArea = {
  code: Scalars['MediumAreaCode']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent: LargeArea;
};

export type Member = {
  favoritePlans: PlanWithPriceConnection;
  favoriteRestaurants: Array<Restaurant>;
  isVicSalonMember: Scalars['Boolean']['output'];
  loginSite: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumberCertified: Scalars['Boolean']['output'];
  point: Scalars['Int']['output'];
  pointVisible: Scalars['Boolean']['output'];
  rank: Scalars['String']['output'];
};

export type MinimumArea = {
  code: Scalars['MinimumAreaCode']['output'];
  name: Scalars['String']['output'];
  parent: SmallArea;
};

export type MinorGenre = {
  code: Scalars['GenreCode']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  acquireDiscountCoupon: Maybe<AcquireDiscountCouponError>;
  deletePaymentCard: Maybe<DeletePaymentCardError>;
  /**
   * お気に入りプランを追加する
   * お気に入りプランの上限を超えている場合はエラーを返す
   * 対象プランが存在しない、または不正な場合はエラーを返す
   */
  favoritePlan: Maybe<FavoritePlanError>;
  favoriteRestaurant: Maybe<FavoriteRestaurantError>;
  reserve: ReserveResult;
  subscribeInventoryNotification: Maybe<SubscribeInventoryNotificationError>;
  /**
   * お気に入りプランを削除する
   * お気に入りプランが存在しない場合は何もしない
   */
  unfavoritePlan: Maybe<UnfavoritePlanError>;
  unfavoriteRestaurant: Maybe<UnfavoriteRestaurantError>;
  unsubscribeInventoryNotification: Maybe<UnsubscribeInventoryNotificationError>;
};


export type MutationAcquireDiscountCouponArgs = {
  code: Scalars['DiscountCouponCode']['input'];
};


export type MutationDeletePaymentCardArgs = {
  cardId: Scalars['PaymentCardId']['input'];
};


export type MutationFavoritePlanArgs = {
  planId: Scalars['PlanId']['input'];
};


export type MutationFavoriteRestaurantArgs = {
  restaurantId: Scalars['RestaurantId']['input'];
};


export type MutationReserveArgs = {
  input: ReserveInput;
};


export type MutationSubscribeInventoryNotificationArgs = {
  restaurantId: Scalars['RestaurantId']['input'];
};


export type MutationUnfavoritePlanArgs = {
  planId: Scalars['PlanId']['input'];
};


export type MutationUnfavoriteRestaurantArgs = {
  restaurantId: Scalars['RestaurantId']['input'];
};


export type MutationUnsubscribeInventoryNotificationArgs = {
  restaurantId: Scalars['RestaurantId']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type OptionMenu = {
  /** 来店日の2日前まで予約可能な場合、2 を返す */
  closeDays: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  image: Maybe<Image>;
  maxOrderPerReservation: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionMenuId: Scalars['OptionMenuId']['output'];
  price: Scalars['Int']['output'];
  visitingPeriodFrom: Maybe<Scalars['Date']['output']>;
  visitingPeriodTo: Maybe<Scalars['Date']['output']>;
};

export type OptionalDatePeriod = {
  from: Maybe<Scalars['Date']['output']>;
  /** 開区間か閉区間かはフィールドによるので注意 */
  to: Maybe<Scalars['Date']['output']>;
};

/** Information about pagination in a connection */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Parking = {
  availability: Availability;
  note: Scalars['String']['output'];
};

export type PaymentType =
  /** 事前決済のみ */
  | 'ONLINE_ONLY'
  /** 現地決済のみ */
  | 'ONSITE_ONLY'
  /** 現地決済と事前決済併用 */
  | 'ONSITE_OR_ONLINE';

export type PaypayAvailability = PaypayAvailable | PaypayUnavailable;

export type PaypayAvailable = {
  balance: Scalars['Int']['output'];
};

export type PaypayUnavailable = {
  cause: PaypayUnavailableCause;
};

export type PaypayUnavailableCause =
  /** PayPay残高取得失敗 */
  | 'FAILED_TO_GET_BALANCE'
  /** Yahoo! JAPAN ID のトークンが不正 */
  | 'INVALID_YAHOO_ID_TOKEN'
  /** PayPay未連携 */
  | 'PAYPAY_NOT_CONNECTED'
  /** 電話番号未認証 */
  | 'PHONE_NUMBER_UNVERIFIED'
  /** Yahoo! JAPAN ID 未連携 */
  | 'YAHOO_ID_NOT_CONNECTED';

export type Pet = {
  allowed: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
};

export type Plan = Node & {
  additionalContents: Scalars['String']['output'];
  attributes: Array<PlanAttribute>;
  /** @deprecated Use cancelPolicy3 instead */
  cancelPolicy2: Maybe<RestaurantCancelPolicy>;
  cancelPolicy3: Maybe<RestaurantCancelPolicy2>;
  capacityRange: PlanCapacityRange;
  childMenus: Array<ChildMenu>;
  course: Course;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated check timesale instead */
  inTimesale: Scalars['Boolean']['output'];
  inventory: Array<ReservableTime>;
  inventoryCalendar: Array<PlanInventoryCalendar>;
  /** キャンセルガードプランかどうか */
  isCancelGuard: Scalars['Boolean']['output'];
  isInSpecial: Scalars['Boolean']['output'];
  isRequestReservation: Scalars['Boolean']['output'];
  isSeatOnly: Scalars['Boolean']['output'];
  listPrice: Maybe<Scalars['Int']['output']>;
  listPriceComponents: Maybe<PlanListPriceComponents>;
  listPriceIsReference: Scalars['Boolean']['output'];
  mealPeriod: MealPeriod;
  memberLimitType: PlanMemberLimitType;
  /** プランの注意文言。 */
  notes: Scalars['String']['output'];
  optionMenus: Array<OptionMenu>;
  paymentType: PaymentType;
  planId: Scalars['PlanId']['output'];
  price: Scalars['Int']['output'];
  reservableVisitorsCount: Array<Scalars['Int']['output']>;
  reserveInfo: ReserveInfoResult;
  restaurant: Restaurant;
  restrictions: Scalars['String']['output'];
  /** PlanId 指定で searchPrice を取得したとき、検索条件にマッチする Plan が存在しないケースがあるため Option を返す。 */
  searchPrice: Maybe<SearchPriceResult>;
  /** プランに設定されている席をすべて返す。 */
  seats: Array<Seat>;
  tags: Array<RestaurantTag>;
  timesale: Maybe<Timesale>;
  version: Scalars['String']['output'];
  viewerFavorited: Scalars['Boolean']['output'];
  /** @deprecated use timesale.timesale.visibleLabel instead */
  visibleTimesaleLabel: Scalars['Boolean']['output'];
};


export type PlanInventoryArgs = {
  visitDate: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
};


export type PlanInventoryCalendarArgs = {
  input: InputMaybe<PlanInventoryCalendarInput>;
  to: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
};


export type PlanIsInSpecialArgs = {
  specialId: InputMaybe<Scalars['SpecialId']['input']>;
};


export type PlanReservableVisitorsCountArgs = {
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
};


export type PlanReserveInfoArgs = {
  input: ReserveInfoInput;
};


export type PlanSearchPriceArgs = {
  input: SearchInput;
};


export type PlanTagsArgs = {
  tagIds: Array<Scalars['RestaurantTagId']['input']>;
};

export type PlanAttribute =
  /** 特典つきプラン */
  | 'BENEFIT'
  /** ブッフェプラン */
  | 'BUFFET'
  /** 割引きありプラン */
  | 'DISCOUNTED'
  /** フリードリンク付きプラン */
  | 'FREE_DRINK'
  /** 一休限定プラン */
  | 'IKYU_LIMITED'
  /** 夜景確定プラン */
  | 'NIGHT_VIEW'
  /** 個室確約プラン */
  | 'PRIVATE_ROOM'
  /** テラス席プラン */
  | 'TERRACE_SEAT';

/** プランの利用可能人数範囲 */
export type PlanCapacityRange = {
  lower: Scalars['Int']['output'];
  upper: Scalars['Int']['output'];
};

export type PlanConnection = {
  /** A list of edges. */
  edges: Array<PlanEdge>;
  /** A list of nodes. */
  nodes: Array<Plan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlanEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Plan;
};

export type PlanInventoryCalendar = {
  date: CalendarDate;
  inventory: Array<ReservableTime>;
};

export type PlanInventoryCalendarInput = {
  childUses?: Array<ChildUse>;
  seatTypes?: Array<SeatType>;
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  until: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
  windowSide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlanListPriceComponents = {
  bouquet: Scalars['Int']['output'];
  cake: Scalars['Int']['output'];
  charge: Scalars['Int']['output'];
  drink: Scalars['Int']['output'];
  food: Scalars['Int']['output'];
  others: Scalars['Int']['output'];
  present: Scalars['Int']['output'];
};

/** プラン会員限定タイプ */
export type PlanMemberLimitType =
  /** ダイヤモンド会員限定 */
  | 'DIAMOND'
  /** ゴールド会員以上限定 */
  | 'GOLD_OR_HIGHER'
  /** 一休会員限定 */
  | 'MEMBER'
  /** 限定なし */
  | 'NO_LIMIT'
  /** プラチナ会員以上限定 */
  | 'PLATINUM_OR_HIGHER'
  /** 特別会員（VIC）限定 */
  | 'VIC';

export type PlanSearchResultConnection = {
  /** A list of edges. */
  edges: Array<PlanSearchResultEdge>;
  /** A list of nodes. */
  nodes: Array<Plan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlanSearchResultEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Plan;
  seats: Array<Seat>;
};

export type PlanWithPriceConnection = {
  /** A list of edges. */
  edges: Array<PlanWithPriceEdge>;
  /** A list of nodes. */
  nodes: Array<Plan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlanWithPriceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Plan;
  price: Maybe<SearchPriceResult>;
  timesaleLabel: Scalars['Boolean']['output'];
};

export type PointRewardSetting = {
  reservablePeriod: DateTimePeriod;
  settingId: Scalars['PointRewardSettingId']['output'];
};

export type Prefecture =
  /** 愛知県 */
  | 'AICHI'
  /** 秋田県 */
  | 'AKITA'
  /** 青森県 */
  | 'AOMORI'
  /** 千葉県 */
  | 'CHIBA'
  /** 愛媛県 */
  | 'EHIME'
  /** 福井県 */
  | 'FUKUI'
  /** 福岡県 */
  | 'FUKUOKA'
  /** 福島県 */
  | 'FUKUSHIMA'
  /** 岐阜県 */
  | 'GIFU'
  /** 群馬県 */
  | 'GUNMA'
  /** 広島県 */
  | 'HIROSHIMA'
  /** 北海道 */
  | 'HOKKAIDO'
  /** 兵庫県 */
  | 'HYOGO'
  /** 茨城県 */
  | 'IBARAKI'
  /** 石川県 */
  | 'ISHIKAWA'
  /** 岩手県 */
  | 'IWATE'
  /** 香川県 */
  | 'KAGAWA'
  /** 鹿児島県 */
  | 'KAGOSHIMA'
  /** 神奈川県 */
  | 'KANAGAWA'
  /** 高知県 */
  | 'KOCHI'
  /** 熊本県 */
  | 'KUMAMOTO'
  /** 京都府 */
  | 'KYOTO'
  /** 三重県 */
  | 'MIE'
  /** 宮城県 */
  | 'MIYAGI'
  /** 宮崎県 */
  | 'MIYAZAKI'
  /** 長野県 */
  | 'NAGANO'
  /** 長崎県 */
  | 'NAGASAKI'
  /** 奈良県 */
  | 'NARA'
  /** 新潟県 */
  | 'NIIGATA'
  /** 大分県 */
  | 'OITA'
  /** 岡山県 */
  | 'OKAYAMA'
  /** 沖縄県 */
  | 'OKINAWA'
  /** 大阪府 */
  | 'OSAKA'
  /** 佐賀県 */
  | 'SAGA'
  /** 埼玉県 */
  | 'SAITAMA'
  /** 滋賀県 */
  | 'SHIGA'
  /** 島根県 */
  | 'SHIMANE'
  /** 静岡県 */
  | 'SHIZUOKA'
  /** 栃木県 */
  | 'TOCHIGI'
  /** 徳島県 */
  | 'TOKUSHIMA'
  /** 東京都 */
  | 'TOKYO'
  /** 鳥取県 */
  | 'TOTTORI'
  /** 富山県 */
  | 'TOYAMA'
  /** 和歌山県 */
  | 'WAKAYAMA'
  /** 山形県 */
  | 'YAMAGATA'
  /** 山口県 */
  | 'YAMAGUCHI'
  /** 山梨県 */
  | 'YAMANASHI';

export type QrCodePaymentAvailability = QrCodePaymentAvailabilityAvailable | QrCodePaymentAvailabilityUnavailable | QrCodePaymentAvailabilityUnknown;

export type QrCodePaymentAvailabilityAvailable = {
  availableQrCodePayments: Array<Scalars['String']['output']>;
};

export type QrCodePaymentAvailabilityUnavailable = {
  dummy: Scalars['Int']['output'];
};

export type QrCodePaymentAvailabilityUnknown = {
  dummy: Scalars['Int']['output'];
};

export type Query = {
  affiliateSite: Maybe<AffiliateSite>;
  calendar: Array<CalendarDate>;
  hitCounts: HitCounts;
  node: Maybe<Node>;
  now: Scalars['DateTime']['output'];
  /**
   * プランを複数取得する
   *
   * 任意の数のプランを取得できてしまうので、クライアントサイドからの利用は禁止
   * サーバーサイドからでも個数にしぼりをつけること
   */
  plans: PlanWithPriceConnection;
  restaurant: Maybe<Restaurant>;
  /**
   * レストランを複数取得する
   *
   * 任意の数のレストランを取得できてしまうので、クライアントサイドからの利用は禁止
   * サーバーサイドからでも個数にしぼりをつけること
   */
  restaurants: Array<Restaurant>;
  searchRestaurants: RestaurantSearchResultConnection;
  shiftJis: ShiftJisResult;
  specialFeature: Maybe<SpecialFeature>;
  suggestions: Array<Suggestion>;
  timesale: Maybe<Timesale>;
  validateDiscountCoupon: DiscountCouponValidationResult;
  /** @deprecated use viewer2 instead */
  viewer: Maybe<Viewer>;
  viewer2: Viewer2;
};


export type QueryCalendarArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryHitCountsArgs = {
  input: SearchRestaurantsInput;
  tags: HitCountsTagsInput;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlansArgs = {
  planIds: Array<Scalars['PlanId']['input']>;
};


export type QueryRestaurantArgs = {
  restaurantId: Scalars['RestaurantId']['input'];
};


export type QueryRestaurantsArgs = {
  restaurantIds: Array<Scalars['RestaurantId']['input']>;
};


export type QuerySearchRestaurantsArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  input: SearchRestaurantsInput;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShiftJisArgs = {
  input: Scalars['String']['input'];
};


export type QuerySpecialFeatureArgs = {
  specialFeatureId: Scalars['SpecialFeatureId']['input'];
};


export type QuerySuggestionsArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  keyword: Scalars['String']['input'];
};


export type QueryTimesaleArgs = {
  timesaleId: Scalars['TimesaleId']['input'];
};


export type QueryValidateDiscountCouponArgs = {
  input: DiscountCouponValidationInput;
};

export type ReferencePriceRange = {
  lower: Scalars['Int']['output'];
  upper: Maybe<Scalars['Int']['output']>;
};

export type RegisteredCreditCard = {
  /** 国際ブランド名(VISA, MASTER, JCB, AMEX,DINERS) */
  brand: Scalars['String']['output'];
  /** カード登録ID */
  cardId: Scalars['String']['output'];
  /** カード有効期限 */
  goodThru: Scalars['String']['output'];
  /** 名義人 */
  holderName: Scalars['String']['output'];
  /** メイン利用のカードかどうか */
  isPrimary: Scalars['Boolean']['output'];
  /** マスクされたカード番号 */
  maskedNumber: Scalars['String']['output'];
  /** カード登録連番 */
  sequence: Scalars['Int']['output'];
};

export type ReservableCalendar = {
  dates: Array<ReservableDate>;
  mealPeriod: MealPeriod;
};

export type ReservableCalendarInput = {
  buffet?: InputMaybe<Scalars['Boolean']['input']>;
  childUses?: Array<ChildUse>;
  expandVisitMinutes?: Scalars['Int']['input'];
  freeFlow?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['Date']['input'];
  lowerBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  /** 取得したい MealPeriod のリスト (検索条件ではない) */
  mealPeriods?: Array<MealPeriod>;
  planIds?: Array<Scalars['PlanId']['input']>;
  sceneTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  seatTypes?: Array<SeatType>;
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Date']['input'];
  upperBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  visitTime?: InputMaybe<Scalars['HourMinute']['input']>;
  visitorsCount?: InputMaybe<Scalars['Int']['input']>;
  windowSide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReservableDate = {
  calendarDate: CalendarDate;
  hasClosedInventory: Scalars['Boolean']['output'];
  reservable: Scalars['Boolean']['output'];
  reservableVisitorsCount: Array<Scalars['Int']['output']>;
};

export type ReservableTime = {
  /** 割引率 (%) */
  discountRatePercent: Maybe<Scalars['Int']['output']>;
  /** 固定ポイント (コースもしくは席のみ) */
  fixedPoints: Scalars['Int']['output'];
  /**
   * ポイント料率 (%)
   * 定常/会員ランク/施策などすべてのポイント付与を含む
   */
  pointRatePercent: Scalars['Float']['output'];
  price: Scalars['Int']['output'];
  seats: Array<Seat>;
  visitTime: Scalars['HourMinute']['output'];
};

export type ReservableTimesInput = {
  buffet?: InputMaybe<Scalars['Boolean']['input']>;
  childUses?: Array<ChildUse>;
  freeFlow?: InputMaybe<Scalars['Boolean']['input']>;
  lowerBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  mealPeriod?: InputMaybe<MealPeriod>;
  planIds?: Array<Scalars['PlanId']['input']>;
  sceneTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  seatTypes?: Array<SeatType>;
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  upperBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  visitDate: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
  windowSide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReservableVisitorsCountsInput = {
  planIds?: Array<Scalars['PlanId']['input']>;
};

export type Reservation = {
  reservationId: Scalars['ReservationId']['output'];
  restaurant: Restaurant;
  visitDate: Scalars['Date']['output'];
  visitTime: Scalars['HourMinute']['output'];
  visitorsCount: Scalars['Int']['output'];
};

export type ReservationGivenPointsType =
  /** 一休ポイント */
  | 'IKYU'
  /** PayPay ポイント */
  | 'PAYPAY';

export type ReservationGivenPointsUsage =
  /** 貯める */
  | 'SAVE'
  /** 即時利用 */
  | 'USE_INSTANTLY';

export type ReserveCancelPolicyInput = {
  cancelPolicyId: Scalars['CancelPolicyId']['input'];
  version: Scalars['Int']['input'];
};

export type ReserveChildMenuInput = {
  childMenuId: Scalars['ChildMenuId']['input'];
  count: Scalars['Int']['input'];
};

export type ReserveDiscountCouponInput = {
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
};

export type ReserveError = {
  messages: Array<Scalars['HtmlFragment']['output']>;
};

export type ReserveGuestAuthenticationType =
  /** メールアドレス認証 */
  | 'EMAIL'
  /** 電話番号認証 */
  | 'PHONE_NUMBER';

export type ReserveInfo = {
  affiliateSiteForm: Maybe<AffiliateSiteForm>;
  childMenus: Array<ChildMenu>;
  discountCouponValidationHash: Scalars['String']['output'];
  /** 同日同時間帯の予約数 */
  duplicateReserveCount: Scalars['Int']['output'];
  /** GMOメンテナンス */
  gmoMaintenance: Scalars['Boolean']['output'];
  inventory: ReservableTime;
  member: Maybe<ReserveInfoMember>;
  optionMenus: Array<ReserveInfoOptionMenu>;
  /** PayPayメンテナンス中メッセージ */
  paypayMaintenanceMessage: Scalars['HtmlFragment']['output'];
  /** PayPay機能停止を伴わないお知らせ */
  paypayNoticeMessage: Scalars['HtmlFragment']['output'];
  plan: Plan;
  point: ReserveInfoPoint;
  /** カードメンテナンス */
  toyotaFinanceMaintenance: Scalars['Boolean']['output'];
  visitDate: Scalars['Date']['output'];
  visitTime: Scalars['HourMinute']['output'];
  visitorsCount: Scalars['Int']['output'];
};

export type ReserveInfoError = {
  messages: Array<Scalars['HtmlFragment']['output']>;
};

export type ReserveInfoInput = {
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
  visitorsCount: Scalars['Int']['input'];
};

export type ReserveInfoMember = {
  cards: Array<RegisteredCreditCard>;
  discountCoupons: Array<DiscountCoupon>;
  email: Scalars['String']['output'];
  mailMagazineSubscription: MailMagazineSubscription;
  name: Scalars['String']['output'];
  nameKana: Scalars['String']['output'];
  paypay: PaypayAvailability;
  phoneNumber: Scalars['String']['output'];
  totalPoint: Scalars['Int']['output'];
  usablePoint: Scalars['Int']['output'];
};

export type ReserveInfoOptionMenu = {
  availability: Maybe<Scalars['Int']['output']>;
  optionMenu: OptionMenu;
};

export type ReserveInfoPoint = {
  /** コース固定付与ポイント */
  courseFixedPoint: Scalars['Int']['output'];
  /** ポイント付与率(会員ランクに応じた新規予約時のポイント付与率) */
  rate: Scalars['Float']['output'];
  /** 席のみ・固定付与ポイント */
  seatOnlyFixedPoint: Scalars['Int']['output'];
};

export type ReserveInfoRedirect = {
  redirect: ReserveInfoRedirectTarget;
};

export type ReserveInfoRedirectTarget =
  /** リフレッシュトークン期限切れにより Y!ログイン画面 にリダイレクトする */
  | 'MEMBER_OAUTH_YID';

export type ReserveInfoResult = ReserveInfo | ReserveInfoError | ReserveInfoRedirect;

export type ReserveInput = {
  adults: Scalars['Int']['input'];
  affiliateSiteFormAnswer?: InputMaybe<Scalars['String']['input']>;
  cancelPolicy?: InputMaybe<ReserveCancelPolicyInput>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  cardSeq?: InputMaybe<Scalars['String']['input']>;
  cardToken?: InputMaybe<Scalars['String']['input']>;
  childMenus: Array<ReserveChildMenuInput>;
  children?: InputMaybe<Scalars['Int']['input']>;
  discountCoupon?: InputMaybe<ReserveDiscountCouponInput>;
  givenPoints?: InputMaybe<Scalars['Int']['input']>;
  givenPointsType?: InputMaybe<ReservationGivenPointsType>;
  givenPointsUsage?: InputMaybe<ReservationGivenPointsUsage>;
  guestAuthenticationType?: InputMaybe<ReserveGuestAuthenticationType>;
  ikyuPointsUsed?: InputMaybe<Scalars['Int']['input']>;
  optionMenus: Array<ReserveOptionMenuInput>;
  paymentAmount: Scalars['Int']['input'];
  paymentType: ReservePaymentType;
  paypayBalanceUsed?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<ReservePlanInput>;
  planId: Scalars['PlanId']['input'];
  requestsAndComments?: InputMaybe<Scalars['String']['input']>;
  reserver: ReservePersonalInfoInput;
  reserverMailAddress?: InputMaybe<Scalars['String']['input']>;
  restaurantId: Scalars['RestaurantId']['input'];
  seatId: Scalars['SeatId']['input'];
  subscribeMailMagazineIkyuNews?: InputMaybe<Scalars['Boolean']['input']>;
  subscribeMailMagazinePointCoupon?: InputMaybe<Scalars['Boolean']['input']>;
  surveyAnswer: Scalars['String']['input'];
  totalAmount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
  visitor?: InputMaybe<ReservePersonalInfoInput>;
  visitorsCount: Scalars['Int']['input'];
};

export type ReserveOk = {
  affiliateSiteConversionTag: Scalars['HtmlFragment']['output'];
  firstTimeReserve: Scalars['Boolean']['output'];
  reservation: Reservation;
};

export type ReserveOptionMenuInput = {
  count: Scalars['Int']['input'];
  optionMenuId: Scalars['OptionMenuId']['input'];
};

export type ReservePaymentType =
  /** 事前決済 */
  | 'ONLINE'
  /** 現地決済 */
  | 'ONSITE';

export type ReservePersonalInfoInput = {
  name: Scalars['String']['input'];
  nameKana: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ReservePlanInput = {
  planId: Scalars['PlanId']['input'];
  version: Scalars['String']['input'];
};

export type ReserveResult = ReserveError | ReserveOk;

export type Restaurant = Node & {
  accesses: Array<RestaurantAccess>;
  /** 店舗の属する宿泊施設 */
  accommodation: Maybe<Accommodation>;
  /** 指定されたプログラムIDの開催中 or 直近のポイント付与設定 */
  activePointRewardSetting: Maybe<PointRewardSetting>;
  /** 都道府県なしの住所 */
  address: Scalars['String']['output'];
  announcement: Maybe<RestaurantAnnouncement>;
  area: RestaurantArea;
  areaReviewRanking: Maybe<RestaurantAreaReviewRanking>;
  /** @deprecated use cancelPolicy2 instead */
  cancelPolicy: Maybe<RestaurantCancelPolicy>;
  cancelPolicy2: Maybe<RestaurantCancelPolicy2>;
  cardPaymentAvailable: Scalars['Boolean']['output'];
  cardPaymentForDisplay: CardPayment;
  catchphraseText: Maybe<Scalars['String']['output']>;
  childAvailability: ChildAvailability;
  course: Maybe<Course>;
  /** 店舗の PR テキスト */
  description: Maybe<Scalars['String']['output']>;
  dinnerReferencePriceRange: Maybe<ReferencePriceRange>;
  discountCoupons: Array<DiscountCoupon>;
  dressCodeText: Scalars['String']['output'];
  /** 都道府県つきの住所 */
  fullAddress: Scalars['String']['output'];
  genre: RestaurantGenre;
  /** 店舗のPR情報 */
  highlights: Array<RestaurantHighlight>;
  hygieneControlText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 店舗画像（コース、席の画像を含む） */
  images: Array<Image>;
  /** 店舗画像 */
  images2: Array<Image>;
  introductionText: Maybe<Scalars['String']['output']>;
  inventory: RestaurantInventory;
  inventoryCalendar: Array<RestaurantPlansInventoryCalendar>;
  isCasual: Scalars['Boolean']['output'];
  /** クチコミ非掲載店舗かどうか */
  isReviewHidden: Scalars['Boolean']['output'];
  /** 至高のレストランか否か */
  isSupreme: Scalars['Boolean']['output'];
  /** テスト店舗か否か */
  isTest: Scalars['Boolean']['output'];
  /** レストランに紐づいたKIWAMINOの記事一覧 */
  kiwaminoArticles: Array<KiwaminoArticle>;
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  lunchReferencePriceRange: Maybe<ReferencePriceRange>;
  /**
   * レストランのメニュー
   *
   * コース、アラカルト、ドリンクいずれもなければ null
   */
  menus: Maybe<RestaurantMenus>;
  name: Scalars['String']['output'];
  /** レストラン名 (かな/アルファベット表記) */
  nameAlt: Scalars['String']['output'];
  /** レストラン名 (カナ表記) */
  nameKana: Scalars['String']['output'];
  nearbyRestaurants: Array<Restaurant>;
  /** 店舗の近隣のスポット */
  nearbySpots: Array<Spot>;
  /**
   * 来店日が6/3でnoncancelable_daysが3の場合、
   * キャンセル操作が可能なのは5/30中まで
   */
  noncancelableDays: Scalars['Int']['output'];
  /** 店舗注意事項 */
  notes: Scalars['String']['output'];
  openingHoursText: Scalars['String']['output'];
  parking: Parking;
  paymentMethodText: Scalars['String']['output'];
  paypayAvailable: Scalars['Boolean']['output'];
  pet: Pet;
  phoneNumber: Scalars['String']['output'];
  /** 一休またはPPGの新着クチコミ1件 */
  pickupReview: Maybe<Review>;
  plan: Maybe<Plan>;
  pointAvailable: Scalars['Boolean']['output'];
  prefecture: Prefecture;
  /** QRコード決済の利用可否 */
  qrCodePaymentAvailability: QrCodePaymentAvailability;
  /**
   * 店舗ステータスが公開中以外の店舗とクチコミ非掲載店舗はどちらも null として扱うので、
   * フロント側で別途 isReviewHidden で判定する必要がある
   */
  rating: Maybe<RestaurantRating>;
  recommendRestaurants: Array<Restaurant>;
  regularHolidayText: Scalars['String']['output'];
  /** 店舗の属性に関連するタグ */
  relatedTags: Array<RestaurantTag>;
  /** カレンダーの取得期間に関わらず、店舗で在庫登録されているすべての MealPeriod を返す */
  reservableCalendar: Array<ReservableCalendar>;
  reservableTimes: Array<Scalars['HourMinute']['output']>;
  /** @deprecated use ReservableDate.reservableVisitorsCount instead */
  reservableVisitorsCounts: Array<Scalars['Int']['output']>;
  reservationPhoneNumber: Scalars['String']['output'];
  restaurantId: Scalars['RestaurantId']['output'];
  reviewTags: Array<ReviewTag>;
  /** クチコミが投稿された予約で利用した時間帯の一覧 */
  reviewedMealPeriods: Array<MealPeriod>;
  /** @deprecated use reviews2 instead */
  reviews: ReviewConnection;
  reviews2: Review2Connection;
  searchCourses: CourseConnection;
  searchSeatOnlyPlans: PlanConnection;
  seat: Maybe<Seat>;
  seatsText: Scalars['String']['output'];
  /** 検索用の店舗名 */
  seoName: Maybe<RestaurantSeoName>;
  serviceFeeText: Scalars['String']['output'];
  smoking: Smoking;
  /** ステータス */
  status: RestaurantStatus;
  supportsInventoryNotification: Scalars['Boolean']['output'];
  tableChargeText: Scalars['String']['output'];
  viewerFavorited: Scalars['Boolean']['output'];
  viewerInventoryNotificationSubscribed: Scalars['Boolean']['output'];
  wheelchairAccessibility: Availability;
  zoom: Scalars['Int']['output'];
};


export type RestaurantActivePointRewardSettingArgs = {
  programId: Scalars['PointRewardProgramId']['input'];
};


export type RestaurantCourseArgs = {
  courseId: Scalars['CourseId']['input'];
};


export type RestaurantImages2Args = {
  first: InputMaybe<Scalars['Int']['input']>;
};


export type RestaurantInventoryArgs = {
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
  visitorsCount: Scalars['Int']['input'];
};


export type RestaurantInventoryCalendarArgs = {
  planIds: Array<Scalars['PlanId']['input']>;
  to: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
};


export type RestaurantKiwaminoArticlesArgs = {
  first?: Scalars['Int']['input'];
};


export type RestaurantNearbyRestaurantsArgs = {
  first: Scalars['Int']['input'];
};


export type RestaurantPlanArgs = {
  planId: Scalars['PlanId']['input'];
};


export type RestaurantRecommendRestaurantsArgs = {
  first: Scalars['Int']['input'];
};


export type RestaurantReservableCalendarArgs = {
  input: ReservableCalendarInput;
};


export type RestaurantReservableTimesArgs = {
  input: ReservableTimesInput;
};


export type RestaurantReservableVisitorsCountsArgs = {
  input: ReservableVisitorsCountsInput;
};


export type RestaurantReviewsArgs = {
  input: FindReviewsInput;
};


export type RestaurantReviews2Args = {
  input: FindReviewsInput;
};


export type RestaurantSearchCoursesArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  input: SearchInput;
};


export type RestaurantSearchSeatOnlyPlansArgs = {
  input: SearchInput;
};


export type RestaurantSeatArgs = {
  seatId: Scalars['SeatId']['input'];
};

export type RestaurantAccess = RestaurantAccessCar | RestaurantAccessTrain;

export type RestaurantAccessCar = {
  note: Scalars['String']['output'];
};

export type RestaurantAccessTrain = {
  line: Scalars['String']['output'];
  note: Scalars['String']['output'];
  station: Scalars['String']['output'];
};

export type RestaurantAnnouncement = {
  content: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RestaurantArea = {
  displayName: Scalars['String']['output'];
  largeCode: Scalars['LargeAreaCode']['output'];
  largeName: Scalars['String']['output'];
  mediumCode: Scalars['MediumAreaCode']['output'];
  mediumKey: Scalars['String']['output'];
  mediumName: Scalars['String']['output'];
  minimums: Array<MinimumArea>;
  smallCode: Scalars['SmallAreaCode']['output'];
  smallName: Scalars['String']['output'];
};

export type RestaurantAreaReviewRanking = {
  minimumArea: MinimumArea;
  rank: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RestaurantCancelPolicy = CancelPolicy | CancelPolicyText;

export type RestaurantCancelPolicy2 = CancelPolicyStructured | CancelPolicyText;

export type RestaurantGenre = {
  displayName: Scalars['String']['output'];
  major: MajorGenre;
  minor: MinorGenre;
};

export type RestaurantHighlight = {
  description: Scalars['String']['output'];
  image: Maybe<Image>;
  imageAlt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RestaurantInventory = {
  courses: Array<RestaurantInventoryCourse>;
  seatOnlyPlans: Array<RestaurantInventorySeatOnlyPlan>;
  /** @deprecated Use seatOnlyPlans instead */
  seatOnlyPlans2: Array<RestaurantInventorySeatOnlyPlan>;
};

export type RestaurantInventoryCourse = {
  course: Course;
  plans: Array<RestaurantInventoryPlan>;
};

export type RestaurantInventoryPlan = {
  /** 割引率 (%) */
  discountRatePercent: Maybe<Scalars['Int']['output']>;
  /** 固定ポイント (コースもしくは席のみ) */
  fixedPoints: Scalars['Int']['output'];
  plan: Plan;
  /**
   * ポイント料率 (%)
   * 定常/会員ランク/施策などすべてのポイント付与を含む
   */
  pointRatePercent: Scalars['Float']['output'];
  price: Scalars['Int']['output'];
  seats: Array<Seat>;
};

export type RestaurantInventorySeatOnlyPlan = {
  fixedPoints: Scalars['Int']['output'];
  plan: Plan;
  seats: Array<Seat>;
};

/** メニューアイテム */
export type RestaurantMenuItem = {
  description: Scalars['String']['output'];
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Maybe<Scalars['Int']['output']>;
};

/** メニュールート */
export type RestaurantMenuRoot = {
  sections: Array<RestaurantMenuSection>;
  updatedDate: Scalars['Date']['output'];
};

/** メニューセクション */
export type RestaurantMenuSection = {
  description: Scalars['String']['output'];
  items: Array<RestaurantMenuItem>;
  title: Scalars['String']['output'];
};

/** レストランのメニュー */
export type RestaurantMenus = {
  aLaCarte: Maybe<RestaurantMenuRoot>;
  course: Maybe<RestaurantMenuRoot>;
  drink: Maybe<RestaurantMenuRoot>;
};

export type RestaurantPlansInventoryCalendar = {
  dates: Array<PlanInventoryCalendar>;
  plan: Plan;
};

export type RestaurantRating = {
  atmosphere: Scalars['Float']['output'];
  costPerformance: Scalars['Float']['output'];
  food: Scalars['Float']['output'];
  service: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
};

export type RestaurantSearchResultConnection = {
  /** A list of edges. */
  edges: Array<RestaurantSearchResultEdge>;
  interpretation: Maybe<ExtendedSearchInterpretation>;
  /** A list of nodes. */
  nodes: Array<Restaurant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestaurantSearchResultEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** 検索対象スポットからの距離 [m] */
  distance: Maybe<Scalars['Int']['output']>;
  /** The item at the end of the edge */
  node: Restaurant;
  plans: Array<Plan>;
  timesaleLabel: Scalars['Boolean']['output'];
};

export type RestaurantSeoName = {
  /** 施設名 */
  accommodation: Scalars['String']['output'];
  /** 店舗名 */
  restaurant: Scalars['String']['output'];
};

/** 店舗サービス区分 */
export type RestaurantServiceType =
  /** カジュアル */
  | 'CASUAL'
  /** 一休 */
  | 'IKYU';

export type RestaurantStatus =
  /** 利用停止 (終了) */
  | 'CLOSED'
  /** 公開中 */
  | 'OPEN'
  /** 準備中 */
  | 'PREPARING'
  /** 利用停止 (残務処理中) */
  | 'STOPPED'
  /** 利用停止 (一時) */
  | 'SUSPENDED';

/** レストランに付与されているタグ */
export type RestaurantTag = {
  name: Scalars['String']['output'];
  tagId: Scalars['RestaurantTagId']['output'];
  type: RestaurantTagType;
};

export type RestaurantTagType =
  /** 飲み物 */
  | 'DRINK'
  /** 食材 */
  | 'FOOD'
  /** 料理のジャンル */
  | 'GENRE'
  /** 目的・シーンなどの特集 */
  | 'SCENE';

export type Review = {
  handleName: Scalars['String']['output'];
  mealPeriod: MealPeriod;
  memberHash: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  rating: ReviewRating;
  restaurantComment: Maybe<Scalars['String']['output']>;
  useScene: UseScene;
  userComment: Scalars['String']['output'];
  userPostDate: Scalars['Date']['output'];
};

export type Review2 = LyReview | Review;

export type Review2Connection = {
  /** A list of edges. */
  edges: Array<Review2Edge>;
  /** A list of nodes. */
  nodes: Array<Review2>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Review2Edge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Review2;
};

export type ReviewConnection = {
  /** A list of edges. */
  edges: Array<ReviewEdge>;
  /** A list of nodes. */
  nodes: Array<Review>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Review;
};

export type ReviewRating = {
  atmosphere: Scalars['Float']['output'];
  costPerformance: Scalars['Float']['output'];
  food: Scalars['Float']['output'];
  service: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
};

export type ReviewTag = {
  count: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type SearchInput = {
  /** ブッフェ (false は未指定と同じ) */
  buffet?: InputMaybe<Scalars['Boolean']['input']>;
  /** 子供利用 */
  childUses?: Array<ChildUse>;
  /** 飲み物 タグ */
  drinkTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  expandVisitMinutes?: Scalars['Int']['input'];
  /** 食べ物 タグ */
  foodTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 飲み放題 (false は未指定と同じ) */
  freeFlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** 料理ジャンル タグ */
  genreTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** タイムセール開催中の店舗のみを検索する */
  isTimesale?: Scalars['Boolean']['input'];
  /** 特集/利用シーン タグ */
  sceneTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 座席タイプ */
  seatTypes?: Array<SeatType>;
  /** 喫煙可 */
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * タイムセールID
   *
   * is_timesale が指定されているとき無視される
   */
  timesaleId?: InputMaybe<Scalars['TimesaleId']['input']>;
  visitDate?: InputMaybe<Scalars['Date']['input']>;
  visitTime?: InputMaybe<Scalars['HourMinute']['input']>;
  visitorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** 窓際席 (false は未指定と同じ) */
  windowSide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchPriceResult = {
  /** 最低価格 */
  bestPrice: Scalars['Int']['output'];
  /** 割引率 (%) */
  discountPercent: Maybe<Scalars['Int']['output']>;
  /** 固定ポイント付与数 */
  fixedPoints: Scalars['Int']['output'];
  /** 在庫がある */
  hasInventory: Scalars['Boolean']['output'];
  /**
   * ポイント料率 (%)
   * 定常/会員ランク/施策などすべてのポイント付与を含む
   */
  pointRatePercent: Scalars['Float']['output'];
  /** 価格が変動する */
  priceVaried: Scalars['Boolean']['output'];
};

/**
 * - 大エリアまたは中エリアのいずれかが未指定の場合は、「全国」の検索として扱い、他のエリア条件が指定されていても無視する
 * - 小エリアと極小エリアが同時に指定された場合は、それぞれの条件をORで検索する
 */
export type SearchRestaurantsInput = {
  /** 宿泊施設の 一休.com ID */
  accommodationId?: InputMaybe<Scalars['AccommodationId']['input']>;
  /** ブッフェ (false は未指定と同じ) */
  buffet?: InputMaybe<Scalars['Boolean']['input']>;
  /** カード支払可 (false は未指定と同じ) */
  cardPaymentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 子供利用 */
  childUses?: Array<ChildUse>;
  /** 市区町村 */
  cityId?: InputMaybe<Scalars['CityId']['input']>;
  /** 飲み物 タグ */
  drinkTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 検索結果から除外するレストラン */
  excludeRestaurantIds?: Array<Scalars['RestaurantId']['input']>;
  expandVisitMinutes?: Scalars['Int']['input'];
  /** 食べ物 タグ */
  foodTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 飲み放題 (false は未指定と同じ) */
  freeFlow?: InputMaybe<Scalars['Boolean']['input']>;
  /** 料理ジャンル */
  genreCodes?: Array<Scalars['GenreCode']['input']>;
  /** 料理ジャンル タグ */
  genreTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 在庫あり */
  hasInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** ホテル内 */
  hotelRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
  /** 一軒家 (false は未指定と同じ) */
  houseRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
  /** 手仕舞い済の在庫を含める (false は未指定と同じ) */
  includeClosedInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** 一休の日対象店舗 */
  isIkyuDays?: InputMaybe<Scalars['Boolean']['input']>;
  /** タイムセール開催中の店舗のみを検索する */
  isTimesale?: Scalars['Boolean']['input'];
  /** キーワード */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** キーワード検索モード */
  keywordSearchMode?: InputMaybe<SearchRestaurantsKeywordSearchMode>;
  /** 大エリア */
  largeAreaCode?: InputMaybe<Scalars['LargeAreaCode']['input']>;
  /** 価格下限 */
  lowerBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  /** 中エリア */
  mediumAreaCode?: InputMaybe<Scalars['MediumAreaCode']['input']>;
  /** 極小エリア */
  minimumAreaCodes?: Array<Scalars['MinimumAreaCode']['input']>;
  /** 駐車場あり (false は未指定と同じ) */
  parkingAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 緯度経度の中心からの半径[km] (拡張検索で緯度経度検索された場合のみ有効) */
  radius?: InputMaybe<Scalars['Float']['input']>;
  /** 店舗サービス区分 */
  restaurantServiceType?: InputMaybe<RestaurantServiceType>;
  /** 特集/利用シーン タグ */
  sceneTagIds?: Array<Scalars['RestaurantTagId']['input']>;
  /** 座席タイプ */
  seatTypes?: Array<SeatType>;
  /** 小エリア */
  smallAreaCodes?: Array<Scalars['SmallAreaCode']['input']>;
  /** 喫煙可 */
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** ソート順 */
  sortOrder?: InputMaybe<SearchRestaurantsSortOrder>;
  /** 特集ID */
  specialFeatureId?: InputMaybe<Scalars['SpecialFeatureId']['input']>;
  /** スポットID (キーワード検索モードに拡張検索を指定した場合のみ有効) */
  spotId?: InputMaybe<Scalars['SpotId']['input']>;
  /**
   * タイムセールID
   *
   * is_timesale が指定されているとき無視される
   */
  timesaleId?: InputMaybe<Scalars['TimesaleId']['input']>;
  /** 町域 */
  townId?: InputMaybe<Scalars['TownId']['input']>;
  /** 価格上限 */
  upperBoundPrice?: InputMaybe<Scalars['Int']['input']>;
  visitDate?: InputMaybe<Scalars['Date']['input']>;
  visitTime?: InputMaybe<Scalars['HourMinute']['input']>;
  visitorsCount?: InputMaybe<Scalars['Int']['input']>;
  /** 窓際席 (false は未指定と同じ) */
  windowSide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchRestaurantsKeywordSearchMode =
  /** 拡張検索 */
  | 'EXTENDED'
  /** フリーワード検索 */
  | 'FREE';

export type SearchRestaurantsSortOrder =
  /** 一休グルメランキング順 */
  | 'GOURMET'
  /** 価格の安い順 */
  | 'LOW_PRICE'
  /** プラン人気順 */
  | 'PLAN_POPULARITY'
  /** 売上ランキング順 */
  | 'RANKING'
  /** おすすめ順 */
  | 'RECOMMEND'
  /**
   * 店舗人気順
   * トップの「人気のレストラン」表示のためのみに使用する
   */
  | 'RESTAURANT_POPULARITY'
  /** クチコミ評価順 */
  | 'REVIEW'
  /** 至高のレストラン順 */
  | 'SUPREME';

export type Seat = Node & {
  attributes: Array<SeatAttribute>;
  bookingType: SeatBookingType;
  capacity: Scalars['Int']['output'];
  charge: SeatCharge;
  childUse: ChildUse;
  /** 席説明 */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  /** @deprecated Use seatTypeDescription instead */
  note: Scalars['String']['output'];
  restaurant: Restaurant;
  seatId: Scalars['SeatId']['output'];
  seatTypeDescription: Maybe<Scalars['String']['output']>;
  seatTypeLabel: Scalars['String']['output'];
  smokingAllowed: Scalars['Boolean']['output'];
  /** @deprecated Use seatTypeLabel instead */
  type: SeatType;
};

export type SeatAttribute =
  /** カップルシート */
  | 'COUPLE_SEAT'
  /** 川床 */
  | 'KAWADOKO'
  /** 掘りごたつ */
  | 'KOTATSU'
  /** テーブル */
  | 'PRIVATE_TABLE'
  /** ソファ */
  | 'SOFA'
  /** 窓際 */
  | 'WINDOW_SEAT'
  /** 座敷 */
  | 'ZASHIKI';

export type SeatBookingType =
  /** 即時予約 */
  | 'DIRECT'
  /** リクエスト予約 */
  | 'REQUEST'
  /** テイクアウト */
  | 'TAKEOUT';

export type SeatCharge = SeatChargeNoCharge | SeatChargePerPerson | SeatChargePerTable;

export type SeatChargeNoCharge = {
  dummy: Scalars['Boolean']['output'];
};

export type SeatChargePerPerson = {
  price: Scalars['Int']['output'];
};

export type SeatChargePerTable = {
  price: Scalars['Int']['output'];
};

export type SeatType =
  /** カウンター席 */
  | 'COUNTER'
  /** その他 */
  | 'OTHER'
  /** 完全個室 */
  | 'PRIVATE_ROOM'
  /** 半個室 */
  | 'SEMI_PRIVATE_ROOM'
  /** テーブル席 */
  | 'TABLE'
  /** テラス */
  | 'TERRACE';

export type ShiftJisError = {
  unmappableCharacter: Scalars['String']['output'];
};

export type ShiftJisOk = {
  bytesLen: Scalars['Int']['output'];
};

export type ShiftJisResult = ShiftJisError | ShiftJisOk;

export type SmallArea = {
  code: Scalars['SmallAreaCode']['output'];
  name: Scalars['String']['output'];
  parent: MediumArea;
};

export type Smoking = {
  note: Scalars['String']['output'];
  policy: SmokingPolicy;
};

/** 喫煙可否 */
export type SmokingPolicy =
  /** 全席喫煙可 */
  | 'ALLOWED'
  /** 全面禁煙 */
  | 'NOT_ALLOWED'
  /** 分煙 */
  | 'SEPARATED_BY_SPACE'
  /** 時間帯禁煙 */
  | 'SEPARATED_BY_TIME'
  /** 不明 */
  | 'UNKNOWN';

export type SpecialFeature = {
  name: Scalars['String']['output'];
  specialFeatureId: Scalars['SpecialFeatureId']['output'];
};

export type Spot = {
  minimumArea: MinimumArea;
  name: Scalars['String']['output'];
  spotId: Scalars['SpotId']['output'];
  type: SpotType;
};

export type SpotType =
  /** ホテル */
  | 'HOTEL'
  /** ランドマーク */
  | 'LANDMARK'
  /** 駅 */
  | 'STATION';

export type SubscribeInventoryNotificationError =
  | 'INVENTORY_NOTIFICATION_NOT_SUPPORTED'
  | 'LOGIN_REQUIRED'
  | 'RESTAURANT_NOT_FOUND';

export type Suggestion = {
  originalWord: Scalars['String']['output'];
  uniqueWord: Scalars['String']['output'];
  wordType: SuggestionWordType;
};

export type SuggestionWordType = Restaurant | SuggestionWordTypeCity | SuggestionWordTypeGenre | SuggestionWordTypeHotel | SuggestionWordTypePrefecture | SuggestionWordTypeSpot | SuggestionWordTypeStation;

export type SuggestionWordTypeCity = {
  dummy: Scalars['Boolean']['output'];
};

export type SuggestionWordTypeGenre = {
  dummy: Scalars['Boolean']['output'];
};

export type SuggestionWordTypeHotel = {
  dummy: Scalars['Boolean']['output'];
};

export type SuggestionWordTypePrefecture = {
  dummy: Scalars['Boolean']['output'];
};

export type SuggestionWordTypeSpot = {
  dummy: Scalars['Boolean']['output'];
};

export type SuggestionWordTypeStation = {
  dummy: Scalars['Boolean']['output'];
};

export type Timesale = {
  imageUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** 予約可能期間 (半開区間; to は含まない) */
  reservablePeriod: DateTimePeriod;
  timesaleId: Scalars['TimesaleId']['output'];
  visibleLabel: Scalars['Boolean']['output'];
};


export type TimesaleImageUrlArgs = {
  device: Device;
};

export type UnfavoritePlanError =
  | 'LOGIN_REQUIRED';

export type UnfavoriteRestaurantError =
  | 'LOGIN_REQUIRED';

export type UnsubscribeInventoryNotificationError =
  | 'LOGIN_REQUIRED';

export type UseScene =
  /** 記念日 */
  | 'ANNIVERSARY'
  /** デート */
  | 'DATING'
  /** その他 */
  | 'OTHER'
  /** 飲み会・宴会 */
  | 'PARTY'
  /** 接待 */
  | 'RECEPTION'
  /** 家族との会食 */
  | 'WITH_FAMILY'
  /** 友人・知人との会食 */
  | 'WITH_FRIENDS';

export type Viewer = {
  isVicSalonMember: Scalars['Boolean']['output'];
  loginSite: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumberCertified: Scalars['Boolean']['output'];
  point: Scalars['Int']['output'];
  pointVisible: Scalars['Boolean']['output'];
  rank: Scalars['String']['output'];
};

export type Viewer2 = Guest | Member | YahooMember;

export type YahooMember = {
  favoritePlans: PlanWithPriceConnection;
  favoriteRestaurants: Array<Restaurant>;
  isPremium: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type RestaurantRecommendCardFragment = { restaurantId: scalars.RestaurantId, name: string, area: { displayName: string }, images: Array<{ url: string }>, rating: { totalValue: number, totalCount: number } | null } & { ' $fragmentName'?: 'RestaurantRecommendCardFragment' };

export type RestaurantAreaFragment = { area: { largeName: string, largeCode: scalars.LargeAreaCode, mediumName: string, mediumKey: string, mediumCode: scalars.MediumAreaCode, smallName: string, smallCode: scalars.SmallAreaCode, minimums: Array<{ code: scalars.MinimumAreaCode, name: string }> } } & { ' $fragmentName'?: 'RestaurantAreaFragment' };

export type RestaurantBreadcrumbsFragment = { name: string, area: { largeName: string, largeCode: scalars.LargeAreaCode, mediumName: string, mediumKey: string, mediumCode: scalars.MediumAreaCode, smallName: string, smallCode: scalars.SmallAreaCode, minimums: Array<{ code: scalars.MinimumAreaCode, name: string }> }, genre: { displayName: string, major: { code: scalars.GenreCode, name: string }, minor: { code: scalars.GenreCode, name: string } } } & { ' $fragmentName'?: 'RestaurantBreadcrumbsFragment' };

export type GetReservableCalendarQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableCalendarInput;
}>;


export type GetReservableCalendarQuery = { restaurant: { reservableCalendar: Array<{ ' $fragmentRefs'?: { 'ReservableCalendarItemFragment': ReservableCalendarItemFragment } }> } | null };

export type GetReservableCalendarAndMealPeriodQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableCalendarInput;
  searchInput: SearchInput;
}>;


export type GetReservableCalendarAndMealPeriodQuery = { restaurant: { reservableCalendar: Array<{ ' $fragmentRefs'?: { 'ReservableCalendarItemFragment': ReservableCalendarItemFragment } }>, searchCourses: { nodes: Array<{ searchPlans: { nodes: Array<{ mealPeriod: MealPeriod }> } }> } } | null };

export type GetReservableCalendarWithMealPeriodQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableCalendarInput;
}>;


export type GetReservableCalendarWithMealPeriodQuery = { restaurant: { reservableCalendar: Array<{ ' $fragmentRefs'?: { 'ReservableCalendarItemFragment': ReservableCalendarItemFragment } }> } | null };

export type GetReservableTimesQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableTimesInput;
}>;


export type GetReservableTimesQuery = { restaurant: { reservableTimes: Array<scalars.HourMinute> } | null };

export type ReservableCalendarItemFragment = { mealPeriod: MealPeriod, dates: Array<{ reservable: boolean, hasClosedInventory: boolean, reservableVisitorsCount: Array<number>, calendarDate: { date: scalars.DateText, holiday: boolean, dayOfWeek: DayOfWeek } }> } & { ' $fragmentName'?: 'ReservableCalendarItemFragment' };

export type RestaurantTwoWeeksCalendarFragment = { phoneNumber: string } & { ' $fragmentName'?: 'RestaurantTwoWeeksCalendarFragment' };

export type CourseSelectionInfoFragment = { courseId: scalars.CourseId, name: string, menuText: string, type: { __typename: 'CourseTypeIkyu' } | { __typename: 'CourseTypeOfficial' }, restaurant: { name: string }, images: Array<{ url: string, name: string }> } & { ' $fragmentName'?: 'CourseSelectionInfoFragment' };

export type RestaurantInventoryCourseFragment = { course: { ' $fragmentRefs'?: { 'CourseSelectionInfoFragment': CourseSelectionInfoFragment } }, plans: Array<{ price: number, discountRatePercent: number | null, pointRatePercent: number, fixedPoints: number, plan: { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment;'PlanAttributesFragment': PlanAttributesFragment } }, seats: Array<{ ' $fragmentRefs'?: { 'SeatAttributesFragment': SeatAttributesFragment } }> }> } & { ' $fragmentName'?: 'RestaurantInventoryCourseFragment' };

export type RestaurantSearchCourseFragment = (
  { searchPlans: { edges: Array<{ seats: Array<{ ' $fragmentRefs'?: { 'SeatAttributesFragment': SeatAttributesFragment } }>, node: (
        { searchPrice: { ' $fragmentRefs'?: { 'PlanSearchPriceFragment': PlanSearchPriceFragment } } | null }
        & { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment;'PlanAttributesFragment': PlanAttributesFragment } }
      ) }> } }
  & { ' $fragmentRefs'?: { 'CourseSelectionInfoFragment': CourseSelectionInfoFragment } }
) & { ' $fragmentName'?: 'RestaurantSearchCourseFragment' };

export type PlanAttributesFragment = { attributes: Array<PlanAttribute>, mealPeriod: MealPeriod, freeFlow3hours: boolean, tags: Array<{ tagId: scalars.RestaurantTagId, name: string, type: RestaurantTagType }> } & { ' $fragmentName'?: 'PlanAttributesFragment' };

export type SeatAttributesFragment = { smokingAllowed: boolean, attributes: Array<SeatAttribute>, seatTypeLabel: string, childUse: ChildUse } & { ' $fragmentName'?: 'SeatAttributesFragment' };

export type GetHighlightsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetHighlightsQuery = { restaurant: { ' $fragmentRefs'?: { 'RestaurantMetadataFragment': RestaurantMetadataFragment;'RestaurantHighlightsFragment': RestaurantHighlightsFragment } } | null };

export type GetReviewsPageQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetReviewsPageQuery = { restaurant: (
    { name: string, status: RestaurantStatus, isTest: boolean, isReviewHidden: boolean, images: Array<{ url: string }> }
    & { ' $fragmentRefs'?: { 'RestaurantRatingFragment': RestaurantRatingFragment;'RestaurantMetadataFragment': RestaurantMetadataFragment } }
  ) | null };

export type CourseSelectionInventoryCoursesQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  visitorsCount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
}>;


export type CourseSelectionInventoryCoursesQuery = { restaurant: (
    { restaurantId: scalars.RestaurantId, name: string, inventory: { seatOnlyPlans: Array<{ fixedPoints: number, plan: { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment;'PlanAttributesFragment': PlanAttributesFragment } }, seats: Array<{ ' $fragmentRefs'?: { 'SeatAttributesFragment': SeatAttributesFragment } }> }>, courses: Array<{ ' $fragmentRefs'?: { 'RestaurantInventoryCourseFragment': RestaurantInventoryCourseFragment } }> } }
    & { ' $fragmentRefs'?: { 'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } }
  ) | null };

export type GetReviewedMealPeriodsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetReviewedMealPeriodsQuery = { restaurant: { reviewedMealPeriods: Array<MealPeriod> } | null };

export type PlanInventoryCalendarQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  to: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
  input: PlanInventoryCalendarInput;
}>;


export type PlanInventoryCalendarQuery = { restaurant: { plan: { inventoryCalendar: Array<{ ' $fragmentRefs'?: { 'InventoryCalendarItemFragment': InventoryCalendarItemFragment } }> } | null } | null };

export type InventoryCalendarItemFragment = { date: { date: scalars.DateText, holiday: boolean, dayOfWeek: DayOfWeek }, inventory: Array<{ visitTime: scalars.HourMinute, price: number, discountRatePercent: number | null, seats: Array<{ seatId: scalars.SeatId }> }> } & { ' $fragmentName'?: 'InventoryCalendarItemFragment' };

export type PlanReservableVisitorsCountsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type PlanReservableVisitorsCountsQuery = { restaurant: { reservableVisitorsCounts: Array<number>, plan: { additionalContents: string, restrictions: string, mealPeriod: MealPeriod, isSeatOnly: boolean, course: { name: string }, capacityRange: { lower: number, upper: number } } | null } | null };

export type RestaurantGenreFragment = { genre: { displayName: string, major: { code: scalars.GenreCode, name: string }, minor: { code: scalars.GenreCode, name: string } } } & { ' $fragmentName'?: 'RestaurantGenreFragment' };

export type PlanRestaurantNotesFragment = { notes: string } & { ' $fragmentName'?: 'PlanRestaurantNotesFragment' };

export type PlanRestaurantAllowDiscountOnReservationFragment = { pointAvailable: boolean } & { ' $fragmentName'?: 'PlanRestaurantAllowDiscountOnReservationFragment' };

export type PlanSearchPriceFragment = { bestPrice: number, priceVaried: boolean, hasInventory: boolean, discountPercent: number | null, pointRatePercent: number, fixedPoints: number } & { ' $fragmentName'?: 'PlanSearchPriceFragment' };

export type PlanSelectionInfoFragment = (
  { planId: scalars.PlanId, additionalContents: string, restrictions: string, description: string, mealPeriod: MealPeriod, price: number, listPrice: number | null, isRequestReservation: boolean, isCancelGuard: boolean, memberLimitType: PlanMemberLimitType, paymentType: PaymentType, notes: string, attributes: Array<PlanAttribute>, isSeatOnly: boolean, timesale: { visibleLabel: boolean, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime } } | null, childMenus: Array<{ ' $fragmentRefs'?: { 'PlanDetailChildMenuItemFragment': PlanDetailChildMenuItemFragment } }>, optionMenus: Array<{ ' $fragmentRefs'?: { 'PlanDetailOptionItemFragment': PlanDetailOptionItemFragment } }>, course: { name: string }, cancelPolicy: { ' $fragmentRefs'?: { 'RestaurantCancelPolicyItem_CancelPolicy_Fragment': RestaurantCancelPolicyItem_CancelPolicy_Fragment } } | { ' $fragmentRefs'?: { 'RestaurantCancelPolicyItem_CancelPolicyText_Fragment': RestaurantCancelPolicyItem_CancelPolicyText_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'PlanListPriceItemFragment': PlanListPriceItemFragment;'SharePlanFragmentFragment': SharePlanFragmentFragment } }
) & { ' $fragmentName'?: 'PlanSelectionInfoFragment' };

export type PlanDetailChildMenuItemFragment = { __typename: 'ChildMenu', childMenuId: scalars.ChildMenuId, name: string, price: number, closeDays: number, visitingPeriodFrom: scalars.DateText | null, visitingPeriodTo: scalars.DateText | null, description: string, image: { url: string, name: string, category: ImageCategory } | null } & { ' $fragmentName'?: 'PlanDetailChildMenuItemFragment' };

export type PlanDetailOptionItemFragment = { __typename: 'OptionMenu', optionMenuId: scalars.OptionMenuId, name: string, price: number, closeDays: number, visitingPeriodFrom: scalars.DateText | null, visitingPeriodTo: scalars.DateText | null, description: string, image: { url: string, name: string } | null } & { ' $fragmentName'?: 'PlanDetailOptionItemFragment' };

export type PlanListPriceItemFragment = { listPrice: number | null, listPriceIsReference: boolean, listPriceComponents: { food: number, drink: number, cake: number, bouquet: number, present: number, charge: number, others: number } | null } & { ' $fragmentName'?: 'PlanListPriceItemFragment' };

export type RestaurantPriceRangeFragment = { lunchReferencePriceRange: { lower: number, upper: number | null } | null, dinnerReferencePriceRange: { lower: number, upper: number | null } | null } & { ' $fragmentName'?: 'RestaurantPriceRangeFragment' };

export type GetRestaurantAccessQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRestaurantAccessQuery = { restaurant: (
    { restaurantId: scalars.RestaurantId, fullAddress: string }
    & { ' $fragmentRefs'?: { 'RestaurantMetadataFragment': RestaurantMetadataFragment;'RestaurantCoordinateFragment': RestaurantCoordinateFragment;'RestaurantAccessesFragment': RestaurantAccessesFragment } }
  ) | null };

export type RestaurantCalendarFragment = { phoneNumber: string } & { ' $fragmentName'?: 'RestaurantCalendarFragment' };

export type AcquireCouponMutationVariables = Exact<{
  code: Scalars['DiscountCouponCode']['input'];
}>;


export type AcquireCouponMutation = { acquireDiscountCoupon: AcquireDiscountCouponError | null };

export type CouponFragment = { code: scalars.DiscountCouponCode, name: string, discountAmount: number, minimumReservationAmount: number | null, viewerAcquired: boolean, usableMemberCount: number | null, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime }, visitablePeriod: { from: scalars.DateText | null, to: scalars.DateText | null } } & { ' $fragmentName'?: 'CouponFragment' };

export type GetCouponListQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetCouponListQuery = { restaurant: { discountCoupons: Array<{ ' $fragmentRefs'?: { 'CouponFragment': CouponFragment } }> } | null };

export type SearchHitCountsQueryVariables = Exact<{
  input: SearchRestaurantsInput;
  tags: HitCountsTagsInput;
}>;


export type SearchHitCountsQuery = { hitCounts: { total: number, facets: Array<{ key: string, count: number }> } };

export type SearchSuggestionsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type SearchSuggestionsQuery = { suggestions: Array<{ uniqueWord: string, wordType: { __typename: 'Restaurant', restaurantId: scalars.RestaurantId, name: string } | { __typename: 'SuggestionWordTypeCity' } | { __typename: 'SuggestionWordTypeGenre' } | { __typename: 'SuggestionWordTypeHotel' } | { __typename: 'SuggestionWordTypePrefecture' } | { __typename: 'SuggestionWordTypeSpot' } | { __typename: 'SuggestionWordTypeStation' } }> };

export type MemberFavoriteListQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberFavoriteListQueryQuery = { viewer: { __typename: 'Guest' } | { __typename: 'Member', favoriteRestaurants: Array<{ ' $fragmentRefs'?: { 'FavoriteRestaurantFragmentFragment': FavoriteRestaurantFragmentFragment } }>, favoritePlans: { edges: Array<{ ' $fragmentRefs'?: { 'FavoritePlanFragmentFragment': FavoritePlanFragmentFragment } }> } } | { __typename: 'YahooMember', favoriteRestaurants: Array<{ ' $fragmentRefs'?: { 'FavoriteRestaurantFragmentFragment': FavoriteRestaurantFragmentFragment } }>, favoritePlans: { edges: Array<{ ' $fragmentRefs'?: { 'FavoritePlanFragmentFragment': FavoritePlanFragmentFragment } }> } } };

export type GuestFavoriteListQueryQueryVariables = Exact<{
  restaurantIds: Array<Scalars['RestaurantId']['input']> | Scalars['RestaurantId']['input'];
  planIds: Array<Scalars['PlanId']['input']> | Scalars['PlanId']['input'];
}>;


export type GuestFavoriteListQueryQuery = { restaurants: Array<{ ' $fragmentRefs'?: { 'FavoriteRestaurantFragmentFragment': FavoriteRestaurantFragmentFragment } }>, plans: { edges: Array<{ ' $fragmentRefs'?: { 'FavoritePlanFragmentFragment': FavoritePlanFragmentFragment } }> } };

export type FavoriteRestaurantFragmentFragment = (
  { restaurantId: scalars.RestaurantId, name: string, status: RestaurantStatus, images: Array<{ url: string }>, area: { displayName: string }, genre: { displayName: string }, rating: { totalValue: number, totalCount: number } | null }
  & { ' $fragmentRefs'?: { 'RestaurantPriceRangeFragment': RestaurantPriceRangeFragment } }
) & { ' $fragmentName'?: 'FavoriteRestaurantFragmentFragment' };

export type FavoritePlanFragmentFragment = { timesaleLabel: boolean, node: { planId: scalars.PlanId, additionalContents: string, restrictions: string, mealPeriod: MealPeriod, listPrice: number | null, isSeatOnly: boolean, course: { name: string, images: Array<{ url: string }> }, restaurant: (
      { restaurantId: scalars.RestaurantId, name: string, area: { displayName: string }, genre: { displayName: string }, rating: { totalValue: number, totalCount: number } | null }
      & { ' $fragmentRefs'?: { 'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } }
    ) }, price: { bestPrice: number, priceVaried: boolean, discountPercent: number | null, pointRatePercent: number, fixedPoints: number } | null } & { ' $fragmentName'?: 'FavoritePlanFragmentFragment' };

export type FavoritePlanQueryQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type FavoritePlanQueryQuery = { restaurant: { plan: { viewerFavorited: boolean } | null } | null };

export type FavoritePlanMutationMutationVariables = Exact<{
  planId: Scalars['PlanId']['input'];
}>;


export type FavoritePlanMutationMutation = { favoritePlan: FavoritePlanError | null };

export type UnfavoritePlanMutationMutationVariables = Exact<{
  planId: Scalars['PlanId']['input'];
}>;


export type UnfavoritePlanMutationMutation = { unfavoritePlan: UnfavoritePlanError | null };

export type FavoriteRestaurantQueryQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type FavoriteRestaurantQueryQuery = { restaurant: { viewerFavorited: boolean } | null };

export type FavoriteRestaurantMutationMutationVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type FavoriteRestaurantMutationMutation = { favoriteRestaurant: FavoriteRestaurantError | null };

export type UnfavoriteRestaurantMutationMutationVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type UnfavoriteRestaurantMutationMutation = { unfavoriteRestaurant: UnfavoriteRestaurantError | null };

export type RestaurantAnnouncementFragment = { announcement: { title: string, content: string, url: string } | null } & { ' $fragmentName'?: 'RestaurantAnnouncementFragment' };

export type GetReviewsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  mealPeriod: InputMaybe<MealPeriod>;
}>;


export type GetReviewsQuery = { restaurant: { reviews2: { totalCount: number, pageInfo: { __typename: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean }, edges: Array<{ node: { ' $fragmentRefs'?: { 'ReviewsNodes_LyReview_Fragment': ReviewsNodes_LyReview_Fragment } } | { ' $fragmentRefs'?: { 'ReviewsNodes_Review_Fragment': ReviewsNodes_Review_Fragment } } }> } } | null };

export type RestaurantGuideTitleFragment = { restaurantId: scalars.RestaurantId, name: string, isCasual: boolean, area: { largeCode: scalars.LargeAreaCode }, genre: { displayName: string } } & { ' $fragmentName'?: 'RestaurantGuideTitleFragment' };

export type KiwaminoArticleInfoFragment = { articleId: scalars.KiwaminoArticleId, title: string, content: scalars.HtmlFragment, postedAt: scalars.DateTime, thumbnailUrl: string } & { ' $fragmentName'?: 'KiwaminoArticleInfoFragment' };

export type RestaurantNearbySpotsFragment = { nearbySpots: Array<{ spotId: scalars.SpotId, name: string, type: SpotType, minimumArea: { code: scalars.MinimumAreaCode, parent: { code: scalars.SmallAreaCode, parent: { key: string } } } }> } & { ' $fragmentName'?: 'RestaurantNearbySpotsFragment' };

export type RestaurantMetadataFragment = { name: string, nameAlt: string, nameKana: string, catchphraseText: string | null, introductionText: string | null, description: string | null, status: RestaurantStatus, isTest: boolean, seoName: { restaurant: string, accommodation: string } | null, accommodation: { name: string } | null, area: { displayName: string }, genre: { displayName: string }, images: Array<{ url: string }> } & { ' $fragmentName'?: 'RestaurantMetadataFragment' };

export type RestaurantSummaryFragment = (
  { name: string, isCasual: boolean, paypayAvailable: boolean, pointAvailable: boolean, supportsInventoryNotification: boolean, catchphraseText: string | null, introductionText: string | null, isReviewHidden: boolean, genre: { displayName: string }, lunchReferencePriceRange: { lower: number, upper: number | null } | null, dinnerReferencePriceRange: { lower: number, upper: number | null } | null, areaReviewRanking: { ' $fragmentRefs'?: { 'RestaurantAreaReviewRankingItemFragment': RestaurantAreaReviewRankingItemFragment } } | null }
  & { ' $fragmentRefs'?: { 'RestaurantGenreFragment': RestaurantGenreFragment;'RestaurantAreaFragment': RestaurantAreaFragment;'RestaurantRatingFragment': RestaurantRatingFragment } }
) & { ' $fragmentName'?: 'RestaurantSummaryFragment' };

export type RestaurantRelatedTagsFragment = { relatedTags: Array<{ type: RestaurantTagType, tagId: scalars.RestaurantTagId, name: string }> } & { ' $fragmentName'?: 'RestaurantRelatedTagsFragment' };

export type SupremeRestaurantFragment = { isSupreme: boolean } & { ' $fragmentName'?: 'SupremeRestaurantFragment' };

export type SearchCoursesQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  searchInput: SearchInput;
}>;


export type SearchCoursesQuery = { restaurant: (
    { restaurantId: scalars.RestaurantId, name: string, searchSeatOnlyPlans: { edges: Array<{ node: (
          { seats: Array<{ ' $fragmentRefs'?: { 'SeatAttributesFragment': SeatAttributesFragment } }>, searchPrice: { hasInventory: boolean, fixedPoints: number } | null }
          & { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment;'PlanAttributesFragment': PlanAttributesFragment } }
        ) }> }, searchCourses: { edges: Array<{ node: { ' $fragmentRefs'?: { 'RestaurantSearchCourseFragment': RestaurantSearchCourseFragment } } }> } }
    & { ' $fragmentRefs'?: { 'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } }
  ) | null };

export type GetInventoryOnlySeatQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  visitorsCount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
}>;


export type GetInventoryOnlySeatQuery = { restaurant: { inventory: { seatOnlyPlans: Array<{ plan: { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment } } }> } } | null };

export type GetRestaurantArticleQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRestaurantArticleQuery = { restaurant: { kiwaminoArticles: Array<{ ' $fragmentRefs'?: { 'KiwaminoArticleInfoFragment': KiwaminoArticleInfoFragment } }> } | null };

export type GetRestaurantSummaryQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  isIkyu: Scalars['Boolean']['input'];
}>;


export type GetRestaurantSummaryQuery = { now: scalars.DateTime, restaurant: (
    { restaurantId: scalars.RestaurantId, discountCoupons: Array<{ ' $fragmentRefs'?: { 'CouponFragment': CouponFragment } }>, searchCourses: { nodes: Array<{ searchPlans: { nodes: Array<{ timesale: { visibleLabel: boolean } | null }> } }> }, ikyuDaySetting: { reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime } } | null }
    & { ' $fragmentRefs'?: { 'RestaurantMetadataFragment': RestaurantMetadataFragment;'RestaurantAreaFragment': RestaurantAreaFragment;'RestaurantIntroductionFragment': RestaurantIntroductionFragment;'RestaurantHighlightsFragment': RestaurantHighlightsFragment;'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'RestaurantAnnouncementFragment': RestaurantAnnouncementFragment;'RestaurantTwoWeeksCalendarFragment': RestaurantTwoWeeksCalendarFragment;'RestaurantCalendarFragment': RestaurantCalendarFragment;'RestaurantSummaryFragment': RestaurantSummaryFragment;'PlanRestaurantNotesFragment': PlanRestaurantNotesFragment;'RestaurantAccessesFragment': RestaurantAccessesFragment;'RestaurantGuideTitleFragment': RestaurantGuideTitleFragment;'RestaurantRelatedTagsFragment': RestaurantRelatedTagsFragment;'RestaurantNearbySpotsFragment': RestaurantNearbySpotsFragment;'RestaurantNearbyRestaurantsFragment': RestaurantNearbyRestaurantsFragment;'RestaurantFaqFragmentFragment': RestaurantFaqFragmentFragment;'RestaurantGuidePhotosFragment': RestaurantGuidePhotosFragment;'SupremeRestaurantFragment': SupremeRestaurantFragment;'RestaurantPriceRangeFragment': RestaurantPriceRangeFragment;'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment;'RestaurantBreadcrumbsFragment': RestaurantBreadcrumbsFragment;'ShareRestaurantButtonFragment': ShareRestaurantButtonFragment;'RestaurantMenusFragmentFragment': RestaurantMenusFragmentFragment } }
  ) | null };

export type GetViewerFavoriteAndSubscribeNotificationQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetViewerFavoriteAndSubscribeNotificationQuery = { restaurant: { viewerFavorited: boolean, viewerInventoryNotificationSubscribed: boolean } | null, viewer: { __typename: 'Viewer' } | null };

export type GuideMenuCoursesQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  searchInput?: InputMaybe<SearchInput>;
}>;


export type GuideMenuCoursesQuery = { restaurant: { searchCourses: { edges: Array<{ node: { ' $fragmentRefs'?: { 'RestaurantSearchCourseFragment': RestaurantSearchCourseFragment } } }> } } | null };

export type RestaurantMenusFragmentFragment = { menus: { course: { ' $fragmentRefs'?: { 'RestaurantMenuRootFragmentFragment': RestaurantMenuRootFragmentFragment } } | null, aLaCarte: { ' $fragmentRefs'?: { 'RestaurantMenuRootFragmentFragment': RestaurantMenuRootFragmentFragment } } | null, drink: { ' $fragmentRefs'?: { 'RestaurantMenuRootFragmentFragment': RestaurantMenuRootFragmentFragment } } | null } | null } & { ' $fragmentName'?: 'RestaurantMenusFragmentFragment' };

export type RestaurantMenuRootFragmentFragment = { updatedDate: scalars.DateText, sections: Array<{ title: string, description: string, items: Array<{ name: string, description: string, price: number | null, isRecommended: boolean }> }> } & { ' $fragmentName'?: 'RestaurantMenuRootFragmentFragment' };

export type RestaurantAreaReviewRankingItemFragment = { rank: number, total: number, minimumArea: { code: scalars.MinimumAreaCode, name: string, parent: { code: scalars.SmallAreaCode, parent: { key: string } } } } & { ' $fragmentName'?: 'RestaurantAreaReviewRankingItemFragment' };

export type RestaurantCoordinateFragment = { longitude: string, latitude: string, zoom: number } & { ' $fragmentName'?: 'RestaurantCoordinateFragment' };

export type RestaurantRatingFragment = { restaurantId: scalars.RestaurantId, name: string, isReviewHidden: boolean, rating: { totalCount: number, totalValue: number, food: number, service: number, atmosphere: number, costPerformance: number } | null } & { ' $fragmentName'?: 'RestaurantRatingFragment' };

type ReviewsNodes_LyReview_Fragment = { __typename: 'LyReview', handleName: string, userComment: string, restaurantComment: string | null, userPostDate: scalars.DateText, totalValue: number } & { ' $fragmentName'?: 'ReviewsNodes_LyReview_Fragment' };

type ReviewsNodes_Review_Fragment = { __typename: 'Review', handleName: string, userComment: string, restaurantComment: string | null, userPostDate: scalars.DateText, memberHash: string | null, mealPeriod: MealPeriod, planName: string, useScene: UseScene, rating: { totalValue: number, food: number, service: number, atmosphere: number, costPerformance: number } } & { ' $fragmentName'?: 'ReviewsNodes_Review_Fragment' };

export type ReviewsNodesFragment = ReviewsNodes_LyReview_Fragment | ReviewsNodes_Review_Fragment;

export type RestaurantNearbyRestaurantsFragment = { nearbyRestaurants: Array<{ ' $fragmentRefs'?: { 'RestaurantRecommendCardFragment': RestaurantRecommendCardFragment } }> } & { ' $fragmentName'?: 'RestaurantNearbyRestaurantsFragment' };

export type GetRecommendRestaurantsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRecommendRestaurantsQuery = { restaurant: { recommendRestaurants: Array<{ ' $fragmentRefs'?: { 'RestaurantRecommendCardFragment': RestaurantRecommendCardFragment } }> } | null };

export type RestaurantFaqFragmentFragment = { openingHoursText: string } & { ' $fragmentName'?: 'RestaurantFaqFragmentFragment' };

export type RestaurantHighlightsFragment = { restaurantId: scalars.RestaurantId, highlights: Array<{ title: string, description: string, imageAlt: string, image: { url: string } | null }> } & { ' $fragmentName'?: 'RestaurantHighlightsFragment' };

export type RestaurantIntroductionFragment = { catchphraseText: string | null, introductionText: string | null } & { ' $fragmentName'?: 'RestaurantIntroductionFragment' };

export type SubscribeInventoryNotificationMutationVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type SubscribeInventoryNotificationMutation = { subscribeInventoryNotification: SubscribeInventoryNotificationError | null };

export type UnsubscribeInventoryNotificationMutationVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type UnsubscribeInventoryNotificationMutation = { unsubscribeInventoryNotification: UnsubscribeInventoryNotificationError | null };

export type RestaurantAddressFragment = { restaurantId: scalars.RestaurantId, prefecture: Prefecture, address: string, latitude: string, longitude: string, area: { smallName: string }, accommodation: { accommodationId: scalars.AccommodationId, name: string } | null } & { ' $fragmentName'?: 'RestaurantAddressFragment' };

export type RestaurantPaymentInfoFragment = { paymentMethodText: string, cardPaymentForDisplay: { availability: Availability, note: string }, qrCodePaymentAvailability: { __typename: 'QrCodePaymentAvailabilityAvailable', availableQrCodePayments: Array<string> } | { __typename: 'QrCodePaymentAvailabilityUnavailable' } | { __typename: 'QrCodePaymentAvailabilityUnknown' } } & { ' $fragmentName'?: 'RestaurantPaymentInfoFragment' };

type RestaurantCancelPolicyItem_CancelPolicy_Fragment = { __typename: 'CancelPolicy', cancelPolicyId: scalars.CancelPolicyId, version: number, note: string, policies: Array<{ __typename: 'CancelPolicyItemDaysBefore', days: number, time: scalars.HourMinute | null, appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } } | { __typename: 'CancelPolicyItemNoShow', appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } } | { __typename: 'CancelPolicyItemOnTheDay', appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } }> } & { ' $fragmentName'?: 'RestaurantCancelPolicyItem_CancelPolicy_Fragment' };

type RestaurantCancelPolicyItem_CancelPolicyText_Fragment = { __typename: 'CancelPolicyText', text: string } & { ' $fragmentName'?: 'RestaurantCancelPolicyItem_CancelPolicyText_Fragment' };

export type RestaurantCancelPolicyItemFragment = RestaurantCancelPolicyItem_CancelPolicy_Fragment | RestaurantCancelPolicyItem_CancelPolicyText_Fragment;

export type RestaurantMainInfoFragmentFragment = (
  { phoneNumber: string, openingHoursText: string, regularHolidayText: string, serviceFeeText: string, tableChargeText: string, dressCodeText: string, cancelPolicy: { ' $fragmentRefs'?: { 'RestaurantCancelPolicyItem_CancelPolicy_Fragment': RestaurantCancelPolicyItem_CancelPolicy_Fragment } } | { ' $fragmentRefs'?: { 'RestaurantCancelPolicyItem_CancelPolicyText_Fragment': RestaurantCancelPolicyItem_CancelPolicyText_Fragment } } | null }
  & { ' $fragmentRefs'?: { 'RestaurantPaymentInfoFragment': RestaurantPaymentInfoFragment;'RestaurantInfoNameFragmentFragment': RestaurantInfoNameFragmentFragment;'RestaurantAddressFragment': RestaurantAddressFragment;'RestaurantAccessesFragment': RestaurantAccessesFragment } }
) & { ' $fragmentName'?: 'RestaurantMainInfoFragmentFragment' };

export type RestaurantSubInfoFragmentFragment = { seatsText: string, wheelchairAccessibility: Availability, notes: string, hygieneControlText: string, smoking: { policy: SmokingPolicy, note: string }, pet: { allowed: boolean, note: string }, childAvailability: { ' $fragmentRefs'?: { 'ChildAvailabilityItem_ChildAvailable_Fragment': ChildAvailabilityItem_ChildAvailable_Fragment } } | { ' $fragmentRefs'?: { 'ChildAvailabilityItem_ChildUnavailable_Fragment': ChildAvailabilityItem_ChildUnavailable_Fragment } }, parking: { availability: Availability, note: string } } & { ' $fragmentName'?: 'RestaurantSubInfoFragmentFragment' };

export type RestaurantInfoNameFragmentFragment = { name: string, nameAlt: string, accommodation: { accommodationId: scalars.AccommodationId, name: string } | null } & { ' $fragmentName'?: 'RestaurantInfoNameFragmentFragment' };

type ChildAvailabilityItem_ChildAvailable_Fragment = { __typename: 'ChildAvailable', note: string, ageLimit: LimitType, chairAvailability: Availability, menuAvailability: Availability, seatLimit: LimitType, timeAvailability: ChildTimeAvailability } & { ' $fragmentName'?: 'ChildAvailabilityItem_ChildAvailable_Fragment' };

type ChildAvailabilityItem_ChildUnavailable_Fragment = { __typename: 'ChildUnavailable', note: string } & { ' $fragmentName'?: 'ChildAvailabilityItem_ChildUnavailable_Fragment' };

export type ChildAvailabilityItemFragment = ChildAvailabilityItem_ChildAvailable_Fragment | ChildAvailabilityItem_ChildUnavailable_Fragment;

export type RestaurantPickupReviewFragment = { restaurantId: scalars.RestaurantId, isReviewHidden: boolean, pickupReview: { handleName: string, userComment: string } | null } & { ' $fragmentName'?: 'RestaurantPickupReviewFragment' };

export type PlanLineFragment = (
  { planId: scalars.PlanId, isSeatOnly: boolean, mealPeriod: MealPeriod, listPrice: number | null, additionalContents: string, restrictions: string, paymentType: PaymentType, memberLimitType: PlanMemberLimitType, isRequestReservation: boolean, isCancelGuard: boolean, course: { name: string }, timesale: { visibleLabel: boolean } | null, searchPrice: { ' $fragmentRefs'?: { 'PlanSearchPriceFragment': PlanSearchPriceFragment } } | null, inventory?: Array<{ __typename: 'ReservableTime' }> }
  & { ' $fragmentRefs'?: { 'MenuTextFragment': MenuTextFragment } }
) & { ' $fragmentName'?: 'PlanLineFragment' };

export type MenuTextFragment = { description: string, course: { menuText: string } } & { ' $fragmentName'?: 'MenuTextFragment' };

type ExtendedSearchInterpretation_ExtendedSearchInterpretationKeyword_Fragment = { __typename: 'ExtendedSearchInterpretationKeyword' } & { ' $fragmentName'?: 'ExtendedSearchInterpretation_ExtendedSearchInterpretationKeyword_Fragment' };

type ExtendedSearchInterpretation_ExtendedSearchInterpretationLocation_Fragment = { __typename: 'ExtendedSearchInterpretationLocation', name: string, radius: number } & { ' $fragmentName'?: 'ExtendedSearchInterpretation_ExtendedSearchInterpretationLocation_Fragment' };

type ExtendedSearchInterpretation_ExtendedSearchInterpretationSpot_Fragment = { __typename: 'ExtendedSearchInterpretationSpot', name: string, radius: number } & { ' $fragmentName'?: 'ExtendedSearchInterpretation_ExtendedSearchInterpretationSpot_Fragment' };

export type ExtendedSearchInterpretationFragment = ExtendedSearchInterpretation_ExtendedSearchInterpretationKeyword_Fragment | ExtendedSearchInterpretation_ExtendedSearchInterpretationLocation_Fragment | ExtendedSearchInterpretation_ExtendedSearchInterpretationSpot_Fragment;

export type ReviewSummaryFragment = { restaurantId: scalars.RestaurantId, isReviewHidden: boolean, rating: { totalCount: number, totalValue: number } | null } & { ' $fragmentName'?: 'ReviewSummaryFragment' };

export type RestaurantCardImageFragment = { restaurantId: scalars.RestaurantId, images: Array<{ url: string, name: string }> } & { ' $fragmentName'?: 'RestaurantCardImageFragment' };

export type RestaurantCardFragment = (
  { restaurantId: scalars.RestaurantId, name: string, isCasual: boolean, description: string | null, genre: { displayName: string }, area: { displayName: string } }
  & { ' $fragmentRefs'?: { 'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment;'RestaurantCardImageFragment': RestaurantCardImageFragment;'RestaurantIkyuDaySettingFragment': RestaurantIkyuDaySettingFragment;'ReviewSummaryFragment': ReviewSummaryFragment;'RestaurantAccessesFragment': RestaurantAccessesFragment;'RestaurantPriceRangeFragment': RestaurantPriceRangeFragment;'RestaurantPhoneNumberFragment': RestaurantPhoneNumberFragment;'RestaurantPickupReviewFragment': RestaurantPickupReviewFragment } }
) & { ' $fragmentName'?: 'RestaurantCardFragment' };

export type RestaurantPhoneNumberFragment = { phoneNumber: string } & { ' $fragmentName'?: 'RestaurantPhoneNumberFragment' };

export type RestaurantIkyuDaySettingFragment = { restaurantId: scalars.RestaurantId, ikyuDaySetting: { reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime } } | null } & { ' $fragmentName'?: 'RestaurantIkyuDaySettingFragment' };

export type RestaurantGuidePhotosFragment = { restaurantId: scalars.RestaurantId, name: string, images: Array<{ url: string, name: string, category: ImageCategory }> } & { ' $fragmentName'?: 'RestaurantGuidePhotosFragment' };

export type PlanSeatFragment = (
  { seatId: scalars.SeatId, seatTypeDescription: string | null, image: { url: string, name: string } | null, charge: { __typename: 'SeatChargeNoCharge' } | { __typename: 'SeatChargePerPerson', price: number } | { __typename: 'SeatChargePerTable', price: number } }
  & { ' $fragmentRefs'?: { 'SeatForLabelFragment': SeatForLabelFragment } }
) & { ' $fragmentName'?: 'PlanSeatFragment' };

export type CheckPlanExistenceQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type CheckPlanExistenceQuery = { restaurant: { plan: { planId: scalars.PlanId } | null } | null };

export type GetPlanDetailQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  searchInput: SearchInput;
}>;


export type GetPlanDetailQuery = { restaurant: (
    { name: string, isCasual: boolean, supportsInventoryNotification: boolean, reservableVisitorsCounts: Array<number>, discountCoupons: Array<{ ' $fragmentRefs'?: { 'CouponFragment': CouponFragment } }>, plan: (
      { course: { ' $fragmentRefs'?: { 'CourseSelectionInfoFragment': CourseSelectionInfoFragment } }, searchPrice: { ' $fragmentRefs'?: { 'PlanSearchPriceFragment': PlanSearchPriceFragment } } | null }
      & { ' $fragmentRefs'?: { 'PlanDetailMetadataFragment': PlanDetailMetadataFragment;'PlanSelectionInfoFragment': PlanSelectionInfoFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'RestaurantGenreFragment': RestaurantGenreFragment;'RestaurantMetadataFragment': RestaurantMetadataFragment;'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'RestaurantAreaFragment': RestaurantAreaFragment;'RestaurantAccessesFragment': RestaurantAccessesFragment;'RestaurantCalendarFragment': RestaurantCalendarFragment;'PlanRestaurantNotesFragment': PlanRestaurantNotesFragment;'RestaurantRatingFragment': RestaurantRatingFragment;'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment;'ShareRestaurantButtonFragment': ShareRestaurantButtonFragment } }
  ) | null };

export type GetPlanReservableVisitorsCountsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type GetPlanReservableVisitorsCountsQuery = { restaurant: { reservableVisitorsCounts: Array<number> } | null };

export type PlanDetailMetadataFragment = { planId: scalars.PlanId, additionalContents: string, restrictions: string, mealPeriod: MealPeriod, description: string, course: { name: string, images: Array<{ url: string }> }, restaurant: { name: string, status: RestaurantStatus, isTest: boolean } } & { ' $fragmentName'?: 'PlanDetailMetadataFragment' };

export type GetPlanDetailInventoryCalendarQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  to: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
}>;


export type GetPlanDetailInventoryCalendarQuery = { restaurant: { plan: { inventoryCalendar: Array<{ inventory: Array<{ ' $fragmentRefs'?: { 'PlanDetailInventoryPlanItemFragment': PlanDetailInventoryPlanItemFragment } }> }> } | null } | null };

export type GetPlanDetailInventoryPlanQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  visitorsCount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
}>;


export type GetPlanDetailInventoryPlanQuery = { restaurant: { plan: { inventory: Array<{ ' $fragmentRefs'?: { 'PlanDetailInventoryPlanItemFragment': PlanDetailInventoryPlanItemFragment } }> } | null } | null };

export type PlanDetailInventoryPlanItemFragment = { visitTime: scalars.HourMinute, price: number, discountRatePercent: number | null, pointRatePercent: number } & { ' $fragmentName'?: 'PlanDetailInventoryPlanItemFragment' };

export type DeletePaymentCardMutationVariables = Exact<{
  cardId: Scalars['PaymentCardId']['input'];
}>;


export type DeletePaymentCardMutation = { deletePaymentCard: { __typename: 'DeletePaymentCardErrorLoginRequired' } | { __typename: 'DeletePaymentCardErrorUndeletable', deletableDateFrom: scalars.DateText } | null };

export type ReserveMutationVariables = Exact<{
  input: ReserveInput;
}>;


export type ReserveMutation = { reserve: { __typename: 'ReserveError', messages: Array<scalars.HtmlFragment> } | (
    { __typename: 'ReserveOk' }
    & { ' $fragmentRefs'?: { 'ReserveSuccessFragment': ReserveSuccessFragment } }
  ) };

export type ReserveSuccessFragment = { firstTimeReserve: boolean, affiliateSiteConversionTag: scalars.HtmlFragment, reservation: { reservationId: scalars.ReservationId, visitDate: scalars.DateText, visitTime: scalars.HourMinute, visitorsCount: number, restaurant: { name: string } } } & { ' $fragmentName'?: 'ReserveSuccessFragment' };

export type CancelPolicyPoliciesFragment = { policies: Array<{ __typename: 'CancelPolicyItemDaysBefore', days: number, time: scalars.HourMinute | null, appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } } | { __typename: 'CancelPolicyItemNoShow', appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } } | { __typename: 'CancelPolicyItemOnTheDay', appliesToVisitorDecrement: boolean, charge: { __typename: 'CancelPolicyChargeFee', fee: number } | { __typename: 'CancelPolicyChargeRate', rate: number } }> } & { ' $fragmentName'?: 'CancelPolicyPoliciesFragment' };

export type GetReserveInputQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  visitDate: Scalars['Date']['input'];
  visitTime: Scalars['HourMinute']['input'];
  visitorsCount: Scalars['Int']['input'];
}>;


export type GetReserveInputQuery = { restaurant: (
    { plan: { reserveInfo: (
        { __typename: 'ReserveInfo' }
        & { ' $fragmentRefs'?: { 'PlanReserveInfoFragment': PlanReserveInfoFragment } }
      ) | { __typename: 'ReserveInfoError', messages: Array<scalars.HtmlFragment> } | { __typename: 'ReserveInfoRedirect', redirect: ReserveInfoRedirectTarget } } | null }
    & { ' $fragmentRefs'?: { 'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment } }
  ) | null, viewer: { ' $fragmentRefs'?: { 'ReserveInfoViewerFragment': ReserveInfoViewerFragment } } | null };

export type InventorySeatsFragment = { seats: Array<(
    { seatId: scalars.SeatId, type: SeatType, seatTypeLabel: string, attributes: Array<SeatAttribute>, smokingAllowed: boolean, seatTypeDescription: string | null, description: string, bookingType: SeatBookingType, capacity: number, childUse: ChildUse, image: { url: string, name: string, category: ImageCategory } | null, charge: { __typename: 'SeatChargeNoCharge' } | { __typename: 'SeatChargePerPerson', price: number } | { __typename: 'SeatChargePerTable', price: number } }
    & { ' $fragmentRefs'?: { 'SeatForLabelFragment': SeatForLabelFragment } }
  )> } & { ' $fragmentName'?: 'InventorySeatsFragment' };

export type MemberCardsFragment = { cards: Array<{ cardId: string, maskedNumber: string, goodThru: string, holderName: string, brand: string, isPrimary: boolean }> } & { ' $fragmentName'?: 'MemberCardsFragment' };

export type MemberDiscountCouponsFragment = { discountCoupons: Array<{ code: scalars.DiscountCouponCode, name: string, discountAmount: number, minimumReservationAmount: number | null, viewerAcquired: boolean, usableMemberCount: number | null, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime }, visitablePeriod: { from: scalars.DateText | null, to: scalars.DateText | null } }> } & { ' $fragmentName'?: 'MemberDiscountCouponsFragment' };

export type PlanCancelPolicyFragment = { cancelPolicy: (
    { __typename: 'CancelPolicyStructured', cancelPolicyId: scalars.CancelPolicyId, version: number, note: string }
    & { ' $fragmentRefs'?: { 'CancelPolicyPoliciesFragment': CancelPolicyPoliciesFragment } }
  ) | { __typename: 'CancelPolicyText', text: string } | null } & { ' $fragmentName'?: 'PlanCancelPolicyFragment' };

export type PlanReserveInfoFragment = (
  { visitDate: scalars.DateText, visitTime: scalars.HourMinute, visitorsCount: number, discountCouponValidationHash: string, duplicateReserveCount: number, toyotaFinanceMaintenance: boolean, gmoMaintenance: boolean, paypayMaintenanceMessage: scalars.HtmlFragment, paypayNoticeMessage: scalars.HtmlFragment, point: { seatOnlyFixedPoint: number, courseFixedPoint: number, rate: number }, affiliateSiteForm: { title: string, notes: string } | null, inventory: (
    { visitTime: scalars.HourMinute, price: number, discountRatePercent: number | null }
    & { ' $fragmentRefs'?: { 'InventorySeatsFragment': InventorySeatsFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'ReserveInfoMemberFragment': ReserveInfoMemberFragment;'ReserveInfoPlanFragment': ReserveInfoPlanFragment;'ReserveInfoChildMenusFragment': ReserveInfoChildMenusFragment;'ReserveInfoOptionMenusFragment': ReserveInfoOptionMenusFragment } }
) & { ' $fragmentName'?: 'PlanReserveInfoFragment' };

export type PlanRestaurantFragment = { restaurant: { name: string, paypayAvailable: boolean, pointAvailable: boolean, cardPaymentAvailable: boolean, notes: string, noncancelableDays: number } } & { ' $fragmentName'?: 'PlanRestaurantFragment' };

export type ReserveInfoChildMenusFragment = { childMenus: Array<{ childMenuId: scalars.ChildMenuId, name: string, price: number, description: string, maxOrderPerReservation: number | null, image: { url: string, name: string } | null }> } & { ' $fragmentName'?: 'ReserveInfoChildMenusFragment' };

export type ReserveInfoMemberFragment = { member: (
    { __typename: 'ReserveInfoMember', name: string, nameKana: string, phoneNumber: string, email: string, totalPoint: number, usablePoint: number, paypay: { __typename: 'PaypayAvailable', balance: number } | { __typename: 'PaypayUnavailable', cause: PaypayUnavailableCause }, mailMagazineSubscription: { restaurant: boolean, point: boolean, present: boolean } }
    & { ' $fragmentRefs'?: { 'MemberDiscountCouponsFragment': MemberDiscountCouponsFragment;'MemberCardsFragment': MemberCardsFragment } }
  ) | null } & { ' $fragmentName'?: 'ReserveInfoMemberFragment' };

export type ReserveInfoOptionMenusFragment = { optionMenus: Array<{ availability: number | null, optionMenu: { optionMenuId: scalars.OptionMenuId, name: string, price: number, description: string, maxOrderPerReservation: number | null, image: { url: string, name: string } | null } }> } & { ' $fragmentName'?: 'ReserveInfoOptionMenusFragment' };

export type ReserveInfoPlanFragment = { plan: (
    { planId: scalars.PlanId, version: string, additionalContents: string, restrictions: string, paymentType: PaymentType, notes: string, isRequestReservation: boolean, description: string, isSeatOnly: boolean, isCancelGuard: boolean, price: number, timesale: { visibleLabel: boolean } | null, course: { name: string, menuText: string, images: Array<{ url: string, name: string }> } }
    & { ' $fragmentRefs'?: { 'PlanRestaurantFragment': PlanRestaurantFragment;'PlanCancelPolicyFragment': PlanCancelPolicyFragment } }
  ) } & { ' $fragmentName'?: 'ReserveInfoPlanFragment' };

export type ReserveInfoViewerFragment = { name: string, phoneNumberCertified: boolean, loginSite: string } & { ' $fragmentName'?: 'ReserveInfoViewerFragment' };

export type ValidateDiscountCouponQueryVariables = Exact<{
  input: DiscountCouponValidationInput;
}>;


export type ValidateDiscountCouponQuery = { validateDiscountCoupon: { __typename: 'DiscountCoupon', code: scalars.DiscountCouponCode, name: string, discountAmount: number, minimumReservationAmount: number | null, viewerAcquired: boolean, usableMemberCount: number | null, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime }, visitablePeriod: { from: scalars.DateText | null, to: scalars.DateText | null } } | { __typename: 'DiscountCouponValidationError', message: scalars.HtmlFragment } };

export type ValidateCouponItemFragment = { code: scalars.DiscountCouponCode, name: string, discountAmount: number, minimumReservationAmount: number | null, viewerAcquired: boolean, usableMemberCount: number | null, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime }, visitablePeriod: { from: scalars.DateText | null, to: scalars.DateText | null } } & { ' $fragmentName'?: 'ValidateCouponItemFragment' };

export type GetSpecialFeatureQueryVariables = Exact<{
  specialFeatureId: Scalars['SpecialFeatureId']['input'];
}>;


export type GetSpecialFeatureQuery = { specialFeature: { name: string } | null };

export type GetTimesaleQueryVariables = Exact<{
  timesaleId: Scalars['TimesaleId']['input'];
  device: Device;
}>;


export type GetTimesaleQuery = { timesale: { timesaleId: scalars.TimesaleId, name: string, imageUrl: string | null, reservablePeriod: { from: scalars.DateTime, to: scalars.DateTime } } | null };

export type SharePlanFragmentFragment = { planId: scalars.PlanId, additionalContents: string, restrictions: string, course: { name: string }, restaurant: { restaurantId: scalars.RestaurantId, name: string } } & { ' $fragmentName'?: 'SharePlanFragmentFragment' };

export type ShareRestaurantButtonFragment = { restaurantId: scalars.RestaurantId, name: string, fullAddress: string } & { ' $fragmentName'?: 'ShareRestaurantButtonFragment' };

export type GetTopRecommendRestaurantsQueryVariables = Exact<{
  restaurantIds: Array<Scalars['RestaurantId']['input']> | Scalars['RestaurantId']['input'];
}>;


export type GetTopRecommendRestaurantsQuery = { restaurants: Array<{ ' $fragmentRefs'?: { 'RestaurantRecommendCardFragment': RestaurantRecommendCardFragment } }> };

export type GetPopularityRestaurantsQueryVariables = Exact<{
  input: SearchRestaurantsInput;
}>;


export type GetPopularityRestaurantsQuery = { searchRestaurants: { edges: Array<{ node: { ' $fragmentRefs'?: { 'RestaurantRecommendCardFragment': RestaurantRecommendCardFragment } } }> } };

export type ViewerQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQueryQuery = { viewer: { __typename: 'Guest' } | { __typename: 'Member', loginSite: string, name: string, point: number, rank: string, isVicSalonMember: boolean, phoneNumberCertified: boolean, pointVisible: boolean } | { __typename: 'YahooMember', name: string, isPremium: boolean } };

export type RestaurantAccessesFragment = { restaurantId: scalars.RestaurantId, accesses: Array<{ __typename: 'RestaurantAccessCar', note: string } | { __typename: 'RestaurantAccessTrain', line: string, station: string, note: string }>, area: { displayName: string, mediumName: string }, parking: { availability: Availability, note: string } } & { ' $fragmentName'?: 'RestaurantAccessesFragment' };

export type ValidateShiftJisQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type ValidateShiftJisQuery = { shiftJis: { __typename: 'ShiftJisError', unmappableCharacter: string } | { __typename: 'ShiftJisOk', bytesLen: number } };

export type SeatForLabelFragment = { seatTypeLabel: string, smokingAllowed: boolean, attributes: Array<SeatAttribute> } & { ' $fragmentName'?: 'SeatForLabelFragment' };

export type GuideDetailQueryQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GuideDetailQueryQuery = { restaurant: (
    { restaurantId: scalars.RestaurantId }
    & { ' $fragmentRefs'?: { 'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'RestaurantMetadataFragment': RestaurantMetadataFragment } }
  ) | null };

export type GuidePhotosQueryQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GuidePhotosQueryQuery = { restaurant: (
    { restaurantId: scalars.RestaurantId }
    & { ' $fragmentRefs'?: { 'RestaurantGuidePhotosFragment': RestaurantGuidePhotosFragment;'RestaurantMetadataFragment': RestaurantMetadataFragment } }
  ) | null };

export type RestaurantPolicyInfoQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type RestaurantPolicyInfoQuery = { restaurant: { name: string, fullAddress: string, phoneNumber: string } | null };

export type SearchRestaurantsQueryVariables = Exact<{
  input: SearchRestaurantsInput;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchInput: SearchInput;
  visitDate: Scalars['Date']['input'];
  visitorsCount: Scalars['Int']['input'];
  withPickupReview?: InputMaybe<Scalars['Boolean']['input']>;
  withPlans?: InputMaybe<Scalars['Boolean']['input']>;
  withPlanInventory?: InputMaybe<Scalars['Boolean']['input']>;
  withMenuText?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchRestaurantsQuery = { searchRestaurants: { totalCount: number, interpretation: { ' $fragmentRefs'?: { 'ExtendedSearchInterpretation_ExtendedSearchInterpretationKeyword_Fragment': ExtendedSearchInterpretation_ExtendedSearchInterpretationKeyword_Fragment } } | { ' $fragmentRefs'?: { 'ExtendedSearchInterpretation_ExtendedSearchInterpretationLocation_Fragment': ExtendedSearchInterpretation_ExtendedSearchInterpretationLocation_Fragment } } | { ' $fragmentRefs'?: { 'ExtendedSearchInterpretation_ExtendedSearchInterpretationSpot_Fragment': ExtendedSearchInterpretation_ExtendedSearchInterpretationSpot_Fragment } } | null, edges: Array<{ timesaleLabel: boolean, node: { ' $fragmentRefs'?: { 'RestaurantCardFragment': RestaurantCardFragment } }, plans?: Array<{ ' $fragmentRefs'?: { 'PlanLineFragment': PlanLineFragment } }> }> } };

export type SearchNeighborhoodRestaurantsQueryVariables = Exact<{
  input: SearchRestaurantsInput;
  first: Scalars['Int']['input'];
}>;


export type SearchNeighborhoodRestaurantsQuery = { searchRestaurants: { totalCount: number, edges: Array<{ node: { ' $fragmentRefs'?: { 'RestaurantRecommendCardFragment': RestaurantRecommendCardFragment } } }> } };

export type SearchRestaurantIdsQueryVariables = Exact<{
  input: SearchRestaurantsInput;
  first: Scalars['Int']['input'];
}>;


export type SearchRestaurantIdsQuery = { searchRestaurants: { totalCount: number, edges: Array<{ node: { restaurantId: scalars.RestaurantId } }> } };

export type GetNowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNowQuery = { now: scalars.DateTime };

export type GetCalendarsQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type GetCalendarsQuery = { calendar: Array<{ date: scalars.DateText, dayOfWeek: DayOfWeek, holiday: boolean }> };

export type GetPlanInventorySeatsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
  visitorsCount: Scalars['Int']['input'];
  visitDate: Scalars['Date']['input'];
}>;


export type GetPlanInventorySeatsQuery = { restaurant: { plan: { inventory: Array<{ visitTime: scalars.HourMinute, seats: Array<{ ' $fragmentRefs'?: { 'PlanSeatFragment': PlanSeatFragment } }> }> } | null } | null };

export type GetPlanSeatsQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type GetPlanSeatsQuery = { restaurant: { plan: { seats: Array<{ ' $fragmentRefs'?: { 'PlanSeatFragment': PlanSeatFragment } }> } | null } | null };

export type GetRestaurantCalendarContextQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRestaurantCalendarContextQuery = { restaurant: { ' $fragmentRefs'?: { 'RestaurantCalendarFragment': RestaurantCalendarFragment;'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'PlanRestaurantNotesFragment': PlanRestaurantNotesFragment;'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } } | null };

export type GetRestaurantPlanDetailContextQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRestaurantPlanDetailContextQuery = { restaurant: { ' $fragmentRefs'?: { 'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'PlanRestaurantNotesFragment': PlanRestaurantNotesFragment;'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } } | null };

export type GetRestaurantPlanContextQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  planId: Scalars['PlanId']['input'];
}>;


export type GetRestaurantPlanContextQuery = { restaurant: (
    { plan: (
      { course: { ' $fragmentRefs'?: { 'CourseSelectionInfoFragment': CourseSelectionInfoFragment } } }
      & { ' $fragmentRefs'?: { 'PlanSelectionInfoFragment': PlanSelectionInfoFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'RestaurantCalendarFragment': RestaurantCalendarFragment;'RestaurantMainInfoFragmentFragment': RestaurantMainInfoFragmentFragment;'RestaurantSubInfoFragmentFragment': RestaurantSubInfoFragmentFragment;'PlanRestaurantNotesFragment': PlanRestaurantNotesFragment;'PlanRestaurantAllowDiscountOnReservationFragment': PlanRestaurantAllowDiscountOnReservationFragment } }
  ) | null };

export type GetRestaurantRatingQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
}>;


export type GetRestaurantRatingQuery = { restaurant: { ' $fragmentRefs'?: { 'RestaurantRatingFragment': RestaurantRatingFragment } } | null };

export type GetCalendarQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableCalendarInput;
}>;


export type GetCalendarQuery = { restaurant: { reservableCalendar: Array<{ ' $fragmentRefs'?: { 'ReservableCalendarItemFragment': ReservableCalendarItemFragment } }> } | null };

export type GetTimesQueryVariables = Exact<{
  restaurantId: Scalars['RestaurantId']['input'];
  input: ReservableTimesInput;
}>;


export type GetTimesQuery = { restaurant: { reservableTimes: Array<scalars.HourMinute> } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const RestaurantBreadcrumbsFragmentDoc = new TypedDocumentString(`
    fragment RestaurantBreadcrumbs on Restaurant {
  name
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
    `, {"fragmentName":"RestaurantBreadcrumbs"}) as unknown as TypedDocumentString<RestaurantBreadcrumbsFragment, unknown>;
export const ReservableCalendarItemFragmentDoc = new TypedDocumentString(`
    fragment ReservableCalendarItem on ReservableCalendar {
  mealPeriod
  dates {
    calendarDate {
      date
      holiday
      dayOfWeek
    }
    reservable
    hasClosedInventory
    reservableVisitorsCount
  }
}
    `, {"fragmentName":"ReservableCalendarItem"}) as unknown as TypedDocumentString<ReservableCalendarItemFragment, unknown>;
export const RestaurantTwoWeeksCalendarFragmentDoc = new TypedDocumentString(`
    fragment RestaurantTwoWeeksCalendar on Restaurant {
  phoneNumber
}
    `, {"fragmentName":"RestaurantTwoWeeksCalendar"}) as unknown as TypedDocumentString<RestaurantTwoWeeksCalendarFragment, unknown>;
export const CourseSelectionInfoFragmentDoc = new TypedDocumentString(`
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
    `, {"fragmentName":"CourseSelectionInfo"}) as unknown as TypedDocumentString<CourseSelectionInfoFragment, unknown>;
export const PlanDetailChildMenuItemFragmentDoc = new TypedDocumentString(`
    fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
    `, {"fragmentName":"PlanDetailChildMenuItem"}) as unknown as TypedDocumentString<PlanDetailChildMenuItemFragment, unknown>;
export const PlanDetailOptionItemFragmentDoc = new TypedDocumentString(`
    fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
    `, {"fragmentName":"PlanDetailOptionItem"}) as unknown as TypedDocumentString<PlanDetailOptionItemFragment, unknown>;
export const PlanListPriceItemFragmentDoc = new TypedDocumentString(`
    fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
    `, {"fragmentName":"PlanListPriceItem"}) as unknown as TypedDocumentString<PlanListPriceItemFragment, unknown>;
export const RestaurantCancelPolicyItemFragmentDoc = new TypedDocumentString(`
    fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
    `, {"fragmentName":"RestaurantCancelPolicyItem"}) as unknown as TypedDocumentString<RestaurantCancelPolicyItemFragment, unknown>;
export const SharePlanFragmentFragmentDoc = new TypedDocumentString(`
    fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}
    `, {"fragmentName":"SharePlanFragment"}) as unknown as TypedDocumentString<SharePlanFragmentFragment, unknown>;
export const PlanSelectionInfoFragmentDoc = new TypedDocumentString(`
    fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
    fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`, {"fragmentName":"PlanSelectionInfo"}) as unknown as TypedDocumentString<PlanSelectionInfoFragment, unknown>;
export const PlanAttributesFragmentDoc = new TypedDocumentString(`
    fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
    `, {"fragmentName":"PlanAttributes"}) as unknown as TypedDocumentString<PlanAttributesFragment, unknown>;
export const SeatAttributesFragmentDoc = new TypedDocumentString(`
    fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
    `, {"fragmentName":"SeatAttributes"}) as unknown as TypedDocumentString<SeatAttributesFragment, unknown>;
export const RestaurantInventoryCourseFragmentDoc = new TypedDocumentString(`
    fragment RestaurantInventoryCourse on RestaurantInventoryCourse {
  course {
    ...CourseSelectionInfo
  }
  plans {
    plan {
      ...PlanSelectionInfo
      ...PlanAttributes
    }
    seats {
      ...SeatAttributes
    }
    price
    discountRatePercent
    pointRatePercent
    fixedPoints
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`, {"fragmentName":"RestaurantInventoryCourse"}) as unknown as TypedDocumentString<RestaurantInventoryCourseFragment, unknown>;
export const PlanSearchPriceFragmentDoc = new TypedDocumentString(`
    fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
    `, {"fragmentName":"PlanSearchPrice"}) as unknown as TypedDocumentString<PlanSearchPriceFragment, unknown>;
export const RestaurantSearchCourseFragmentDoc = new TypedDocumentString(`
    fragment RestaurantSearchCourse on Course {
  ...CourseSelectionInfo
  searchPlans(input: $searchInput) {
    edges {
      seats {
        ...SeatAttributes
      }
      node {
        ...PlanSelectionInfo
        ...PlanAttributes
        searchPrice(input: $searchInput) {
          ...PlanSearchPrice
        }
      }
    }
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`, {"fragmentName":"RestaurantSearchCourse"}) as unknown as TypedDocumentString<RestaurantSearchCourseFragment, unknown>;
export const InventoryCalendarItemFragmentDoc = new TypedDocumentString(`
    fragment InventoryCalendarItem on PlanInventoryCalendar {
  date {
    date
    holiday
    dayOfWeek
  }
  inventory {
    visitTime
    price
    seats {
      seatId
    }
    discountRatePercent
  }
}
    `, {"fragmentName":"InventoryCalendarItem"}) as unknown as TypedDocumentString<InventoryCalendarItemFragment, unknown>;
export const PlanRestaurantNotesFragmentDoc = new TypedDocumentString(`
    fragment PlanRestaurantNotes on Restaurant {
  notes
}
    `, {"fragmentName":"PlanRestaurantNotes"}) as unknown as TypedDocumentString<PlanRestaurantNotesFragment, unknown>;
export const RestaurantCalendarFragmentDoc = new TypedDocumentString(`
    fragment RestaurantCalendar on Restaurant {
  phoneNumber
}
    `, {"fragmentName":"RestaurantCalendar"}) as unknown as TypedDocumentString<RestaurantCalendarFragment, unknown>;
export const CouponFragmentDoc = new TypedDocumentString(`
    fragment Coupon on DiscountCoupon {
  code
  name
  discountAmount
  minimumReservationAmount
  viewerAcquired
  reservablePeriod {
    from
    to
  }
  visitablePeriod {
    from
    to
  }
  usableMemberCount
}
    `, {"fragmentName":"Coupon"}) as unknown as TypedDocumentString<CouponFragment, unknown>;
export const RestaurantPriceRangeFragmentDoc = new TypedDocumentString(`
    fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
    `, {"fragmentName":"RestaurantPriceRange"}) as unknown as TypedDocumentString<RestaurantPriceRangeFragment, unknown>;
export const FavoriteRestaurantFragmentFragmentDoc = new TypedDocumentString(`
    fragment FavoriteRestaurantFragment on Restaurant {
  restaurantId
  name
  status
  images: images2(first: 1) {
    url
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  rating {
    totalValue
    totalCount
  }
  ...RestaurantPriceRange
}
    fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}`, {"fragmentName":"FavoriteRestaurantFragment"}) as unknown as TypedDocumentString<FavoriteRestaurantFragmentFragment, unknown>;
export const PlanRestaurantAllowDiscountOnReservationFragmentDoc = new TypedDocumentString(`
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
    `, {"fragmentName":"PlanRestaurantAllowDiscountOnReservation"}) as unknown as TypedDocumentString<PlanRestaurantAllowDiscountOnReservationFragment, unknown>;
export const FavoritePlanFragmentFragmentDoc = new TypedDocumentString(`
    fragment FavoritePlanFragment on PlanWithPriceEdge {
  node {
    planId
    course {
      name
      images {
        url
      }
    }
    additionalContents
    restrictions
    mealPeriod
    restaurant {
      restaurantId
      name
      area {
        displayName
      }
      genre {
        displayName
      }
      rating {
        totalValue
        totalCount
      }
      ...PlanRestaurantAllowDiscountOnReservation
    }
    listPrice
    isSeatOnly
  }
  price {
    bestPrice
    priceVaried
    discountPercent
    pointRatePercent
    fixedPoints
  }
  timesaleLabel
}
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}`, {"fragmentName":"FavoritePlanFragment"}) as unknown as TypedDocumentString<FavoritePlanFragmentFragment, unknown>;
export const RestaurantAnnouncementFragmentDoc = new TypedDocumentString(`
    fragment RestaurantAnnouncement on Restaurant {
  announcement {
    title
    content
    url
  }
}
    `, {"fragmentName":"RestaurantAnnouncement"}) as unknown as TypedDocumentString<RestaurantAnnouncementFragment, unknown>;
export const RestaurantGuideTitleFragmentDoc = new TypedDocumentString(`
    fragment RestaurantGuideTitle on Restaurant {
  restaurantId
  name
  isCasual
  area {
    largeCode
  }
  genre {
    displayName
  }
}
    `, {"fragmentName":"RestaurantGuideTitle"}) as unknown as TypedDocumentString<RestaurantGuideTitleFragment, unknown>;
export const KiwaminoArticleInfoFragmentDoc = new TypedDocumentString(`
    fragment KiwaminoArticleInfo on KiwaminoArticle {
  articleId
  title
  content
  postedAt
  thumbnailUrl
}
    `, {"fragmentName":"KiwaminoArticleInfo"}) as unknown as TypedDocumentString<KiwaminoArticleInfoFragment, unknown>;
export const RestaurantNearbySpotsFragmentDoc = new TypedDocumentString(`
    fragment RestaurantNearbySpots on Restaurant {
  nearbySpots {
    spotId
    name
    type
    minimumArea {
      code
      parent {
        code
        parent {
          key
        }
      }
    }
  }
}
    `, {"fragmentName":"RestaurantNearbySpots"}) as unknown as TypedDocumentString<RestaurantNearbySpotsFragment, unknown>;
export const RestaurantMetadataFragmentDoc = new TypedDocumentString(`
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
    `, {"fragmentName":"RestaurantMetadata"}) as unknown as TypedDocumentString<RestaurantMetadataFragment, unknown>;
export const RestaurantGenreFragmentDoc = new TypedDocumentString(`
    fragment RestaurantGenre on Restaurant {
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
    `, {"fragmentName":"RestaurantGenre"}) as unknown as TypedDocumentString<RestaurantGenreFragment, unknown>;
export const RestaurantAreaFragmentDoc = new TypedDocumentString(`
    fragment RestaurantArea on Restaurant {
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
}
    `, {"fragmentName":"RestaurantArea"}) as unknown as TypedDocumentString<RestaurantAreaFragment, unknown>;
export const RestaurantRatingFragmentDoc = new TypedDocumentString(`
    fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}
    `, {"fragmentName":"RestaurantRating"}) as unknown as TypedDocumentString<RestaurantRatingFragment, unknown>;
export const RestaurantAreaReviewRankingItemFragmentDoc = new TypedDocumentString(`
    fragment RestaurantAreaReviewRankingItem on RestaurantAreaReviewRanking {
  rank
  total
  minimumArea {
    code
    name
    parent {
      code
      parent {
        key
      }
    }
  }
}
    `, {"fragmentName":"RestaurantAreaReviewRankingItem"}) as unknown as TypedDocumentString<RestaurantAreaReviewRankingItemFragment, unknown>;
export const RestaurantSummaryFragmentDoc = new TypedDocumentString(`
    fragment RestaurantSummary on Restaurant {
  name
  genre {
    displayName
  }
  ...RestaurantGenre
  isCasual
  paypayAvailable
  pointAvailable
  ...RestaurantArea
  supportsInventoryNotification
  catchphraseText
  introductionText
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
  ...RestaurantRating
  areaReviewRanking {
    ...RestaurantAreaReviewRankingItem
  }
  isReviewHidden
}
    fragment RestaurantArea on Restaurant {
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
}
fragment RestaurantGenre on Restaurant {
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
fragment RestaurantAreaReviewRankingItem on RestaurantAreaReviewRanking {
  rank
  total
  minimumArea {
    code
    name
    parent {
      code
      parent {
        key
      }
    }
  }
}
fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}`, {"fragmentName":"RestaurantSummary"}) as unknown as TypedDocumentString<RestaurantSummaryFragment, unknown>;
export const RestaurantRelatedTagsFragmentDoc = new TypedDocumentString(`
    fragment RestaurantRelatedTags on Restaurant {
  relatedTags {
    type
    tagId
    name
  }
}
    `, {"fragmentName":"RestaurantRelatedTags"}) as unknown as TypedDocumentString<RestaurantRelatedTagsFragment, unknown>;
export const SupremeRestaurantFragmentDoc = new TypedDocumentString(`
    fragment SupremeRestaurant on Restaurant {
  isSupreme
}
    `, {"fragmentName":"SupremeRestaurant"}) as unknown as TypedDocumentString<SupremeRestaurantFragment, unknown>;
export const RestaurantMenuRootFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantMenuRootFragment on RestaurantMenuRoot {
  sections {
    title
    description
    items {
      name
      description
      price
      isRecommended
    }
  }
  updatedDate
}
    `, {"fragmentName":"RestaurantMenuRootFragment"}) as unknown as TypedDocumentString<RestaurantMenuRootFragmentFragment, unknown>;
export const RestaurantMenusFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantMenusFragment on Restaurant {
  menus {
    course {
      ...RestaurantMenuRootFragment
    }
    aLaCarte {
      ...RestaurantMenuRootFragment
    }
    drink {
      ...RestaurantMenuRootFragment
    }
  }
}
    fragment RestaurantMenuRootFragment on RestaurantMenuRoot {
  sections {
    title
    description
    items {
      name
      description
      price
      isRecommended
    }
  }
  updatedDate
}`, {"fragmentName":"RestaurantMenusFragment"}) as unknown as TypedDocumentString<RestaurantMenusFragmentFragment, unknown>;
export const RestaurantCoordinateFragmentDoc = new TypedDocumentString(`
    fragment RestaurantCoordinate on Restaurant {
  longitude
  latitude
  zoom
}
    `, {"fragmentName":"RestaurantCoordinate"}) as unknown as TypedDocumentString<RestaurantCoordinateFragment, unknown>;
export const ReviewsNodesFragmentDoc = new TypedDocumentString(`
    fragment ReviewsNodes on Review2 {
  __typename
  ... on Review {
    handleName
    userComment
    restaurantComment
    userPostDate
    memberHash
    mealPeriod
    planName
    rating {
      totalValue
      food
      service
      atmosphere
      costPerformance
    }
    useScene
  }
  ... on LyReview {
    handleName
    userComment
    restaurantComment
    userPostDate
    totalValue: rating
  }
}
    `, {"fragmentName":"ReviewsNodes"}) as unknown as TypedDocumentString<ReviewsNodesFragment, unknown>;
export const RestaurantRecommendCardFragmentDoc = new TypedDocumentString(`
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}
    `, {"fragmentName":"RestaurantRecommendCard"}) as unknown as TypedDocumentString<RestaurantRecommendCardFragment, unknown>;
export const RestaurantNearbyRestaurantsFragmentDoc = new TypedDocumentString(`
    fragment RestaurantNearbyRestaurants on Restaurant {
  nearbyRestaurants(first: 5) {
    ...RestaurantRecommendCard
  }
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}`, {"fragmentName":"RestaurantNearbyRestaurants"}) as unknown as TypedDocumentString<RestaurantNearbyRestaurantsFragment, unknown>;
export const RestaurantFaqFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantFaqFragment on Restaurant {
  openingHoursText
}
    `, {"fragmentName":"RestaurantFaqFragment"}) as unknown as TypedDocumentString<RestaurantFaqFragmentFragment, unknown>;
export const RestaurantHighlightsFragmentDoc = new TypedDocumentString(`
    fragment RestaurantHighlights on Restaurant {
  restaurantId
  highlights {
    title
    description
    imageAlt
    image {
      url
    }
  }
}
    `, {"fragmentName":"RestaurantHighlights"}) as unknown as TypedDocumentString<RestaurantHighlightsFragment, unknown>;
export const RestaurantIntroductionFragmentDoc = new TypedDocumentString(`
    fragment RestaurantIntroduction on Restaurant {
  catchphraseText
  introductionText
}
    `, {"fragmentName":"RestaurantIntroduction"}) as unknown as TypedDocumentString<RestaurantIntroductionFragment, unknown>;
export const RestaurantPaymentInfoFragmentDoc = new TypedDocumentString(`
    fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
    `, {"fragmentName":"RestaurantPaymentInfo"}) as unknown as TypedDocumentString<RestaurantPaymentInfoFragment, unknown>;
export const RestaurantInfoNameFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
    `, {"fragmentName":"RestaurantInfoNameFragment"}) as unknown as TypedDocumentString<RestaurantInfoNameFragmentFragment, unknown>;
export const RestaurantAddressFragmentDoc = new TypedDocumentString(`
    fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
    `, {"fragmentName":"RestaurantAddress"}) as unknown as TypedDocumentString<RestaurantAddressFragment, unknown>;
export const RestaurantAccessesFragmentDoc = new TypedDocumentString(`
    fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}
    `, {"fragmentName":"RestaurantAccesses"}) as unknown as TypedDocumentString<RestaurantAccessesFragment, unknown>;
export const RestaurantMainInfoFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
    fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`, {"fragmentName":"RestaurantMainInfoFragment"}) as unknown as TypedDocumentString<RestaurantMainInfoFragmentFragment, unknown>;
export const ChildAvailabilityItemFragmentDoc = new TypedDocumentString(`
    fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
    `, {"fragmentName":"ChildAvailabilityItem"}) as unknown as TypedDocumentString<ChildAvailabilityItemFragment, unknown>;
export const RestaurantSubInfoFragmentFragmentDoc = new TypedDocumentString(`
    fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
    fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}`, {"fragmentName":"RestaurantSubInfoFragment"}) as unknown as TypedDocumentString<RestaurantSubInfoFragmentFragment, unknown>;
export const MenuTextFragmentDoc = new TypedDocumentString(`
    fragment MenuText on Plan {
  description
  course {
    menuText
  }
}
    `, {"fragmentName":"MenuText"}) as unknown as TypedDocumentString<MenuTextFragment, unknown>;
export const PlanLineFragmentDoc = new TypedDocumentString(`
    fragment PlanLine on Plan {
  planId
  isSeatOnly
  mealPeriod
  course {
    name
  }
  listPrice
  additionalContents
  restrictions
  paymentType
  memberLimitType
  isRequestReservation
  isCancelGuard
  timesale {
    visibleLabel
  }
  ...MenuText @include(if: $withMenuText)
  searchPrice(input: $searchInput) {
    ...PlanSearchPrice
  }
  inventory(visitDate: $visitDate, visitorsCount: $visitorsCount) @include(if: $withPlanInventory) {
    __typename
  }
}
    fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment MenuText on Plan {
  description
  course {
    menuText
  }
}`, {"fragmentName":"PlanLine"}) as unknown as TypedDocumentString<PlanLineFragment, unknown>;
export const ExtendedSearchInterpretationFragmentDoc = new TypedDocumentString(`
    fragment ExtendedSearchInterpretation on ExtendedSearchInterpretation {
  __typename
  ... on ExtendedSearchInterpretationSpot {
    name
    radius
  }
  ... on ExtendedSearchInterpretationLocation {
    name
    radius
  }
}
    `, {"fragmentName":"ExtendedSearchInterpretation"}) as unknown as TypedDocumentString<ExtendedSearchInterpretationFragment, unknown>;
export const RestaurantCardImageFragmentDoc = new TypedDocumentString(`
    fragment RestaurantCardImage on Restaurant {
  restaurantId
  images {
    url
    name
  }
}
    `, {"fragmentName":"RestaurantCardImage"}) as unknown as TypedDocumentString<RestaurantCardImageFragment, unknown>;
export const RestaurantIkyuDaySettingFragmentDoc = new TypedDocumentString(`
    fragment RestaurantIkyuDaySetting on Restaurant {
  restaurantId
  ikyuDaySetting: activePointRewardSetting(programId: "3") {
    reservablePeriod {
      from
      to
    }
  }
}
    `, {"fragmentName":"RestaurantIkyuDaySetting"}) as unknown as TypedDocumentString<RestaurantIkyuDaySettingFragment, unknown>;
export const ReviewSummaryFragmentDoc = new TypedDocumentString(`
    fragment ReviewSummary on Restaurant {
  restaurantId
  isReviewHidden
  rating {
    totalCount
    totalValue
  }
}
    `, {"fragmentName":"ReviewSummary"}) as unknown as TypedDocumentString<ReviewSummaryFragment, unknown>;
export const RestaurantPhoneNumberFragmentDoc = new TypedDocumentString(`
    fragment RestaurantPhoneNumber on Restaurant {
  phoneNumber
}
    `, {"fragmentName":"RestaurantPhoneNumber"}) as unknown as TypedDocumentString<RestaurantPhoneNumberFragment, unknown>;
export const RestaurantPickupReviewFragmentDoc = new TypedDocumentString(`
    fragment RestaurantPickupReview on Restaurant {
  restaurantId
  pickupReview {
    handleName
    userComment
  }
  isReviewHidden
}
    `, {"fragmentName":"RestaurantPickupReview"}) as unknown as TypedDocumentString<RestaurantPickupReviewFragment, unknown>;
export const RestaurantCardFragmentDoc = new TypedDocumentString(`
    fragment RestaurantCard on Restaurant {
  restaurantId
  name
  isCasual
  genre {
    displayName
  }
  area {
    displayName
  }
  description
  ...PlanRestaurantAllowDiscountOnReservation
  ...RestaurantCardImage
  ...RestaurantIkyuDaySetting
  ...ReviewSummary
  ...RestaurantAccesses
  ...RestaurantPriceRange
  ...RestaurantPhoneNumber
  ...RestaurantPickupReview @include(if: $withPickupReview)
}
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
fragment RestaurantPickupReview on Restaurant {
  restaurantId
  pickupReview {
    handleName
    userComment
  }
  isReviewHidden
}
fragment ReviewSummary on Restaurant {
  restaurantId
  isReviewHidden
  rating {
    totalCount
    totalValue
  }
}
fragment RestaurantCardImage on Restaurant {
  restaurantId
  images {
    url
    name
  }
}
fragment RestaurantPhoneNumber on Restaurant {
  phoneNumber
}
fragment RestaurantIkyuDaySetting on Restaurant {
  restaurantId
  ikyuDaySetting: activePointRewardSetting(programId: "3") {
    reservablePeriod {
      from
      to
    }
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`, {"fragmentName":"RestaurantCard"}) as unknown as TypedDocumentString<RestaurantCardFragment, unknown>;
export const RestaurantGuidePhotosFragmentDoc = new TypedDocumentString(`
    fragment RestaurantGuidePhotos on Restaurant {
  restaurantId
  name
  images {
    url
    name
    category
  }
}
    `, {"fragmentName":"RestaurantGuidePhotos"}) as unknown as TypedDocumentString<RestaurantGuidePhotosFragment, unknown>;
export const SeatForLabelFragmentDoc = new TypedDocumentString(`
    fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}
    `, {"fragmentName":"SeatForLabel"}) as unknown as TypedDocumentString<SeatForLabelFragment, unknown>;
export const PlanSeatFragmentDoc = new TypedDocumentString(`
    fragment PlanSeat on Seat {
  seatId
  seatTypeDescription
  image {
    url
    name
  }
  charge {
    __typename
    ... on SeatChargePerTable {
      price
    }
    ... on SeatChargePerPerson {
      price
    }
  }
  ...SeatForLabel
}
    fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`, {"fragmentName":"PlanSeat"}) as unknown as TypedDocumentString<PlanSeatFragment, unknown>;
export const PlanDetailMetadataFragmentDoc = new TypedDocumentString(`
    fragment PlanDetailMetadata on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
    images {
      url
    }
  }
  mealPeriod
  description
  restaurant {
    name
    status
    isTest
  }
}
    `, {"fragmentName":"PlanDetailMetadata"}) as unknown as TypedDocumentString<PlanDetailMetadataFragment, unknown>;
export const PlanDetailInventoryPlanItemFragmentDoc = new TypedDocumentString(`
    fragment PlanDetailInventoryPlanItem on ReservableTime {
  visitTime
  price
  discountRatePercent
  pointRatePercent
}
    `, {"fragmentName":"PlanDetailInventoryPlanItem"}) as unknown as TypedDocumentString<PlanDetailInventoryPlanItemFragment, unknown>;
export const ReserveSuccessFragmentDoc = new TypedDocumentString(`
    fragment ReserveSuccess on ReserveOk {
  reservation {
    reservationId
    restaurant {
      name
    }
    visitDate
    visitTime
    visitorsCount
  }
  firstTimeReserve
  affiliateSiteConversionTag
}
    `, {"fragmentName":"ReserveSuccess"}) as unknown as TypedDocumentString<ReserveSuccessFragment, unknown>;
export const MemberDiscountCouponsFragmentDoc = new TypedDocumentString(`
    fragment MemberDiscountCoupons on ReserveInfoMember {
  discountCoupons {
    code
    name
    discountAmount
    minimumReservationAmount
    viewerAcquired
    reservablePeriod {
      from
      to
    }
    visitablePeriod {
      from
      to
    }
    usableMemberCount
  }
}
    `, {"fragmentName":"MemberDiscountCoupons"}) as unknown as TypedDocumentString<MemberDiscountCouponsFragment, unknown>;
export const MemberCardsFragmentDoc = new TypedDocumentString(`
    fragment MemberCards on ReserveInfoMember {
  cards {
    cardId
    maskedNumber
    goodThru
    holderName
    brand
    isPrimary
  }
}
    `, {"fragmentName":"MemberCards"}) as unknown as TypedDocumentString<MemberCardsFragment, unknown>;
export const ReserveInfoMemberFragmentDoc = new TypedDocumentString(`
    fragment ReserveInfoMember on ReserveInfo {
  member {
    __typename
    name
    nameKana
    phoneNumber
    email
    ...MemberDiscountCoupons
    ...MemberCards
    paypay {
      __typename
      ... on PaypayAvailable {
        balance
      }
      ... on PaypayUnavailable {
        cause
      }
      __typename
    }
    totalPoint
    usablePoint
    mailMagazineSubscription {
      restaurant
      point
      present
    }
  }
}
    fragment MemberCards on ReserveInfoMember {
  cards {
    cardId
    maskedNumber
    goodThru
    holderName
    brand
    isPrimary
  }
}
fragment MemberDiscountCoupons on ReserveInfoMember {
  discountCoupons {
    code
    name
    discountAmount
    minimumReservationAmount
    viewerAcquired
    reservablePeriod {
      from
      to
    }
    visitablePeriod {
      from
      to
    }
    usableMemberCount
  }
}`, {"fragmentName":"ReserveInfoMember"}) as unknown as TypedDocumentString<ReserveInfoMemberFragment, unknown>;
export const PlanRestaurantFragmentDoc = new TypedDocumentString(`
    fragment PlanRestaurant on Plan {
  restaurant {
    name
    paypayAvailable
    pointAvailable
    cardPaymentAvailable
    notes
    noncancelableDays
  }
}
    `, {"fragmentName":"PlanRestaurant"}) as unknown as TypedDocumentString<PlanRestaurantFragment, unknown>;
export const CancelPolicyPoliciesFragmentDoc = new TypedDocumentString(`
    fragment CancelPolicyPolicies on CancelPolicyStructured {
  policies {
    __typename
    appliesToVisitorDecrement
    charge {
      __typename
      ... on CancelPolicyChargeRate {
        rate
      }
      ... on CancelPolicyChargeFee {
        fee
      }
    }
    ... on CancelPolicyItemDaysBefore {
      days
      time
    }
  }
}
    `, {"fragmentName":"CancelPolicyPolicies"}) as unknown as TypedDocumentString<CancelPolicyPoliciesFragment, unknown>;
export const PlanCancelPolicyFragmentDoc = new TypedDocumentString(`
    fragment PlanCancelPolicy on Plan {
  cancelPolicy: cancelPolicy3 {
    __typename
    ... on CancelPolicyStructured {
      cancelPolicyId
      version
      note
      ...CancelPolicyPolicies
    }
    ... on CancelPolicyText {
      text
    }
  }
}
    fragment CancelPolicyPolicies on CancelPolicyStructured {
  policies {
    __typename
    appliesToVisitorDecrement
    charge {
      __typename
      ... on CancelPolicyChargeRate {
        rate
      }
      ... on CancelPolicyChargeFee {
        fee
      }
    }
    ... on CancelPolicyItemDaysBefore {
      days
      time
    }
  }
}`, {"fragmentName":"PlanCancelPolicy"}) as unknown as TypedDocumentString<PlanCancelPolicyFragment, unknown>;
export const ReserveInfoPlanFragmentDoc = new TypedDocumentString(`
    fragment ReserveInfoPlan on ReserveInfo {
  plan {
    planId
    version
    additionalContents
    restrictions
    paymentType
    notes
    isRequestReservation
    description
    isSeatOnly
    isCancelGuard
    price
    ...PlanRestaurant
    ...PlanCancelPolicy
    timesale {
      visibleLabel
    }
    course {
      name
      menuText
      images {
        url
        name
      }
    }
  }
}
    fragment CancelPolicyPolicies on CancelPolicyStructured {
  policies {
    __typename
    appliesToVisitorDecrement
    charge {
      __typename
      ... on CancelPolicyChargeRate {
        rate
      }
      ... on CancelPolicyChargeFee {
        fee
      }
    }
    ... on CancelPolicyItemDaysBefore {
      days
      time
    }
  }
}
fragment PlanCancelPolicy on Plan {
  cancelPolicy: cancelPolicy3 {
    __typename
    ... on CancelPolicyStructured {
      cancelPolicyId
      version
      note
      ...CancelPolicyPolicies
    }
    ... on CancelPolicyText {
      text
    }
  }
}
fragment PlanRestaurant on Plan {
  restaurant {
    name
    paypayAvailable
    pointAvailable
    cardPaymentAvailable
    notes
    noncancelableDays
  }
}`, {"fragmentName":"ReserveInfoPlan"}) as unknown as TypedDocumentString<ReserveInfoPlanFragment, unknown>;
export const ReserveInfoChildMenusFragmentDoc = new TypedDocumentString(`
    fragment ReserveInfoChildMenus on ReserveInfo {
  childMenus {
    childMenuId
    name
    price
    image {
      url
      name
    }
    description
    maxOrderPerReservation
  }
}
    `, {"fragmentName":"ReserveInfoChildMenus"}) as unknown as TypedDocumentString<ReserveInfoChildMenusFragment, unknown>;
export const ReserveInfoOptionMenusFragmentDoc = new TypedDocumentString(`
    fragment ReserveInfoOptionMenus on ReserveInfo {
  optionMenus {
    availability
    optionMenu {
      optionMenuId
      name
      price
      image {
        url
        name
      }
      description
      maxOrderPerReservation
    }
  }
}
    `, {"fragmentName":"ReserveInfoOptionMenus"}) as unknown as TypedDocumentString<ReserveInfoOptionMenusFragment, unknown>;
export const InventorySeatsFragmentDoc = new TypedDocumentString(`
    fragment InventorySeats on ReservableTime {
  seats {
    seatId
    type
    seatTypeLabel
    attributes
    smokingAllowed
    seatTypeDescription
    description
    bookingType
    capacity
    childUse
    image {
      url
      name
      category
    }
    charge {
      __typename
      ... on SeatChargePerTable {
        price
      }
      ... on SeatChargePerPerson {
        price
      }
    }
    ...SeatForLabel
  }
}
    fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`, {"fragmentName":"InventorySeats"}) as unknown as TypedDocumentString<InventorySeatsFragment, unknown>;
export const PlanReserveInfoFragmentDoc = new TypedDocumentString(`
    fragment PlanReserveInfo on ReserveInfo {
  visitDate
  visitTime
  visitorsCount
  discountCouponValidationHash
  duplicateReserveCount
  toyotaFinanceMaintenance
  gmoMaintenance
  paypayMaintenanceMessage
  paypayNoticeMessage
  ...ReserveInfoMember
  ...ReserveInfoPlan
  ...ReserveInfoChildMenus
  ...ReserveInfoOptionMenus
  point {
    seatOnlyFixedPoint
    courseFixedPoint
    rate
  }
  affiliateSiteForm {
    title
    notes
  }
  inventory {
    visitTime
    price
    discountRatePercent
    ...InventorySeats
  }
}
    fragment CancelPolicyPolicies on CancelPolicyStructured {
  policies {
    __typename
    appliesToVisitorDecrement
    charge {
      __typename
      ... on CancelPolicyChargeRate {
        rate
      }
      ... on CancelPolicyChargeFee {
        fee
      }
    }
    ... on CancelPolicyItemDaysBefore {
      days
      time
    }
  }
}
fragment InventorySeats on ReservableTime {
  seats {
    seatId
    type
    seatTypeLabel
    attributes
    smokingAllowed
    seatTypeDescription
    description
    bookingType
    capacity
    childUse
    image {
      url
      name
      category
    }
    charge {
      __typename
      ... on SeatChargePerTable {
        price
      }
      ... on SeatChargePerPerson {
        price
      }
    }
    ...SeatForLabel
  }
}
fragment MemberCards on ReserveInfoMember {
  cards {
    cardId
    maskedNumber
    goodThru
    holderName
    brand
    isPrimary
  }
}
fragment MemberDiscountCoupons on ReserveInfoMember {
  discountCoupons {
    code
    name
    discountAmount
    minimumReservationAmount
    viewerAcquired
    reservablePeriod {
      from
      to
    }
    visitablePeriod {
      from
      to
    }
    usableMemberCount
  }
}
fragment PlanCancelPolicy on Plan {
  cancelPolicy: cancelPolicy3 {
    __typename
    ... on CancelPolicyStructured {
      cancelPolicyId
      version
      note
      ...CancelPolicyPolicies
    }
    ... on CancelPolicyText {
      text
    }
  }
}
fragment PlanRestaurant on Plan {
  restaurant {
    name
    paypayAvailable
    pointAvailable
    cardPaymentAvailable
    notes
    noncancelableDays
  }
}
fragment ReserveInfoChildMenus on ReserveInfo {
  childMenus {
    childMenuId
    name
    price
    image {
      url
      name
    }
    description
    maxOrderPerReservation
  }
}
fragment ReserveInfoMember on ReserveInfo {
  member {
    __typename
    name
    nameKana
    phoneNumber
    email
    ...MemberDiscountCoupons
    ...MemberCards
    paypay {
      __typename
      ... on PaypayAvailable {
        balance
      }
      ... on PaypayUnavailable {
        cause
      }
      __typename
    }
    totalPoint
    usablePoint
    mailMagazineSubscription {
      restaurant
      point
      present
    }
  }
}
fragment ReserveInfoOptionMenus on ReserveInfo {
  optionMenus {
    availability
    optionMenu {
      optionMenuId
      name
      price
      image {
        url
        name
      }
      description
      maxOrderPerReservation
    }
  }
}
fragment ReserveInfoPlan on ReserveInfo {
  plan {
    planId
    version
    additionalContents
    restrictions
    paymentType
    notes
    isRequestReservation
    description
    isSeatOnly
    isCancelGuard
    price
    ...PlanRestaurant
    ...PlanCancelPolicy
    timesale {
      visibleLabel
    }
    course {
      name
      menuText
      images {
        url
        name
      }
    }
  }
}
fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`, {"fragmentName":"PlanReserveInfo"}) as unknown as TypedDocumentString<PlanReserveInfoFragment, unknown>;
export const ReserveInfoViewerFragmentDoc = new TypedDocumentString(`
    fragment ReserveInfoViewer on Viewer {
  name
  phoneNumberCertified
  loginSite
}
    `, {"fragmentName":"ReserveInfoViewer"}) as unknown as TypedDocumentString<ReserveInfoViewerFragment, unknown>;
export const ValidateCouponItemFragmentDoc = new TypedDocumentString(`
    fragment ValidateCouponItem on DiscountCoupon {
  code
  name
  discountAmount
  minimumReservationAmount
  viewerAcquired
  reservablePeriod {
    from
    to
  }
  visitablePeriod {
    from
    to
  }
  usableMemberCount
}
    `, {"fragmentName":"ValidateCouponItem"}) as unknown as TypedDocumentString<ValidateCouponItemFragment, unknown>;
export const ShareRestaurantButtonFragmentDoc = new TypedDocumentString(`
    fragment ShareRestaurantButton on Restaurant {
  restaurantId
  name
  fullAddress
}
    `, {"fragmentName":"ShareRestaurantButton"}) as unknown as TypedDocumentString<ShareRestaurantButtonFragment, unknown>;
export const GetReservableCalendarDocument = new TypedDocumentString(`
    query getReservableCalendar($restaurantId: RestaurantId!, $input: ReservableCalendarInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableCalendar(input: $input) {
      ...ReservableCalendarItem
    }
  }
}
    fragment ReservableCalendarItem on ReservableCalendar {
  mealPeriod
  dates {
    calendarDate {
      date
      holiday
      dayOfWeek
    }
    reservable
    hasClosedInventory
    reservableVisitorsCount
  }
}`) as unknown as TypedDocumentString<GetReservableCalendarQuery, GetReservableCalendarQueryVariables>;
export const GetReservableCalendarAndMealPeriodDocument = new TypedDocumentString(`
    query getReservableCalendarAndMealPeriod($restaurantId: RestaurantId!, $input: ReservableCalendarInput!, $searchInput: SearchInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableCalendar(input: $input) {
      ...ReservableCalendarItem
    }
    searchCourses(input: $searchInput) {
      nodes {
        searchPlans(input: $searchInput) {
          nodes {
            mealPeriod
          }
        }
      }
    }
  }
}
    fragment ReservableCalendarItem on ReservableCalendar {
  mealPeriod
  dates {
    calendarDate {
      date
      holiday
      dayOfWeek
    }
    reservable
    hasClosedInventory
    reservableVisitorsCount
  }
}`) as unknown as TypedDocumentString<GetReservableCalendarAndMealPeriodQuery, GetReservableCalendarAndMealPeriodQueryVariables>;
export const GetReservableCalendarWithMealPeriodDocument = new TypedDocumentString(`
    query getReservableCalendarWithMealPeriod($restaurantId: RestaurantId!, $input: ReservableCalendarInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableCalendar(input: $input) {
      ...ReservableCalendarItem
    }
  }
}
    fragment ReservableCalendarItem on ReservableCalendar {
  mealPeriod
  dates {
    calendarDate {
      date
      holiday
      dayOfWeek
    }
    reservable
    hasClosedInventory
    reservableVisitorsCount
  }
}`) as unknown as TypedDocumentString<GetReservableCalendarWithMealPeriodQuery, GetReservableCalendarWithMealPeriodQueryVariables>;
export const GetReservableTimesDocument = new TypedDocumentString(`
    query getReservableTimes($restaurantId: RestaurantId!, $input: ReservableTimesInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableTimes(input: $input)
  }
}
    `) as unknown as TypedDocumentString<GetReservableTimesQuery, GetReservableTimesQueryVariables>;
export const GetHighlightsDocument = new TypedDocumentString(`
    query GetHighlights($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    ...RestaurantMetadata
    ...RestaurantHighlights
  }
}
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantHighlights on Restaurant {
  restaurantId
  highlights {
    title
    description
    imageAlt
    image {
      url
    }
  }
}`) as unknown as TypedDocumentString<GetHighlightsQuery, GetHighlightsQueryVariables>;
export const GetReviewsPageDocument = new TypedDocumentString(`
    query GetReviewsPage($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    name
    ...RestaurantRating
    ...RestaurantMetadata
    status
    isTest
    images {
      url
    }
    isReviewHidden
  }
}
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}`) as unknown as TypedDocumentString<GetReviewsPageQuery, GetReviewsPageQueryVariables>;
export const CourseSelectionInventoryCoursesDocument = new TypedDocumentString(`
    query CourseSelectionInventoryCourses($restaurantId: RestaurantId!, $visitorsCount: Int!, $visitDate: Date!, $visitTime: HourMinute!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    name
    ...PlanRestaurantAllowDiscountOnReservation
    inventory(
      visitDate: $visitDate
      visitorsCount: $visitorsCount
      visitTime: $visitTime
    ) {
      seatOnlyPlans {
        plan {
          ...PlanSelectionInfo
          ...PlanAttributes
        }
        seats {
          ...SeatAttributes
        }
        fixedPoints
      }
      courses {
        ...RestaurantInventoryCourse
      }
    }
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment RestaurantInventoryCourse on RestaurantInventoryCourse {
  course {
    ...CourseSelectionInfo
  }
  plans {
    plan {
      ...PlanSelectionInfo
      ...PlanAttributes
    }
    seats {
      ...SeatAttributes
    }
    price
    discountRatePercent
    pointRatePercent
    fixedPoints
  }
}
fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`) as unknown as TypedDocumentString<CourseSelectionInventoryCoursesQuery, CourseSelectionInventoryCoursesQueryVariables>;
export const GetReviewedMealPeriodsDocument = new TypedDocumentString(`
    query GetReviewedMealPeriods($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    reviewedMealPeriods
  }
}
    `) as unknown as TypedDocumentString<GetReviewedMealPeriodsQuery, GetReviewedMealPeriodsQueryVariables>;
export const PlanInventoryCalendarDocument = new TypedDocumentString(`
    query PlanInventoryCalendar($restaurantId: RestaurantId!, $planId: PlanId!, $to: Date!, $visitorsCount: Int!, $input: PlanInventoryCalendarInput!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      inventoryCalendar(to: $to, visitorsCount: $visitorsCount, input: $input) {
        ...InventoryCalendarItem
      }
    }
  }
}
    fragment InventoryCalendarItem on PlanInventoryCalendar {
  date {
    date
    holiday
    dayOfWeek
  }
  inventory {
    visitTime
    price
    seats {
      seatId
    }
    discountRatePercent
  }
}`) as unknown as TypedDocumentString<PlanInventoryCalendarQuery, PlanInventoryCalendarQueryVariables>;
export const PlanReservableVisitorsCountsDocument = new TypedDocumentString(`
    query PlanReservableVisitorsCounts($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    reservableVisitorsCounts(input: {planIds: [$planId]})
    plan(planId: $planId) {
      additionalContents
      restrictions
      mealPeriod
      isSeatOnly
      course {
        name
      }
      capacityRange {
        lower
        upper
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PlanReservableVisitorsCountsQuery, PlanReservableVisitorsCountsQueryVariables>;
export const GetRestaurantAccessDocument = new TypedDocumentString(`
    query GetRestaurantAccess($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    fullAddress
    ...RestaurantMetadata
    ...RestaurantCoordinate
    ...RestaurantAccesses
  }
}
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantCoordinate on Restaurant {
  longitude
  latitude
  zoom
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetRestaurantAccessQuery, GetRestaurantAccessQueryVariables>;
export const AcquireCouponDocument = new TypedDocumentString(`
    mutation acquireCoupon($code: DiscountCouponCode!) {
  acquireDiscountCoupon(code: $code)
}
    `) as unknown as TypedDocumentString<AcquireCouponMutation, AcquireCouponMutationVariables>;
export const GetCouponListDocument = new TypedDocumentString(`
    query getCouponList($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    discountCoupons {
      ...Coupon
    }
  }
}
    fragment Coupon on DiscountCoupon {
  code
  name
  discountAmount
  minimumReservationAmount
  viewerAcquired
  reservablePeriod {
    from
    to
  }
  visitablePeriod {
    from
    to
  }
  usableMemberCount
}`) as unknown as TypedDocumentString<GetCouponListQuery, GetCouponListQueryVariables>;
export const SearchHitCountsDocument = new TypedDocumentString(`
    query searchHitCounts($input: SearchRestaurantsInput!, $tags: HitCountsTagsInput!) {
  hitCounts(input: $input, tags: $tags) {
    total
    facets {
      key
      count
    }
  }
}
    `) as unknown as TypedDocumentString<SearchHitCountsQuery, SearchHitCountsQueryVariables>;
export const SearchSuggestionsDocument = new TypedDocumentString(`
    query SearchSuggestions($keyword: String!, $first: Int!) {
  suggestions(keyword: $keyword, first: $first) {
    wordType {
      __typename
      ... on Restaurant {
        restaurantId
        name
      }
    }
    uniqueWord
  }
}
    `) as unknown as TypedDocumentString<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>;
export const MemberFavoriteListQueryDocument = new TypedDocumentString(`
    query MemberFavoriteListQuery {
  viewer: viewer2 {
    __typename
    ... on Member {
      favoriteRestaurants {
        ...FavoriteRestaurantFragment
      }
      favoritePlans {
        edges {
          ...FavoritePlanFragment
        }
      }
    }
    ... on YahooMember {
      favoriteRestaurants {
        ...FavoriteRestaurantFragment
      }
      favoritePlans {
        edges {
          ...FavoritePlanFragment
        }
      }
    }
  }
}
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
fragment FavoriteRestaurantFragment on Restaurant {
  restaurantId
  name
  status
  images: images2(first: 1) {
    url
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  rating {
    totalValue
    totalCount
  }
  ...RestaurantPriceRange
}
fragment FavoritePlanFragment on PlanWithPriceEdge {
  node {
    planId
    course {
      name
      images {
        url
      }
    }
    additionalContents
    restrictions
    mealPeriod
    restaurant {
      restaurantId
      name
      area {
        displayName
      }
      genre {
        displayName
      }
      rating {
        totalValue
        totalCount
      }
      ...PlanRestaurantAllowDiscountOnReservation
    }
    listPrice
    isSeatOnly
  }
  price {
    bestPrice
    priceVaried
    discountPercent
    pointRatePercent
    fixedPoints
  }
  timesaleLabel
}`) as unknown as TypedDocumentString<MemberFavoriteListQueryQuery, MemberFavoriteListQueryQueryVariables>;
export const GuestFavoriteListQueryDocument = new TypedDocumentString(`
    query GuestFavoriteListQuery($restaurantIds: [RestaurantId!]!, $planIds: [PlanId!]!) {
  restaurants(restaurantIds: $restaurantIds) {
    ...FavoriteRestaurantFragment
  }
  plans(planIds: $planIds) {
    edges {
      ...FavoritePlanFragment
    }
  }
}
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
fragment FavoriteRestaurantFragment on Restaurant {
  restaurantId
  name
  status
  images: images2(first: 1) {
    url
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  rating {
    totalValue
    totalCount
  }
  ...RestaurantPriceRange
}
fragment FavoritePlanFragment on PlanWithPriceEdge {
  node {
    planId
    course {
      name
      images {
        url
      }
    }
    additionalContents
    restrictions
    mealPeriod
    restaurant {
      restaurantId
      name
      area {
        displayName
      }
      genre {
        displayName
      }
      rating {
        totalValue
        totalCount
      }
      ...PlanRestaurantAllowDiscountOnReservation
    }
    listPrice
    isSeatOnly
  }
  price {
    bestPrice
    priceVaried
    discountPercent
    pointRatePercent
    fixedPoints
  }
  timesaleLabel
}`) as unknown as TypedDocumentString<GuestFavoriteListQueryQuery, GuestFavoriteListQueryQueryVariables>;
export const FavoritePlanQueryDocument = new TypedDocumentString(`
    query FavoritePlanQuery($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      viewerFavorited
    }
  }
}
    `) as unknown as TypedDocumentString<FavoritePlanQueryQuery, FavoritePlanQueryQueryVariables>;
export const FavoritePlanMutationDocument = new TypedDocumentString(`
    mutation FavoritePlanMutation($planId: PlanId!) {
  favoritePlan(planId: $planId)
}
    `) as unknown as TypedDocumentString<FavoritePlanMutationMutation, FavoritePlanMutationMutationVariables>;
export const UnfavoritePlanMutationDocument = new TypedDocumentString(`
    mutation UnfavoritePlanMutation($planId: PlanId!) {
  unfavoritePlan(planId: $planId)
}
    `) as unknown as TypedDocumentString<UnfavoritePlanMutationMutation, UnfavoritePlanMutationMutationVariables>;
export const FavoriteRestaurantQueryDocument = new TypedDocumentString(`
    query FavoriteRestaurantQuery($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    viewerFavorited
  }
}
    `) as unknown as TypedDocumentString<FavoriteRestaurantQueryQuery, FavoriteRestaurantQueryQueryVariables>;
export const FavoriteRestaurantMutationDocument = new TypedDocumentString(`
    mutation FavoriteRestaurantMutation($restaurantId: RestaurantId!) {
  favoriteRestaurant(restaurantId: $restaurantId)
}
    `) as unknown as TypedDocumentString<FavoriteRestaurantMutationMutation, FavoriteRestaurantMutationMutationVariables>;
export const UnfavoriteRestaurantMutationDocument = new TypedDocumentString(`
    mutation UnfavoriteRestaurantMutation($restaurantId: RestaurantId!) {
  unfavoriteRestaurant(restaurantId: $restaurantId)
}
    `) as unknown as TypedDocumentString<UnfavoriteRestaurantMutationMutation, UnfavoriteRestaurantMutationMutationVariables>;
export const GetReviewsDocument = new TypedDocumentString(`
    query GetReviews($restaurantId: RestaurantId!, $first: Int!, $offset: Int!, $mealPeriod: MealPeriod) {
  restaurant(restaurantId: $restaurantId) {
    reviews2(input: {first: $first, offset: $offset, mealPeriod: $mealPeriod}) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        __typename
      }
      edges {
        node {
          ...ReviewsNodes
        }
      }
      totalCount
    }
  }
}
    fragment ReviewsNodes on Review2 {
  __typename
  ... on Review {
    handleName
    userComment
    restaurantComment
    userPostDate
    memberHash
    mealPeriod
    planName
    rating {
      totalValue
      food
      service
      atmosphere
      costPerformance
    }
    useScene
  }
  ... on LyReview {
    handleName
    userComment
    restaurantComment
    userPostDate
    totalValue: rating
  }
}`) as unknown as TypedDocumentString<GetReviewsQuery, GetReviewsQueryVariables>;
export const SearchCoursesDocument = new TypedDocumentString(`
    query SearchCourses($restaurantId: RestaurantId!, $searchInput: SearchInput!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    name
    ...PlanRestaurantAllowDiscountOnReservation
    searchSeatOnlyPlans(input: $searchInput) {
      edges {
        node {
          ...PlanSelectionInfo
          ...PlanAttributes
          seats {
            ...SeatAttributes
          }
          searchPrice(input: $searchInput) {
            hasInventory
            fixedPoints
          }
        }
      }
    }
    searchCourses(input: $searchInput) {
      edges {
        node {
          ...RestaurantSearchCourse
        }
      }
    }
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment RestaurantSearchCourse on Course {
  ...CourseSelectionInfo
  searchPlans(input: $searchInput) {
    edges {
      seats {
        ...SeatAttributes
      }
      node {
        ...PlanSelectionInfo
        ...PlanAttributes
        searchPrice(input: $searchInput) {
          ...PlanSearchPrice
        }
      }
    }
  }
}
fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`) as unknown as TypedDocumentString<SearchCoursesQuery, SearchCoursesQueryVariables>;
export const GetInventoryOnlySeatDocument = new TypedDocumentString(`
    query getInventoryOnlySeat($restaurantId: RestaurantId!, $visitorsCount: Int!, $visitDate: Date!, $visitTime: HourMinute!) {
  restaurant(restaurantId: $restaurantId) {
    inventory(
      visitDate: $visitDate
      visitorsCount: $visitorsCount
      visitTime: $visitTime
    ) {
      seatOnlyPlans {
        plan {
          ...PlanSelectionInfo
        }
      }
    }
  }
}
    fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`) as unknown as TypedDocumentString<GetInventoryOnlySeatQuery, GetInventoryOnlySeatQueryVariables>;
export const GetRestaurantArticleDocument = new TypedDocumentString(`
    query getRestaurantArticle($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    kiwaminoArticles {
      ...KiwaminoArticleInfo
    }
  }
}
    fragment KiwaminoArticleInfo on KiwaminoArticle {
  articleId
  title
  content
  postedAt
  thumbnailUrl
}`) as unknown as TypedDocumentString<GetRestaurantArticleQuery, GetRestaurantArticleQueryVariables>;
export const GetRestaurantSummaryDocument = new TypedDocumentString(`
    query getRestaurantSummary($restaurantId: RestaurantId!, $isIkyu: Boolean!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    ...RestaurantMetadata
    ...RestaurantArea
    ...RestaurantIntroduction
    ...RestaurantHighlights
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...RestaurantAnnouncement
    ...RestaurantTwoWeeksCalendar
    ...RestaurantCalendar
    ...RestaurantSummary
    ...PlanRestaurantNotes
    ...RestaurantAccesses
    ...RestaurantGuideTitle
    ...RestaurantRelatedTags
    ...RestaurantNearbySpots
    ...RestaurantNearbyRestaurants
    ...RestaurantFaqFragment
    ...RestaurantGuidePhotos
    ...SupremeRestaurant @include(if: $isIkyu)
    ...RestaurantPriceRange
    ...PlanRestaurantAllowDiscountOnReservation
    ...RestaurantBreadcrumbs
    ...ShareRestaurantButton
    ...RestaurantMenusFragment
    discountCoupons {
      ...Coupon
    }
    searchCourses(input: {}) {
      nodes {
        searchPlans(input: {}) {
          nodes {
            timesale {
              visibleLabel
            }
          }
        }
      }
    }
    ikyuDaySetting: activePointRewardSetting(programId: "3") {
      reservablePeriod {
        from
        to
      }
    }
  }
  now
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}
fragment RestaurantArea on Restaurant {
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
}
fragment RestaurantBreadcrumbs on Restaurant {
  name
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
fragment RestaurantTwoWeeksCalendar on Restaurant {
  phoneNumber
}
fragment RestaurantGenre on Restaurant {
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
fragment PlanRestaurantNotes on Restaurant {
  notes
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
fragment RestaurantCalendar on Restaurant {
  phoneNumber
}
fragment Coupon on DiscountCoupon {
  code
  name
  discountAmount
  minimumReservationAmount
  viewerAcquired
  reservablePeriod {
    from
    to
  }
  visitablePeriod {
    from
    to
  }
  usableMemberCount
}
fragment RestaurantAnnouncement on Restaurant {
  announcement {
    title
    content
    url
  }
}
fragment RestaurantGuideTitle on Restaurant {
  restaurantId
  name
  isCasual
  area {
    largeCode
  }
  genre {
    displayName
  }
}
fragment RestaurantNearbySpots on Restaurant {
  nearbySpots {
    spotId
    name
    type
    minimumArea {
      code
      parent {
        code
        parent {
          key
        }
      }
    }
  }
}
fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantSummary on Restaurant {
  name
  genre {
    displayName
  }
  ...RestaurantGenre
  isCasual
  paypayAvailable
  pointAvailable
  ...RestaurantArea
  supportsInventoryNotification
  catchphraseText
  introductionText
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
  ...RestaurantRating
  areaReviewRanking {
    ...RestaurantAreaReviewRankingItem
  }
  isReviewHidden
}
fragment RestaurantRelatedTags on Restaurant {
  relatedTags {
    type
    tagId
    name
  }
}
fragment SupremeRestaurant on Restaurant {
  isSupreme
}
fragment RestaurantMenusFragment on Restaurant {
  menus {
    course {
      ...RestaurantMenuRootFragment
    }
    aLaCarte {
      ...RestaurantMenuRootFragment
    }
    drink {
      ...RestaurantMenuRootFragment
    }
  }
}
fragment RestaurantMenuRootFragment on RestaurantMenuRoot {
  sections {
    title
    description
    items {
      name
      description
      price
      isRecommended
    }
  }
  updatedDate
}
fragment RestaurantAreaReviewRankingItem on RestaurantAreaReviewRanking {
  rank
  total
  minimumArea {
    code
    name
    parent {
      code
      parent {
        key
      }
    }
  }
}
fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}
fragment RestaurantNearbyRestaurants on Restaurant {
  nearbyRestaurants(first: 5) {
    ...RestaurantRecommendCard
  }
}
fragment RestaurantFaqFragment on Restaurant {
  openingHoursText
}
fragment RestaurantHighlights on Restaurant {
  restaurantId
  highlights {
    title
    description
    imageAlt
    image {
      url
    }
  }
}
fragment RestaurantIntroduction on Restaurant {
  catchphraseText
  introductionText
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment RestaurantGuidePhotos on Restaurant {
  restaurantId
  name
  images {
    url
    name
    category
  }
}
fragment ShareRestaurantButton on Restaurant {
  restaurantId
  name
  fullAddress
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetRestaurantSummaryQuery, GetRestaurantSummaryQueryVariables>;
export const GetViewerFavoriteAndSubscribeNotificationDocument = new TypedDocumentString(`
    query getViewerFavoriteAndSubscribeNotification($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    viewerFavorited
    viewerInventoryNotificationSubscribed
  }
  viewer {
    __typename
  }
}
    `) as unknown as TypedDocumentString<GetViewerFavoriteAndSubscribeNotificationQuery, GetViewerFavoriteAndSubscribeNotificationQueryVariables>;
export const GuideMenuCoursesDocument = new TypedDocumentString(`
    query GuideMenuCourses($restaurantId: RestaurantId!, $searchInput: SearchInput = {}) {
  restaurant(restaurantId: $restaurantId) {
    searchCourses(input: $searchInput) {
      edges {
        node {
          ...RestaurantSearchCourse
        }
      }
    }
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment RestaurantSearchCourse on Course {
  ...CourseSelectionInfo
  searchPlans(input: $searchInput) {
    edges {
      seats {
        ...SeatAttributes
      }
      node {
        ...PlanSelectionInfo
        ...PlanAttributes
        searchPrice(input: $searchInput) {
          ...PlanSearchPrice
        }
      }
    }
  }
}
fragment PlanAttributes on Plan {
  attributes
  mealPeriod
  freeFlow3hours: isInSpecial(specialId: "100426")
  tags(tagIds: ["3239", "3533"]) {
    tagId
    name
    type
  }
}
fragment SeatAttributes on Seat {
  smokingAllowed
  attributes
  seatTypeLabel
  childUse
}
fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}`) as unknown as TypedDocumentString<GuideMenuCoursesQuery, GuideMenuCoursesQueryVariables>;
export const GetRecommendRestaurantsDocument = new TypedDocumentString(`
    query GetRecommendRestaurants($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    recommendRestaurants(first: 5) {
      ...RestaurantRecommendCard
    }
  }
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}`) as unknown as TypedDocumentString<GetRecommendRestaurantsQuery, GetRecommendRestaurantsQueryVariables>;
export const SubscribeInventoryNotificationDocument = new TypedDocumentString(`
    mutation subscribeInventoryNotification($restaurantId: RestaurantId!) {
  subscribeInventoryNotification(restaurantId: $restaurantId)
}
    `) as unknown as TypedDocumentString<SubscribeInventoryNotificationMutation, SubscribeInventoryNotificationMutationVariables>;
export const UnsubscribeInventoryNotificationDocument = new TypedDocumentString(`
    mutation unsubscribeInventoryNotification($restaurantId: RestaurantId!) {
  unsubscribeInventoryNotification(restaurantId: $restaurantId)
}
    `) as unknown as TypedDocumentString<UnsubscribeInventoryNotificationMutation, UnsubscribeInventoryNotificationMutationVariables>;
export const CheckPlanExistenceDocument = new TypedDocumentString(`
    query CheckPlanExistence($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      planId
    }
  }
}
    `) as unknown as TypedDocumentString<CheckPlanExistenceQuery, CheckPlanExistenceQueryVariables>;
export const GetPlanDetailDocument = new TypedDocumentString(`
    query GetPlanDetail($restaurantId: RestaurantId!, $planId: PlanId!, $searchInput: SearchInput!) {
  restaurant(restaurantId: $restaurantId) {
    name
    isCasual
    supportsInventoryNotification
    ...RestaurantGenre
    reservableVisitorsCounts(input: {})
    ...RestaurantMetadata
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...RestaurantArea
    ...RestaurantAccesses
    ...RestaurantCalendar
    ...PlanRestaurantNotes
    ...RestaurantRating
    ...PlanRestaurantAllowDiscountOnReservation
    discountCoupons {
      ...Coupon
    }
    plan(planId: $planId) {
      ...PlanDetailMetadata
      ...PlanSelectionInfo
      course {
        ...CourseSelectionInfo
      }
      searchPrice(input: $searchInput) {
        ...PlanSearchPrice
      }
    }
    ...ShareRestaurantButton
  }
}
    fragment RestaurantArea on Restaurant {
  area {
    largeName
    largeCode
    mediumName
    mediumKey
    mediumCode
    smallName
    smallCode
    minimums {
      code
      name
    }
  }
}
fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment RestaurantGenre on Restaurant {
  genre {
    displayName
    major {
      code
      name
    }
    minor {
      code
      name
    }
  }
}
fragment PlanRestaurantNotes on Restaurant {
  notes
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCalendar on Restaurant {
  phoneNumber
}
fragment Coupon on DiscountCoupon {
  code
  name
  discountAmount
  minimumReservationAmount
  viewerAcquired
  reservablePeriod {
    from
    to
  }
  visitablePeriod {
    from
    to
  }
  usableMemberCount
}
fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment PlanDetailMetadata on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
    images {
      url
    }
  }
  mealPeriod
  description
  restaurant {
    name
    status
    isTest
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}
fragment ShareRestaurantButton on Restaurant {
  restaurantId
  name
  fullAddress
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetPlanDetailQuery, GetPlanDetailQueryVariables>;
export const GetPlanReservableVisitorsCountsDocument = new TypedDocumentString(`
    query GetPlanReservableVisitorsCounts($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    reservableVisitorsCounts(input: {planIds: [$planId]})
  }
}
    `) as unknown as TypedDocumentString<GetPlanReservableVisitorsCountsQuery, GetPlanReservableVisitorsCountsQueryVariables>;
export const GetPlanDetailInventoryCalendarDocument = new TypedDocumentString(`
    query GetPlanDetailInventoryCalendar($restaurantId: RestaurantId!, $planId: PlanId!, $to: Date!, $visitorsCount: Int!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      inventoryCalendar(to: $to, visitorsCount: $visitorsCount) {
        inventory {
          ...PlanDetailInventoryPlanItem
        }
      }
    }
  }
}
    fragment PlanDetailInventoryPlanItem on ReservableTime {
  visitTime
  price
  discountRatePercent
  pointRatePercent
}`) as unknown as TypedDocumentString<GetPlanDetailInventoryCalendarQuery, GetPlanDetailInventoryCalendarQueryVariables>;
export const GetPlanDetailInventoryPlanDocument = new TypedDocumentString(`
    query GetPlanDetailInventoryPlan($restaurantId: RestaurantId!, $planId: PlanId!, $visitorsCount: Int!, $visitDate: Date!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      inventory(visitDate: $visitDate, visitorsCount: $visitorsCount) {
        ...PlanDetailInventoryPlanItem
      }
    }
  }
}
    fragment PlanDetailInventoryPlanItem on ReservableTime {
  visitTime
  price
  discountRatePercent
  pointRatePercent
}`) as unknown as TypedDocumentString<GetPlanDetailInventoryPlanQuery, GetPlanDetailInventoryPlanQueryVariables>;
export const DeletePaymentCardDocument = new TypedDocumentString(`
    mutation deletePaymentCard($cardId: PaymentCardId!) {
  deletePaymentCard(cardId: $cardId) {
    __typename
    ... on DeletePaymentCardErrorUndeletable {
      deletableDateFrom
    }
  }
}
    `) as unknown as TypedDocumentString<DeletePaymentCardMutation, DeletePaymentCardMutationVariables>;
export const ReserveDocument = new TypedDocumentString(`
    mutation reserve($input: ReserveInput!) {
  reserve(input: $input) {
    __typename
    ... on ReserveOk {
      ...ReserveSuccess
    }
    ... on ReserveError {
      messages
    }
  }
}
    fragment ReserveSuccess on ReserveOk {
  reservation {
    reservationId
    restaurant {
      name
    }
    visitDate
    visitTime
    visitorsCount
  }
  firstTimeReserve
  affiliateSiteConversionTag
}`) as unknown as TypedDocumentString<ReserveMutation, ReserveMutationVariables>;
export const GetReserveInputDocument = new TypedDocumentString(`
    query GetReserveInput($restaurantId: RestaurantId!, $planId: PlanId!, $visitDate: Date!, $visitTime: HourMinute!, $visitorsCount: Int!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      reserveInfo(
        input: {visitDate: $visitDate, visitTime: $visitTime, visitorsCount: $visitorsCount}
      ) {
        __typename
        ... on ReserveInfo {
          ...PlanReserveInfo
        }
        ... on ReserveInfoError {
          messages
        }
        ... on ReserveInfoRedirect {
          redirect
        }
      }
    }
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
  }
  viewer {
    ...ReserveInfoViewer
  }
}
    fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment CancelPolicyPolicies on CancelPolicyStructured {
  policies {
    __typename
    appliesToVisitorDecrement
    charge {
      __typename
      ... on CancelPolicyChargeRate {
        rate
      }
      ... on CancelPolicyChargeFee {
        fee
      }
    }
    ... on CancelPolicyItemDaysBefore {
      days
      time
    }
  }
}
fragment InventorySeats on ReservableTime {
  seats {
    seatId
    type
    seatTypeLabel
    attributes
    smokingAllowed
    seatTypeDescription
    description
    bookingType
    capacity
    childUse
    image {
      url
      name
      category
    }
    charge {
      __typename
      ... on SeatChargePerTable {
        price
      }
      ... on SeatChargePerPerson {
        price
      }
    }
    ...SeatForLabel
  }
}
fragment MemberCards on ReserveInfoMember {
  cards {
    cardId
    maskedNumber
    goodThru
    holderName
    brand
    isPrimary
  }
}
fragment MemberDiscountCoupons on ReserveInfoMember {
  discountCoupons {
    code
    name
    discountAmount
    minimumReservationAmount
    viewerAcquired
    reservablePeriod {
      from
      to
    }
    visitablePeriod {
      from
      to
    }
    usableMemberCount
  }
}
fragment PlanCancelPolicy on Plan {
  cancelPolicy: cancelPolicy3 {
    __typename
    ... on CancelPolicyStructured {
      cancelPolicyId
      version
      note
      ...CancelPolicyPolicies
    }
    ... on CancelPolicyText {
      text
    }
  }
}
fragment PlanReserveInfo on ReserveInfo {
  visitDate
  visitTime
  visitorsCount
  discountCouponValidationHash
  duplicateReserveCount
  toyotaFinanceMaintenance
  gmoMaintenance
  paypayMaintenanceMessage
  paypayNoticeMessage
  ...ReserveInfoMember
  ...ReserveInfoPlan
  ...ReserveInfoChildMenus
  ...ReserveInfoOptionMenus
  point {
    seatOnlyFixedPoint
    courseFixedPoint
    rate
  }
  affiliateSiteForm {
    title
    notes
  }
  inventory {
    visitTime
    price
    discountRatePercent
    ...InventorySeats
  }
}
fragment PlanRestaurant on Plan {
  restaurant {
    name
    paypayAvailable
    pointAvailable
    cardPaymentAvailable
    notes
    noncancelableDays
  }
}
fragment ReserveInfoChildMenus on ReserveInfo {
  childMenus {
    childMenuId
    name
    price
    image {
      url
      name
    }
    description
    maxOrderPerReservation
  }
}
fragment ReserveInfoMember on ReserveInfo {
  member {
    __typename
    name
    nameKana
    phoneNumber
    email
    ...MemberDiscountCoupons
    ...MemberCards
    paypay {
      __typename
      ... on PaypayAvailable {
        balance
      }
      ... on PaypayUnavailable {
        cause
      }
      __typename
    }
    totalPoint
    usablePoint
    mailMagazineSubscription {
      restaurant
      point
      present
    }
  }
}
fragment ReserveInfoOptionMenus on ReserveInfo {
  optionMenus {
    availability
    optionMenu {
      optionMenuId
      name
      price
      image {
        url
        name
      }
      description
      maxOrderPerReservation
    }
  }
}
fragment ReserveInfoPlan on ReserveInfo {
  plan {
    planId
    version
    additionalContents
    restrictions
    paymentType
    notes
    isRequestReservation
    description
    isSeatOnly
    isCancelGuard
    price
    ...PlanRestaurant
    ...PlanCancelPolicy
    timesale {
      visibleLabel
    }
    course {
      name
      menuText
      images {
        url
        name
      }
    }
  }
}
fragment ReserveInfoViewer on Viewer {
  name
  phoneNumberCertified
  loginSite
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}
fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`) as unknown as TypedDocumentString<GetReserveInputQuery, GetReserveInputQueryVariables>;
export const ValidateDiscountCouponDocument = new TypedDocumentString(`
    query ValidateDiscountCoupon($input: DiscountCouponValidationInput!) {
  validateDiscountCoupon(input: $input) {
    __typename
    ... on DiscountCoupon {
      code
      name
      discountAmount
      minimumReservationAmount
      viewerAcquired
      reservablePeriod {
        from
        to
      }
      visitablePeriod {
        from
        to
      }
      usableMemberCount
    }
    ... on DiscountCouponValidationError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<ValidateDiscountCouponQuery, ValidateDiscountCouponQueryVariables>;
export const GetSpecialFeatureDocument = new TypedDocumentString(`
    query GetSpecialFeature($specialFeatureId: SpecialFeatureId!) {
  specialFeature(specialFeatureId: $specialFeatureId) {
    name
  }
}
    `) as unknown as TypedDocumentString<GetSpecialFeatureQuery, GetSpecialFeatureQueryVariables>;
export const GetTimesaleDocument = new TypedDocumentString(`
    query GetTimesale($timesaleId: TimesaleId!, $device: Device!) {
  timesale(timesaleId: $timesaleId) {
    timesaleId
    name
    reservablePeriod {
      from
      to
    }
    imageUrl(device: $device)
  }
}
    `) as unknown as TypedDocumentString<GetTimesaleQuery, GetTimesaleQueryVariables>;
export const GetTopRecommendRestaurantsDocument = new TypedDocumentString(`
    query GetTopRecommendRestaurants($restaurantIds: [RestaurantId!]!) {
  restaurants(restaurantIds: $restaurantIds) {
    ...RestaurantRecommendCard
  }
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}`) as unknown as TypedDocumentString<GetTopRecommendRestaurantsQuery, GetTopRecommendRestaurantsQueryVariables>;
export const GetPopularityRestaurantsDocument = new TypedDocumentString(`
    query GetPopularityRestaurants($input: SearchRestaurantsInput!) {
  searchRestaurants(input: $input, first: 10) {
    edges {
      node {
        ...RestaurantRecommendCard
      }
    }
  }
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}`) as unknown as TypedDocumentString<GetPopularityRestaurantsQuery, GetPopularityRestaurantsQueryVariables>;
export const ViewerQueryDocument = new TypedDocumentString(`
    query ViewerQuery {
  viewer: viewer2 {
    __typename
    ... on Member {
      loginSite
      name
      point
      rank
      isVicSalonMember
      phoneNumberCertified
      pointVisible
    }
    ... on YahooMember {
      name
      isPremium
    }
  }
}
    `) as unknown as TypedDocumentString<ViewerQueryQuery, ViewerQueryQueryVariables>;
export const ValidateShiftJisDocument = new TypedDocumentString(`
    query ValidateShiftJis($input: String!) {
  shiftJis(input: $input) {
    __typename
    ... on ShiftJisOk {
      bytesLen
    }
    ... on ShiftJisError {
      unmappableCharacter
    }
  }
}
    `) as unknown as TypedDocumentString<ValidateShiftJisQuery, ValidateShiftJisQueryVariables>;
export const GuideDetailQueryDocument = new TypedDocumentString(`
    query GuideDetailQuery($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...RestaurantMetadata
  }
}
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GuideDetailQueryQuery, GuideDetailQueryQueryVariables>;
export const GuidePhotosQueryDocument = new TypedDocumentString(`
    query GuidePhotosQuery($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    restaurantId
    ...RestaurantGuidePhotos
    ...RestaurantMetadata
  }
}
    fragment RestaurantMetadata on Restaurant {
  name
  nameAlt
  nameKana
  seoName {
    restaurant
    accommodation
  }
  accommodation {
    name
  }
  area {
    displayName
  }
  genre {
    displayName
  }
  catchphraseText
  introductionText
  description
  status
  isTest
  images {
    url
  }
}
fragment RestaurantGuidePhotos on Restaurant {
  restaurantId
  name
  images {
    url
    name
    category
  }
}`) as unknown as TypedDocumentString<GuidePhotosQueryQuery, GuidePhotosQueryQueryVariables>;
export const RestaurantPolicyInfoDocument = new TypedDocumentString(`
    query RestaurantPolicyInfo($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    name
    fullAddress
    phoneNumber
  }
}
    `) as unknown as TypedDocumentString<RestaurantPolicyInfoQuery, RestaurantPolicyInfoQueryVariables>;
export const SearchRestaurantsDocument = new TypedDocumentString(`
    query SearchRestaurants($input: SearchRestaurantsInput!, $first: Int!, $offset: Int!, $searchInput: SearchInput!, $visitDate: Date!, $visitorsCount: Int!, $withPickupReview: Boolean = false, $withPlans: Boolean = false, $withPlanInventory: Boolean = false, $withMenuText: Boolean = false) {
  searchRestaurants(input: $input, first: $first, offset: $offset) {
    totalCount
    interpretation {
      ...ExtendedSearchInterpretation
    }
    edges {
      node {
        ...RestaurantCard
      }
      plans @include(if: $withPlans) {
        ...PlanLine
      }
      timesaleLabel
    }
  }
}
    fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment PlanSearchPrice on SearchPriceResult {
  bestPrice
  priceVaried
  hasInventory
  discountPercent
  pointRatePercent
  fixedPoints
}
fragment RestaurantPriceRange on Restaurant {
  lunchReferencePriceRange {
    lower
    upper
  }
  dinnerReferencePriceRange {
    lower
    upper
  }
}
fragment RestaurantPickupReview on Restaurant {
  restaurantId
  pickupReview {
    handleName
    userComment
  }
  isReviewHidden
}
fragment PlanLine on Plan {
  planId
  isSeatOnly
  mealPeriod
  course {
    name
  }
  listPrice
  additionalContents
  restrictions
  paymentType
  memberLimitType
  isRequestReservation
  isCancelGuard
  timesale {
    visibleLabel
  }
  ...MenuText @include(if: $withMenuText)
  searchPrice(input: $searchInput) {
    ...PlanSearchPrice
  }
  inventory(visitDate: $visitDate, visitorsCount: $visitorsCount) @include(if: $withPlanInventory) {
    __typename
  }
}
fragment MenuText on Plan {
  description
  course {
    menuText
  }
}
fragment ExtendedSearchInterpretation on ExtendedSearchInterpretation {
  __typename
  ... on ExtendedSearchInterpretationSpot {
    name
    radius
  }
  ... on ExtendedSearchInterpretationLocation {
    name
    radius
  }
}
fragment ReviewSummary on Restaurant {
  restaurantId
  isReviewHidden
  rating {
    totalCount
    totalValue
  }
}
fragment RestaurantCardImage on Restaurant {
  restaurantId
  images {
    url
    name
  }
}
fragment RestaurantCard on Restaurant {
  restaurantId
  name
  isCasual
  genre {
    displayName
  }
  area {
    displayName
  }
  description
  ...PlanRestaurantAllowDiscountOnReservation
  ...RestaurantCardImage
  ...RestaurantIkyuDaySetting
  ...ReviewSummary
  ...RestaurantAccesses
  ...RestaurantPriceRange
  ...RestaurantPhoneNumber
  ...RestaurantPickupReview @include(if: $withPickupReview)
}
fragment RestaurantPhoneNumber on Restaurant {
  phoneNumber
}
fragment RestaurantIkyuDaySetting on Restaurant {
  restaurantId
  ikyuDaySetting: activePointRewardSetting(programId: "3") {
    reservablePeriod {
      from
      to
    }
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<SearchRestaurantsQuery, SearchRestaurantsQueryVariables>;
export const SearchNeighborhoodRestaurantsDocument = new TypedDocumentString(`
    query SearchNeighborhoodRestaurants($input: SearchRestaurantsInput!, $first: Int!) {
  searchRestaurants(input: $input, first: $first) {
    totalCount
    edges {
      node {
        ...RestaurantRecommendCard
      }
    }
  }
}
    fragment RestaurantRecommendCard on Restaurant {
  restaurantId
  name
  area {
    displayName
  }
  images: images2(first: 1) {
    url
  }
  rating {
    totalValue
    totalCount
  }
}`) as unknown as TypedDocumentString<SearchNeighborhoodRestaurantsQuery, SearchNeighborhoodRestaurantsQueryVariables>;
export const SearchRestaurantIdsDocument = new TypedDocumentString(`
    query SearchRestaurantIds($input: SearchRestaurantsInput!, $first: Int!) {
  searchRestaurants(input: $input, first: $first) {
    totalCount
    edges {
      node {
        restaurantId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchRestaurantIdsQuery, SearchRestaurantIdsQueryVariables>;
export const GetNowDocument = new TypedDocumentString(`
    query GetNow {
  now
}
    `) as unknown as TypedDocumentString<GetNowQuery, GetNowQueryVariables>;
export const GetCalendarsDocument = new TypedDocumentString(`
    query GetCalendars($from: Date!, $to: Date!) {
  calendar(from: $from, to: $to) {
    date
    dayOfWeek
    holiday
  }
}
    `) as unknown as TypedDocumentString<GetCalendarsQuery, GetCalendarsQueryVariables>;
export const GetPlanInventorySeatsDocument = new TypedDocumentString(`
    query GetPlanInventorySeats($restaurantId: RestaurantId!, $planId: PlanId!, $visitorsCount: Int!, $visitDate: Date!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      inventory(visitorsCount: $visitorsCount, visitDate: $visitDate) {
        visitTime
        seats {
          ...PlanSeat
        }
      }
    }
  }
}
    fragment PlanSeat on Seat {
  seatId
  seatTypeDescription
  image {
    url
    name
  }
  charge {
    __typename
    ... on SeatChargePerTable {
      price
    }
    ... on SeatChargePerPerson {
      price
    }
  }
  ...SeatForLabel
}
fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`) as unknown as TypedDocumentString<GetPlanInventorySeatsQuery, GetPlanInventorySeatsQueryVariables>;
export const GetPlanSeatsDocument = new TypedDocumentString(`
    query GetPlanSeats($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    plan(planId: $planId) {
      seats {
        ...PlanSeat
      }
    }
  }
}
    fragment PlanSeat on Seat {
  seatId
  seatTypeDescription
  image {
    url
    name
  }
  charge {
    __typename
    ... on SeatChargePerTable {
      price
    }
    ... on SeatChargePerPerson {
      price
    }
  }
  ...SeatForLabel
}
fragment SeatForLabel on Seat {
  seatTypeLabel
  smokingAllowed
  attributes
}`) as unknown as TypedDocumentString<GetPlanSeatsQuery, GetPlanSeatsQueryVariables>;
export const GetRestaurantCalendarContextDocument = new TypedDocumentString(`
    query GetRestaurantCalendarContext($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    ...RestaurantCalendar
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...PlanRestaurantNotes
    ...PlanRestaurantAllowDiscountOnReservation
  }
}
    fragment PlanRestaurantNotes on Restaurant {
  notes
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantCalendar on Restaurant {
  phoneNumber
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetRestaurantCalendarContextQuery, GetRestaurantCalendarContextQueryVariables>;
export const GetRestaurantPlanDetailContextDocument = new TypedDocumentString(`
    query GetRestaurantPlanDetailContext($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...PlanRestaurantNotes
    ...PlanRestaurantAllowDiscountOnReservation
  }
}
    fragment PlanRestaurantNotes on Restaurant {
  notes
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetRestaurantPlanDetailContextQuery, GetRestaurantPlanDetailContextQueryVariables>;
export const GetRestaurantPlanContextDocument = new TypedDocumentString(`
    query GetRestaurantPlanContext($restaurantId: RestaurantId!, $planId: PlanId!) {
  restaurant(restaurantId: $restaurantId) {
    ...RestaurantCalendar
    ...RestaurantMainInfoFragment
    ...RestaurantSubInfoFragment
    ...PlanRestaurantNotes
    ...PlanRestaurantAllowDiscountOnReservation
    plan(planId: $planId) {
      ...PlanSelectionInfo
      course {
        ...CourseSelectionInfo
      }
    }
  }
}
    fragment CourseSelectionInfo on Course {
  courseId
  name
  type {
    __typename
  }
  menuText
  restaurant {
    name
  }
  images {
    url
    name
  }
}
fragment PlanRestaurantNotes on Restaurant {
  notes
}
fragment PlanRestaurantAllowDiscountOnReservation on Restaurant {
  pointAvailable
}
fragment PlanSelectionInfo on Plan {
  planId
  additionalContents
  restrictions
  description
  mealPeriod
  timesale {
    reservablePeriod {
      from
      to
    }
    visibleLabel
  }
  price
  childMenus {
    ...PlanDetailChildMenuItem
  }
  optionMenus {
    ...PlanDetailOptionItem
  }
  course {
    name
  }
  listPrice
  ...PlanListPriceItem
  isRequestReservation
  isCancelGuard
  memberLimitType
  paymentType
  cancelPolicy: cancelPolicy2 {
    ...RestaurantCancelPolicyItem
  }
  notes
  attributes
  ...SharePlanFragment
  isSeatOnly
}
fragment PlanDetailChildMenuItem on ChildMenu {
  childMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  image {
    url
    name
    category
  }
  description
  __typename
}
fragment PlanDetailOptionItem on OptionMenu {
  optionMenuId
  name
  price
  closeDays
  visitingPeriodFrom
  visitingPeriodTo
  description
  image {
    url
    name
  }
  __typename
}
fragment PlanListPriceItem on Plan {
  listPrice
  listPriceIsReference
  listPriceComponents {
    food
    drink
    cake
    bouquet
    present
    charge
    others
  }
}
fragment RestaurantCalendar on Restaurant {
  phoneNumber
}
fragment RestaurantAddress on Restaurant {
  restaurantId
  prefecture
  area {
    smallName
  }
  address
  latitude
  longitude
  accommodation {
    accommodationId
    name
  }
}
fragment RestaurantPaymentInfo on Restaurant {
  paymentMethodText
  cardPaymentForDisplay {
    availability
    note
  }
  qrCodePaymentAvailability {
    __typename
    ... on QrCodePaymentAvailabilityAvailable {
      availableQrCodePayments
    }
  }
}
fragment RestaurantCancelPolicyItem on RestaurantCancelPolicy {
  __typename
  ... on CancelPolicy {
    cancelPolicyId
    version
    note
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
  ... on CancelPolicyText {
    text
  }
}
fragment RestaurantMainInfoFragment on Restaurant {
  phoneNumber
  openingHoursText
  regularHolidayText
  ...RestaurantPaymentInfo
  serviceFeeText
  tableChargeText
  cancelPolicy {
    ...RestaurantCancelPolicyItem
  }
  dressCodeText
  ...RestaurantInfoNameFragment
  ...RestaurantAddress
  ...RestaurantAccesses
}
fragment RestaurantSubInfoFragment on Restaurant {
  seatsText
  smoking {
    policy
    note
  }
  pet {
    allowed
    note
  }
  childAvailability {
    ...ChildAvailabilityItem
  }
  wheelchairAccessibility
  parking {
    availability
    note
  }
  notes
  hygieneControlText
}
fragment RestaurantInfoNameFragment on Restaurant {
  name
  nameAlt
  accommodation {
    accommodationId
    name
  }
}
fragment ChildAvailabilityItem on ChildAvailability {
  ... on ChildAvailable {
    note
    ageLimit
    chairAvailability
    menuAvailability
    seatLimit
    timeAvailability
    __typename
  }
  ... on ChildUnavailable {
    note
    __typename
  }
}
fragment SharePlanFragment on Plan {
  planId
  additionalContents
  restrictions
  course {
    name
  }
  restaurant {
    restaurantId
    name
  }
}
fragment RestaurantAccesses on Restaurant {
  restaurantId
  accesses {
    __typename
    ... on RestaurantAccessTrain {
      line
      station
      note
    }
    ... on RestaurantAccessCar {
      note
    }
  }
  area {
    displayName
    mediumName
  }
  parking {
    availability
    note
  }
}`) as unknown as TypedDocumentString<GetRestaurantPlanContextQuery, GetRestaurantPlanContextQueryVariables>;
export const GetRestaurantRatingDocument = new TypedDocumentString(`
    query GetRestaurantRating($restaurantId: RestaurantId!) {
  restaurant(restaurantId: $restaurantId) {
    ...RestaurantRating
  }
}
    fragment RestaurantRating on Restaurant {
  restaurantId
  name
  isReviewHidden
  rating {
    totalCount
    totalValue
    food
    service
    atmosphere
    costPerformance
  }
}`) as unknown as TypedDocumentString<GetRestaurantRatingQuery, GetRestaurantRatingQueryVariables>;
export const GetCalendarDocument = new TypedDocumentString(`
    query GetCalendar($restaurantId: RestaurantId!, $input: ReservableCalendarInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableCalendar(input: $input) {
      ...ReservableCalendarItem
    }
  }
}
    fragment ReservableCalendarItem on ReservableCalendar {
  mealPeriod
  dates {
    calendarDate {
      date
      holiday
      dayOfWeek
    }
    reservable
    hasClosedInventory
    reservableVisitorsCount
  }
}`) as unknown as TypedDocumentString<GetCalendarQuery, GetCalendarQueryVariables>;
export const GetTimesDocument = new TypedDocumentString(`
    query GetTimes($restaurantId: RestaurantId!, $input: ReservableTimesInput!) {
  restaurant(restaurantId: $restaurantId) {
    reservableTimes(input: $input)
  }
}
    `) as unknown as TypedDocumentString<GetTimesQuery, GetTimesQueryVariables>;